/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 52);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap) {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

  return '/*# ' + data + ' */';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54).Buffer))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context = context || (this.$vnode && this.$vnode.ssrContext)
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    // inject component registration as beforeCreate hook
    var existing = options.beforeCreate
    options.beforeCreate = existing
      ? [].concat(existing, hook)
      : [hook]
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(193)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(170);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list, options);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove, transformResult;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    transformResult = options.transform(obj.css);
	    
	    if (transformResult) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = transformResult;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css. 
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = {
	"economie-finance-budget": {
		"title": "Financement / Budget",
		"main": false,
		"invisible": true,
		"image": "economie-finance",
		"fn": "→ [24] Rétablir les frontières nationales et sortir de l’espace Schengen (…)<br>→ [38] Supprimer la directive « détachement des travailleurs » (…) Mettre en place une taxe additionnelle sur l’embauche de salariés étrangers ;<br>→ [43] Remettre de l’ordre dans nos finances publiques par la fin des mauvaises dépenses publiques (notamment celles liées à l’immigration et à l’Union Européenne) et par la lutte contre la fraude sociale et fiscale (...).<br>→ [44] Abaisser les charges sociales des TPE-PME (...) en fusionnant l’ensemble des dispositifs d’allègement des charges sociales de manière dégressive (le CICE sera transformé en allègement de charges et entrera dans le dispositif) (…).<br>→ [47] Créer un taux intermédiaire d&#39;impôt sur les sociétés à 24 % (au lieu de 33 %) pour les PME (…).<br>→ [52] Fixer l’âge légal de la retraite à 60 ans avec 40 annuités de cotisations pourpercevoir une retraite pleine.<br>→ [59] Instaurer une Prime de Pouvoir d’Achat (PPA) à destination des bas revenus et des petites retraites (pour les revenus jusqu’à 1 500 euros par mois), financée par une Contribution Sociale sur les Importations de 3 % ;<br>→ [64] Défiscaliser les heures supplémentaires (...);<br>→ [71] Réaliser des économies en supprimant l’Aide Médicale d’État réservée aux clandestins (...);<br>→ [75] Baisser de 10 % l’impôt sur le revenu sur les trois premières tranches ;<br>→ [78] Lutter efficacement contre l’évasion fiscale (…) en s’attaquant aux paradis fiscaux et en créant une taxe sur l’activité réalisée en France par les grands groupes et les profits qui auraient été détournés ;<br>→ [121] Augmenter dès la 1ère année du mandat le budget de la Défense à 2 % du PIB puis tendre vers 3 % à l’horizon 2022 (…) ;<br>→ [134] « Pour maintenir, moderniser et sécuriser la filière nucléaire française, engager le Grand Carénage (...). Refuser la fermeture de la centrale de Fessenheim. »</p>\n<p><em>Ainsi que les mesures 4, 6, 13, 16, 20, 34, 37, 39, 41, 48, 54, 55, 56, 58, 60, 65, 67, 68, 74, 76, 82, 86, 88, 110, 128, 132, 133, 135, et 141.</em>",
		"fi": "La <a href=\"http://www.lefigaro.fr/conjoncture/2017/01/05/20002-20170105ARTFIG00115-tout-savoir-sur-la-defiscalisation-des-heures-sup.php\">défiscalisation des heures supplémentaires</a>, la <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">baisse de l&#39;impôt sur le revenu</a> et <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">celle de l&#39;impôt sur les sociétés</a> coûteraient 21,5 milliards d&#39;euros par an. Le CICE coûte <a href=\"http://www.latribune.fr/economie/france/le-cice-un-scandale-d-etat-587387.html\">20 milliards d&#39;euros</a> par an, même en le réorientant. Et la <a href=\"http://www.lefigaro.fr/conjoncture/2017/04/17/20002-20170417ARTFIG00054-la-prime-de-pouvoir-d-achat-de-marine-le-pen-couterait-15-milliards-d-euroset-serait.php\">Prime de Pouvoir d’Achat</a> coûterait plus 15 milliards d&#39;euros par an.</p>\n<p>Pour le budget de la défense, une hausse de plus de 7 milliards d&#39;euros est prévue pour la première année, pour monter à <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/05/01/comment-le-fn-deshabille-le-budget_1566602\">24 milliards d&#39;euros par an d&#39;ici 2022</a>. Le grand carénage nucléaire coûterait<a href=\"https://lenergeek.com/2016/05/27/edf-fait-le-point-sur-son-grand-carenage/\"> 51 milliards d&#39;euros</a> d&#39;après EDF, <a href=\"http://www.lemonde.fr/planete/article/2014/02/25/prolonger-les-reacteurs-nucleaires-hors-de-prix-selon-greenpeace_4373122_3244.html\">et jusqu&#39;à 261 milliards d&#39;euros d&#39;après Greenpeace</a>, soit entre 6 et 32 milliards d&#39;euros par an <a href=\"http://energie.lexpansion.com/energie-nucleaire/nucleaire-qu-est-ce-que-le-grand-carenage-_a-32-8015.html\">d&#39;ici 2025</a>. Ajoutons <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/05/01/comment-le-fn-deshabille-le-budget_1566602\">3-4 milliards d&#39;euros</a> de coût par an pour les prestations sociales. La réforme des retraites s&#39;élèverait à <a href=\"http://www.ifrap.org/retraite/le-pen-macron-ce-quils-preparent-en-matiere-de-retraites\">17 à 18 milliards d&#39;euros</a>, soit 3,5 milliards d&#39;euros par an, et on peut ajouter <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/05/01/comment-le-fn-deshabille-le-budget_1566602\">2,5 milliards d&#39;euros</a> pour la hausse du budget de la recherche. Soit entre 95,5 et 122,5 milliards d&#39;euros de dépenses par an en fin de mandat (entre 78,5 et 105,5 milliards d&#39;euros la 1ère année).</p>\n<p>Pour compenser, le parti compte récupérer <a href=\"http://www.laprovence.com/actu/en-direct/4434095/le-pen-veut-economiser-15-milliards-annuels-sur-le-cout-de-limmigration.html\">15 milliards d&#39;euros par an en taxant les importations, et 4 milliards d&#39;euros par an avec la taxe sur l&#39;embauche de salariés étrangers et la fin du travail détaché</a>. Il compte aussi sur <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">12 milliards d&#39;euros</a> de recettes supplémentaires par an. D&#39;abord avec une baisse du « coût de l&#39;immigration », que le responsable du programme économique estime à <a href=\"http://www.cnewsmatin.fr/france/2017-05-06/marine-le-pen-presidente-de-la-republique-quelles-consequences-740787\">8 milliards d&#39;euros par an</a>, et Marine Le Pen à <a href=\"http://www.laprovence.com/actu/en-direct/4434095/le-pen-veut-economiser-15-milliards-annuels-sur-le-cout-de-limmigration.html\">15 milliards d&#39;euros par an</a>. Mais ces chiffres paraissent totalement fantaisistes. En 2016, le budget de l&#39;Aide Médicale d&#39;Etat était de <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/10/07/idee-recue-sur-les-migrants-3-6-ils-viennent-en-france-pour-se-faire-soigner_5009730_4355770.html\">744 millions d&#39;euros</a>, et celui de la <a href=\"http://www.immigration.interieur.gouv.fr/La-Direction-generale/Presentation\">mission ministérielle « immigration, asile, intégration »</a>, de <a href=\"http://www.forumrefugies.org/s-informer/actualites/asile-immigration-et-integration-un-budget-en-augmentation-pour-2016\">804,8 millions d&#39;euros</a>. Soit 1,5 milliard d&#39;euros. <a href=\"http://www.courrierinternational.com/article/2010/12/02/les-tres-bons-comptes-de-l-immigration\">Des économistes</a> montrent même que l&#39;immigration serait plutôt positive sur l&#39;économie, et aurait rapporté plus de 12 milliards d&#39;euros à l&#39;Etat français en 2009...</p>\n<p>Le parti compte aussi récupérer <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/02/28/chiffrage-le-front-national-pas-moins-flou-qu-emmanuel-macron_1551764\">9 milliards d&#39;euros par an</a> en arrêtant de financer l&#39;UE, mais l&#39;argent serait réaffecté ailleurs, et la sortie de Schengen coûterait <a href=\"http://www.strategie.gouv.fr/publications/consequences-economiques-dun-abandon-accords-de-schengen\">1 à 2 milliards d&#39;euros par an</a>. Le FN compte économiser <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/02/28/chiffrage-le-front-national-pas-moins-flou-qu-emmanuel-macron_1551764\">50 milliards d&#39;euros par an</a> avec la lutte contre la fraude sociale et fiscale, mais la première serait d&#39;à peine <a href=\"http://tempsreel.nouvelobs.com/en-direct/a-chaud/33790-eco-millions-euros-fraude-prestations-sociales-detectes.html\">300 millions d&#39;euros par an</a>, et pour la seconde, aucune mesure concrète n&#39;est avancée.<br>Marine Le Pen estime que la « réforme territoriale et institutionnelle » <a href=\"http://www.laprovence.com/actu/en-direct/4434095/le-pen-veut-economiser-15-milliards-annuels-sur-le-cout-de-limmigration.html\">rapporterait 10 milliards d&#39;euros par an</a>, mais à la différence de l&#39;Etat, <a href=\"http://www.atlantico.fr/decryptage/qui-supprimer-regions-departements-communautes-communes-agglomerations-match-coutefficacite-jean-luc-boeuf-955939.html\">les budgets des collectivités sont chaque année à l&#39;équilibre</a>. D&#39;après <a href=\"http://www.europe1.fr/economie/reduire-le-nombre-de-parlementaires-ca-rapporte-combien-2901347\">ces chiffres</a>, baisser le nombre de députés et sénateurs rapporterait à peine plus de 150 millions d&#39;euros par an. Marine Le Pen estime aussi à 5 milliards d&#39;euros par an le coût de la délinquance, chiffre invérifiable.</p>\n<p>Quoi qu&#39;il en soit, il resterait au minimum entre 64,5 et 91,5 milliards d&#39;euros de déficit par an en fin de mandat (entre 47,5 et 74,5 la première année), sans compter les plus petites dépenses, ni celles qui ne sont pas budgetées (énergies renouvelables, autres défiscalisations et exonérations, &quot;patriotisme économique&quot;...). Avec de telles estimations, et vu le contenu du programme économique du FN, imaginer que le déficit (3,3% en 2016) passerait <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">« de 4,5% en 2018 à 1,3% en 2022 »</a> semble donc totalement improbable. Sans compter le coût d&#39;une éventuelle sortie de l&#39;euro.",
		"aec": "Sur le quinquennat, une <strong><a href=\"https://www.lafaqdelavenirencommun.com/article/13/23/fr/quel-est-le-co%C3%BBt-du-programme-l_avenir-en-commun-.html\">augmentation du budget de l&#39;Etat de 173 milliards d&#39;euros est prévue, ainsi qu&#39;un plan d&#39;investissement de 100 milliards d&#39;euros</a></strong> sur 5 ans, soit 20 milliards d&#39;euros par an.</p>\n<p>Ces 173 milliards d’euros se répartiront de la façon suivante :</p>\n<ul>\n<li>33 milliards d&#39;euros pour l’urgence sociale.</li>\n<li>32 milliards d&#39;euros pour le financement des retraites.</li>\n<li>24 milliards d&#39;euros pour l&#39;éducation, la culture et la recherche.</li>\n<li>22 milliards d&#39;euros pour l’augmentation des salaires de la fonction publique, et pour  l&#39;<strong><a href=\"https://laec.fr/s30m1\">augmentation immédiate du smic net mensuel</a></strong>, pour le porter à 1 326 euros net par mois.</li>\n<li>21 milliards d&#39;euros pour renforcer les services à la personne.</li>\n<li>17 milliards d&#39;euros pour la jeunesse.</li>\n<li>10 milliards d&#39;euros pour la création de contrats coopératifs, et pour la sécurité.</li>\n<li>6 milliards d&#39;euros pour <strong><a href=\"https://laec.fr/s36m3\">refonder l&#39;impôt sur les sociétés</a></strong> et établir l&#39;égalité devant l&#39;impôt entre PME et grands groupes, et  <strong><a href=\"https://avenirencommun.fr/livret-produire-france/\">à court terme, le faire baisser à 25 %</a></strong>.</li>\n<li>5 milliards d&#39;euros pour la santé.</li>\n<li>3 milliards d&#39;euros pour <strong><a href=\"https://laec.fr/s11m2\">la Justice</a></strong> afin d’augmenter de 75% sur 5 ans le budget de ce ministère et de recruter du personnel.</li>\n</ul>\n<p>Concernant le plan d’investissement de 100 milliards d&#39;euros sur 5 ans, cette somme ira à <strong><a href=\"https://laec.fr/s18m1\">des projets écologiquement et socialement utiles</a></strong>, selon la répartition suivante :</p>\n<ul>\n<li>50 milliards d&#39;euros pour <a href=\"https://infogr.am/plan_dinvestissements\">l&#39;urgence écologique</a>.</li>\n<li>45 milliards d&#39;euros pour <a href=\"https://infogr.am/plan_dinvestissements\">l&#39;urgence sociale</a>.</li>\n<li>5 milliards d&#39;euros pour <a href=\"https://infogr.am/plan_dinvestissements\">les services publics</a>.</li>\n</ul>\n<p>Nous prévoyons 190 milliards d&#39;euros de recettes par an, dont 55 milliards d&#39;euros pour la relance économique, soit 135 milliards d&#39;euros par an si on ne compte pas les bénéfices prévus de cette relance. Cette somme se répartit de la manière suivante :</p>\n<ul>\n<li>38 milliards d&#39;euros avec la <strong><a href=\"https://laec.fr/s36m2\">suppression ou la réorganisation de certaines niches fiscales</a></strong> (<a href=\"http://www.lefigaro.fr/conjoncture/2015/10/07/20002-20151007ARTFIG00017-la-fin-de-la-prime-pour-l-emploi-va-reduire-le-cout-des-niches-fiscales.php\">estimation assez faible</a>).</li>\n<li>33 milliards d&#39;euros sur tout le programme fiscal : <strong><a href=\"https://laec.fr/s36m6\">TVA grand luxe</a></strong> (5 milliards d&#39;euros), <strong><a href=\"https://laec.fr/s36m4\">renforcement de l&#39;ISF</a></strong> et des <strong><a href=\"https://laec.fr/s36m5\">droits de succession</a></strong> (3 milliards d&#39;euros), imposition des hautes transactions immobilières (5 milliards d&#39;euros), <a href=\"https://laec.fr/s36m1\">réforme de l&#39;impôt sur les revenus</a>, <a href=\"https://laec.fr/s37m1\">impôt universel</a>, <a href=\"https://laec.fr/s18m3\">remise à plat des aides publiques et exonérations</a> aux entreprises, <a href=\"https://laec.fr/s37m2\">taxation de leurs bénéfices</a> (10 milliards d&#39;euros), et mise en place d&#39;une <strong><a href=\"https://laec.fr/s19m3\">taxe sur les transactions financières</a></strong> (5 milliards d&#39;euros).</li>\n<li>30 milliards d&#39;euros en luttant contre la fraude et l’évasion fiscale, <a href=\"https://www.challenges.fr/economie/l-evasion-fiscale-coute-a-la-france-entre-40-et-60-milliards-d-euros-par-an_26100\">estimation assez basse</a>, notamment en <a href=\"https://laec.fr/s37m5\">renforçant les moyens humains et techniques</a> de l&#39;administration fiscale et des douanes, en <strong><a href=\"https://laec.fr/s37m3\">interdisant aux banques françaises</a></strong> toute activité dans les paradis fiscaux, et en luttant <a href=\"https://laec.fr/s37m4\">au niveau international</a>.</li>\n<li><strong><a href=\"https://laec.fr/s18m2\">21 milliards d&#39;euros en supprimant le CICE</a></strong>.</li>\n<li>13 milliards d&#39;euros avec d&#39;autres recettes, comme les <a href=\"https://laec.fr/s17m2\">mesures anti-dumping d&#39;urgence sur les industries stratégiques et la hausse immédiate des droits de douane</a> pour les pays aux droits sociaux limités, le fait de <a href=\"https://laec.fr/s49m2\">cesser d&#39;appliquer la directive</a> sur le détachement de travailleurs, une <strong><a href=\"https://laec.fr/s42m2\">taxe kilométrique aux frontières</a></strong> ou une <strong><a href=\"https://laec.fr/s42m1\">contribution carbone</a></strong>.</li>\n</ul>\n<p>Le déficit budgétaire prévu est de <a href=\"http://www.latribune.fr/economie/presidentielle-2017/melenchon-ou-la-relance-par-l-investissement-public-684971.html\">3,5 % du PIB en moyenne sur le quinquennat, il est prévu qu&#39;il monte à 4,8% en 2018 mais finisse à 2,5 % du PIB en 2022</a>.",
		"badge": {
			"text": "Démagogique",
			"color": "red"
		},
		"parent": "economie-finance",
		"slug": "economie-finance-budget",
		"relatives": [
			{
				"title": "Financement / Budget",
				"link": "economie-finance-budget"
			},
			{
				"title": "Economie Générale",
				"link": "economie-finance-economie"
			},
			{
				"title": "Finance",
				"link": "economie-finance-finance"
			},
			{
				"title": "Protectionnisme",
				"link": "economie-finance-protectionnisme"
			}
		]
	},
	"economie-finance-economie": {
		"title": "Economie Générale",
		"main": false,
		"invisible": true,
		"image": "economie-finance",
		"fn": "→ [34] Plan de ré-industrialisation dans le cadre d’une coopération associant l’industrie et l’État-stratège (…)<br>→ [35] Soutenir les entreprises françaises face à la concurrence internationale déloyale par (...) le rétablissement d’une monnaie nationale adaptée à notre économie.<br>→ [37] Instaurer un vrai patriotisme économique en se libérant des contraintes européennes et en réservant la commande publique aux entreprises françaises si l’écart de prix est raisonnable. (...)<br>→ [39] (…) Créer sous la tutelle de la Caisse des Dépôts et Consignations un fonds souverain (…)<br>→ [43] (…) Sortir de la dépendance aux marchés financiers en autorisant à nouveau le financement direct du Trésor par la Banque de France ;<br>→ [44] Abaisser les charges sociales des TPE-PME (...) en fusionnant l’ensemble des dispositifs d’allègement des charges sociales de manière dégressive (le CICE sera transformé en allègement de charges et entrera dans le dispositif) (…).<br>→ [59] Instaurer une Prime de Pouvoir d’Achat (PPA) à destination des bas revenus et des petites retraites (pour les revenus jusqu’à 1 500 euros par mois) (...) ;<br>→ [75] Baisser de 10 % l’impôt sur le revenu sur les trois premières tranches ;<br>→ [121] Augmenter dès la 1ère année du mandat le budget de la Défense à 2 % du PIB puis tendre vers 3 % à l’horizon 2022 (…) ;<br>→ [133] « Développer massivement les filières françaises des énergies renouvelables (solaire, biogaz, bois…) grâce à un protectionnisme intelligent, au patriotisme économique, à l’investissement public et privé et aux commandes d’EDF. (...)»<br>→ [134] « Pour maintenir, moderniser et sécuriser la filière nucléaire française, engager le Grand Carénage (...) Refuser la fermeture de la centrale de Fessenheim. »",
		"fi": "Les programme du FN semble insuffisant pour relancer la demande. Les gains de pouvoir d&#39;achat devraient être assez modestes, surtout pour les plus pauvres, et peu de choses sont prévues contre le chômage et la précarité. Vu le déséquilibre du budget, on peut aussi douter de la mise en place de nombre de mesures plus sociales, ou des baisses d&#39;impôts annoncées.</p>\n<p>Pour relancer l&#39;économie, le FN envisage surtout des défiscalisations et des baisses de cotisations sociales. Mais ces baisses <a href=\"http://www.humanite.fr/exonerations-de-cotisations-cout-exorbitant-efficacite-douteuse-523868\">se succèdent depuis plus de 20 ans</a> (on est passé de 3,4 à 27,6 milliards d&#39;euros/ an entre 1993 et 2013, sans compter <a href=\"http://www.latribune.fr/economie/france/le-cice-un-scandale-d-etat-587387.html\">le CICE</a>), et en plus d&#39;aggraver la dette, elles ont été <a href=\"http://www.humanite.fr/exonerations-de-cotisations-cout-exorbitant-efficacite-douteuse-523868\">peu efficaces</a>. Le FN veut créer un fond souverain, mais <a href=\"https://www.lesechos.fr/elections/front-national/0212037674644-debat-les-7-intox-economiques-de-marine-le-pen-2084468.php\">il existe déjà avec la Banque Publique d&#39;Investissement (BPI)</a>.</p>\n<p>Les investissements prévus sont aussi assez modestes. Ceux dans les énergies renouvelables et l&#39;isolation de l&#39;habitat ne sont pas chiffrés, comme ceux pour le « patriotisme économique » ou la « ré-industrialisation ». Les plus importants prévus sont dans le nucléaire et dans la défense, et on ne voit pas comment ils relanceraient l&#39;activité. L’investissement public peut avoir un fort effet d’entraînement sur l’activité : <a href=\"http://www.lemonde.fr/idees/article/2016/11/04/l-investissement-public-est-la-cle-de-la-reprise-economique_5025661_3232.html\">entre 1,3 et 2,5 euros pour 1 euro investi pour l’économiste Xavier Ragot</a>. <a href=\"https://www.lesechos.fr/02/12/2016/lesechos.fr/0211556543481_investissement-public---le-plaidoyer-de-l-ofce.htm\">Le FMI plaide aussi pour la hausse des investissements publics</a>, mais selon l&#39;OFCE, ils doivent se faire <a href=\"https://www.lesechos.fr/02/12/2016/lesechos.fr/0211556543481_investissement-public---le-plaidoyer-de-l-ofce.htm\">en priorité dans la transition énergétique ou l&#39;éducation</a> pour être efficaces.</p>\n<p>Le parti ne remet pas non plus en cause la légitimité de la dette, et ne prévoit pas d&#39;augmenter les prélèvements sur les plus hauts revenus ou la finance : Il ne resterait donc que le financement auprès des marchés, ou la création monétaire. Ce qui aggraverait l&#39;inflation, tandis que les prévisions d&#39;inflation du parti (<a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\"> hausse progressive jusqu&#39;à « 2,5% à compter de 2020 »</a>) ne sont déjà pas réalistes, compte tenu des mesures protectionnistes prévues, surtout <a href=\"http://www.alternatives-economiques.fr/une-sortie-de-leuro-penaliserait-lepargne-francais/00078519\">en cas de sortie de l&#39;euro</a>. On imagine donc mal <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">une croissance de 2%  (contre 1,1% en 2016) puis « 2,5% en fin de quinquennat »</a>, comme le prévoit le parti.",
		"aec": "En général: Prévisions d&#39;inflation de <a href=\"https://fr.scribd.com/document/339809194/Chiffrage-projet-France-insoumise\">4,2% / an</a>; Et le coefficient multiplicateur des investissements publics retenu est de  <a href=\"https://fr.scribd.com/document/339809194/Chiffrage-projet-France-insoumise\">1,4\n</a><br><br>Financement : Faire <strong><a href=\"https://laec.fr/s35m2\">racheter la dette publique</a></strong> par la Banque centrale;  <strong><a href=\"https://laec.fr/s35m1\">Audit citoyen de la dette publique</a></strong>; <strong><a href=\"https://laec.fr/s49m1\">S&#39;exonérer du pacte de stabilité</a></strong> et des règles européennes encadrant les déficits ; Dans le cadre du plan B : <strong><a href=\"https://laec.fr/s52m2\">Réquisitionner la Banque de France</a></strong> pour reprendre le contrôle de la politique du crédit ; <strong><a href=\"https://laec.fr/s21m\">Créer un pôle public bancaire</a></strong> ; Accorder une <strong><a href=\"https://laec.fr/s21m2\">licence bancaire à la Banque publique d&#39;investissement</a></strong> (BPI) pour se financer auprès de la Banque centrale.<br><br><strong><a href=\"https://www.lafaqdelavenirencommun.com/article/13/23/fr/quel-est-le-co%C3%BBt-du-programme-l_avenir-en-commun-.html\">100 milliards d&#39;euros d’investissements</a></strong> sur 5 ans (20 milliards d&#39;euros/an) pour des <a href=\"https://laec.fr/s18m1\">investissements écologiquement et socialement utiles</a>:<br>50 milliards d&#39;euros pour l&#39;urgence écologique dont : 25 milliards d&#39;euros dans les <strong><a href=\"https://laec.fr/s39m1\">énergies renouvelables</a>;</strong> 20 pour <a href=\"https://laec.fr/s40m1\">l&#39;isolation des logements</a>; Et 5  pour développer le <a href=\"https://laec.fr/s41\">ferroutage</a>.<br>45 milliards d&#39;euros pour l&#39;urgence sociale dont : 18 pour construire <strong><a href=\"https://laec.fr/s34m2\">1 millions de logements publics aux normes écologiques</a></strong>; et 10 pour le <a href=\"https://laec.fr/s68m1\">plan 0 obstacle</a> pour l&#39;accessibilité des handicapés;<br><a href=\"https://infogr.am/plan_dinvestissements\">5 milliards d&#39;euros</a> pour les services publics.<br><br><a href=\"https://www.lafaqdelavenirencommun.com/article/13/23/fr/quel-est-le-co%C3%BBt-du-programme-l_avenir-en-commun-.html\">173 milliards d&#39;euros de hausse du budget</a> de l’Etat et de la sécurité sociale, dont :<br>33 milliards d&#39;euros pour l’urgence sociale, dont <strong><a href=\"https://laec.fr/s33m2\">l&#39;augmentation des minimas sociaux</a></strong> au dessus du seuil de pauvreté.<br>32 milliards d&#39;euros pour la <strong><a href=\"https://laec.fr/s31m1\">retraite à 60 ans avec 40 ans de cotisation</a></strong> et la <a href=\"https://laec.fr/s31m2\">revalorisation des pensions</a>.<br>24 milliards d&#39;euros pour l&#39;éducation, la culture, et la recherche, dont la <strong><a href=\"https://laec.fr/s73m3\">gratuité totale de l&#39;éducation</a></strong>, le <strong><a href=\"https://laec.fr/s73m4\">recrutement de 60 000 enseignants</a></strong> et la hausse de 4,6 milliards d&#39;euros du <a href=\"https://laec.fr/s75m4\">budget de Enseignement supérieur et recherche</a>.<br>22 milliards d&#39;euros pour augmenter les salaires  de la <a href=\"https://laec.fr/s30m2\">fonction publique</a> et <strong><a href=\"https://laec.fr/s30m1\">du SMIC</a></strong>.<br>17 milliards d&#39;euros pour la jeunesse: <a href=\"https://laec.fr/s27m1\">Allocation d&#39;autonomie</a> et création de <a href=\"https://laec.fr/s27m2\">660 000 contrats jeunes</a>.<br>6,4 milliards d&#39;euros pour le <a href=\"https://laec.fr/s26m3\">droit opposable à l&#39;emploi</a>, la <a href=\"https://laec.fr/s25\">lutte contre précarité</a>.",
		"badge": {
			"text": "Mensonger",
			"color": "red"
		},
		"parent": "economie-finance",
		"slug": "economie-finance-economie",
		"relatives": [
			{
				"title": "Financement / Budget",
				"link": "economie-finance-budget"
			},
			{
				"title": "Economie Générale",
				"link": "economie-finance-economie"
			},
			{
				"title": "Finance",
				"link": "economie-finance-finance"
			},
			{
				"title": "Protectionnisme",
				"link": "economie-finance-protectionnisme"
			}
		]
	},
	"economie-finance-finance": {
		"title": "Finance",
		"main": false,
		"invisible": true,
		"image": "economie-finance",
		"fn": "→ [134] Mettre en place un plan de ré-industrialisation dans le cadre d’une coopération associant l’industrie et l’État-stratège pour privilégier l’économie réelle face à la finance spéculative.<br>→ [139] Assurer la protection des secteurs stratégiques et porteurs par un contrôle des investissements étrangers qui portent atteinte aux intérêts nationaux grâce à une Autorité de Sûreté Économique. Créer sous la tutelle de la Caisse des Dépôts et Consignations un fonds souverain avec la double mission de protéger les entreprises des fonds vautour ou des OPA hostiles et de prendre des participations dans des secteurs porteurs.<br>→ [143] Remettre de l’ordre dans nos finances publiques par la fin des mauvaises dépenses publiques (notamment celles liées à l’immigration et à l’Union européenne) et par la lutte contre la fraude sociale et fiscale. Sortir de la dépendance aux marchés financiers en autorisant à nouveau le financement direct du Trésor par la Banque de France.<br>→ [178] Lutter efficacement contre l’évasion fiscale pour préserver notre modèle social en s’attaquant aux paradis fiscaux et en créant une taxe sur l’activité réalisée en France par les grands groupes et les profits qui auraient été détournés.",
		"fi": "Le contrôle des investissements semble être une bonne chose, ainsi que la création d&#39;un fonds souverain, mais ce fonds <a href=\"https://www.lesechos.fr/elections/front-national/0212037674644-debat-les-7-intox-economiques-de-marine-le-pen-2084468.php\">existe déjà à travers la BPI</a>. Il est prévu qu&#39;il soit géré <a href=\"http://www.europe1.fr/politique/whirlpool-macron-avait-dit-aux-salaries-quil-nirait-pas-les-rencontrer-selon-le-pen-3317087\">par les chefs d&#39;entreprises</a> directement, et rien ne garantit que ces sommes ne finiront pas par grossir les profits et les dividendes des entreprises. Les investissements pour la ré-industrialisation sont <a href=\"http://www.latribune.fr/economie/international/le-fmi-plaide-pour-une-relance-urgente-de-la-depense-publique-588379.html\">nécessaires pour une relance de l&#39;économie</a>, mais ne sont pas prévus dans le budget. Le FN propose en quelques sortes d&#39;appliquer des pansements de dernière minute contre les opérations d&#39;achats, mais ne propose pas pour autant de légiférer, ni un <a href=\"https://www.lesechos.fr/26/06/2015/LesEchos/21967-051-ECH_pourquoi-il-faut-separer-les-banques.htm\">contrôle accru sur les transactions financières ou les banques d&#39;investissement</a>, et le risque est de dépenser toujours plus pour sauver l&#39;industrie française et compenser les méfaits de la finance, qui pousse à la désindustrialisation.</p>\n<p>Pour sortir de la dépendance aux marchés financiers, il faudrait développer d&#39;autres formes de financements, ce que le FN ne fait pas vraiment. Remettre en cause la légitimité de la dette de l&#39;Etat, et augmenter les recettes fiscales en imposant les plus riches, <a href=\"http://analysonslefn.fr/themes/economie-finance-budget\">et avoir un budget équilibré</a>. Taxer aussi la spéculation et la finance, qui appauvrit l&#39;économie réelle. Les versements de dividendes ont été <a href=\"https://business.lesechos.fr/directions-financieres/financement-et-operations/gestion-de-tresorerie/0202787732558-la-distribution-de-dividendes-multipliee-par-7-en-vingt-ans-6993.php\">multipliés par 7 en 20 ans</a>, ils augmentent continuellement, même quand les profits baissent. En 2012 ils représentaient <a href=\"http://alternatives-economiques.fr/blogs/chavagneux/2014/03/10/les-distributions-de-dividendes-plombent-l%E2%80%99investissement-des-entreprises/\">85% des profits, et 2,6 fois le montant total des investissements</a>. Il est aussi indispensable de lutter réellement contre <a href=\"http://www.parismatch.com/Actu/Economie/Optimisation-fiscale-les-pratiques-des-multinationales-passees-au-crible-850851\">la fraude, l&#39;évasion et de l&#39;optimisation fiscale</a>, alors que les mesures du FN dans ce domaine n&#39;ont rien de concret, et n&#39;abordent pas le problème des niches fiscales. S&#39;attaquer à tous ces problèmes pourrait augmenter considérablement les recettes de l&#39;Etat, et <a href=\"https://www.bastamag.net/Comment-recuperer-200-milliards-d-euros-sans-imposer-aux-Francais-une-cure-d\">réduire sa dépendance aux marchés financiers, sans imposer de cure d&#39;austérité</a>.",
		"aec": "<strong><a href=\"https://laec.fr/s18m4\">Réindustrialiser le pays</a></strong> par l&#39;investissement, le rétablissement de plans de filières, la création de pôles publics et la défense des industries stratégiques.<br>Séparer <strong><a href=\"https://laec.fr/s19m1\">les banques d&#39;affaires et de détail</a></strong>, et créer un <strong><a href=\"https://laec.fr/s21m\">pôle public bancaire</a></strong> ; Accorder une <strong><a href=\"https://laec.fr/s21m2\">licence bancaire à la Banque publique d&#39;investissement</a></strong> (BPI).<br><strong><a href=\"https://laec.fr/s35m1\">Audit citoyen</a></strong> de la dette publique; <strong><a href=\"https://laec.fr/s49m1\">S&#39;exonérer du pacte de stabilité</a></strong> et des règles européennes encadrant les déficits.<br><strong><a href=\"https://laec.fr/s19m2\">Contrôler</a></strong> les mouvements de capitaux.<br>Instaurer une <strong><a href=\"https://laec.fr/s19m3\">taxe réelle sur les transactions financières</a></strong>.<br><a href=\"https://laec.fr/s20m1\">Mettre fin</a> à la cotation continue des entreprises en Bourse.<br><a href=\"https://laec.fr/s20m5\">Interdire aux entreprises</a> de distribuer un montant de dividendes supérieur à leurs bénéfices et donc d&#39;emprunter pour distribuer des dividendes.<br>Mettre fin au dumping à l&#39;intérieur de l&#39;UE par <strong><a href=\"https://laec.fr/s51m7\">une politique volontariste et rapide d&#39;harmonisation sociale et fiscale</a></strong> par le haut dans toute l&#39;UE avec inscription d&#39;une clause de non-régression des droits sociaux  (plan A pour l&#39;Union Européenne).<br><strong><a href=\"https://laec.fr/s51m1\">Mettre fin à l&#39;indépendance de la Banque centrale européenne</a></strong>, autoriser le rachat de la dette publique directement aux États, interdire à la BCE de couper les liquidités à un État membre (plan A): <a href=\"https://laec.fr/s52m2\">Réquisitionner</a> la Banque de France (plan B).<br>Rendre effectif le <strong><a href=\"https://laec.fr/s16m6\">droit de réquisition des entreprises</a></strong> d&#39;intérêt général par l&#39;État.",
		"badge": {
			"text": "Mensonger",
			"color": "red"
		},
		"parent": "economie-finance",
		"slug": "economie-finance-finance",
		"relatives": [
			{
				"title": "Financement / Budget",
				"link": "economie-finance-budget"
			},
			{
				"title": "Economie Générale",
				"link": "economie-finance-economie"
			},
			{
				"title": "Finance",
				"link": "economie-finance-finance"
			},
			{
				"title": "Protectionnisme",
				"link": "economie-finance-protectionnisme"
			}
		]
	},
	"economie-finance-protectionnisme": {
		"title": "Protectionnisme",
		"main": false,
		"invisible": true,
		"image": "economie-finance",
		"fn": "→ [35] Soutenir les entreprises françaises face à la concurrence internationale déloyale par la mise en place d’un protectionnisme intelligent et le rétablissement d’une monnaie nationale adaptée à notre économie, levier de notre compétitivité.<br>→ [36] Afin d’assurer la protection des consommateurs et la concurrence loyale, interdire l’importation et la vente de produits provenant de l’étranger qui ne respectent pas les normes imposées aux producteurs français. Parallèlement, soutenir le « Fabriqué en France » par un étiquetage obligatoire, clair et loyal sur l’origine des produits et denrées commercialisés en France.<br>→ [37] Instaurer un vrai patriotisme économique en se libérant des contraintes européennes et en réservant la commande publique aux entreprises françaises si l’écart de prix est raisonnable. Réserver une partie de la commande publique aux PME.<br>→ [38] Supprimer sur notre territoire la directive « détachement des travailleurs » qui y crée une concurrence déloyale inadmissible. Mettre en place une taxe additionnelle sur l’embauche de salariés étrangers afin d’assurer effectivement la priorité nationale à l’emploi des Français.<br>→ [59] Instaurer une Prime de Pouvoir d’Achat (PPA) à destination des bas revenus et des petites retraites (pour les revenus jusqu’à 1500 euros par mois), financée par une Contribution Sociale sur les Importations de 3 %.",
		"fi": "Le rétablissement d&#39;une monnaie nationale aurait vraisemblablement des conséquences désastreuses. La France ayant un fort déficit commercial (les importations <a href=\"http://www.lefigaro.fr/flash-eco/2017/02/07/97002-20170207FILWWW00046-le-deficit-commercial-s-est-creuse-en-decembre.php\">dépassent les exportations de presque 50 milliards d&#39;euros en 2016</a>), la valeur de la nouvelle monnaie française chuterait drastiquement. Cette dévaluation serait donc accompagnée d&#39;une <a href=\"https://www.challenges.fr/election-presidentielle-2017/front-national-la-facture-delirante-du-programme-economique-de-marine-le-pen_453582\">inflation qui impacterait fatalement le porte-feuille des français dans leur ensemble, et des entreprises</a>.</p>\n<p>Les mesures protectionnistes du FN à elles seules ne suffiront pas à préserver la France et ses intérêts. On peut penser que si la France taxe les travailleurs étrangers ou les entreprises étrangères, <a href=\"https://www.lesechos.fr/elections/marine-le-pen/0211794313711-front-national-un-projet-economique-inconsequent-2064341.php\">des mesures de rétorsion seraient prises</a>, qui pourraient faire monter les prix d&#39;une manière plus importante que ce que prévoit le FN (une <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">accélération progressive jusqu&#39;à 2,5% en 2020</a>).</p>\n<p>Pour cela, il faut tenir compte des conditions de production, qu&#39;il s&#39;agisse de l&#39;exploitation des travailleurs et des dégâts écologiques. Les produits qui ne respectent pas les normes imposées aux producteurs français sont déjà interdits, et tous les produits commercialisés en France doivent les respecter. On ne voit donc pas ce que cette mesure apportera de plus. Il faut surtout chercher à améliorer et harmoniser les conditions de travail partout, et arrêter la concurrence déloyale. Au niveau de l&#39;Union Européenne, il ne suffit pas de supprimer la directive sur le travail détaché, mais il faut aussi agir pour en finir avec le dumping fiscal et social. Et en faire de même au niveau mondial, car le repli sur nos frontières nationales ne nous mettra pas à l&#39;abri pour autant de la concurrence déloyale.",
		"aec": "Adopter <strong><a href=\"https://laec.fr/s17m2\">des mesures anti-dumping</a></strong> d&#39;urgence sur les industries stratégiques (acier, photovoltaïque…), augmenter immédiatement les droits de douane pour les pays aux droits sociaux limités (travail des enfants, absence de droits syndicaux), prendre des mesures de rétorsion commerciales contre les paradis fiscaux.<br>Instaurer une <strong><a href=\"https://avenirencommun.fr/livret-produire-france/\">taxation sociale aux frontières sur la base du droit social</a></strong> du pays exportateur (salaire minimum, droit à la retraite, etc.) en cas d’absence d’accord bilatéral comportant des exigences sociales ; Mettre en place une <strong><a href=\"https://avenirencommun.fr/livret-produire-france/\">taxation des importations sur les entreprises ayant délocalisé</a></strong>, taxation qui alimenterait un « Fonds solidaire d’aide à la relocalisation et de lutte contre les délocalisations ».<br>Imposer une taxation écologique aux frontières : Introduire une <strong><a href=\"https://laec.fr/s42m1\">contribution carbone</a></strong> sur le transport de marchandises et une <strong><a href=\"https://laec.fr/s42m2\">taxe kilométrique</a></strong> suivant la distance parcourue; <a href=\"https://laec.fr/s58m4\">Créer un crime international d&#39;écocide</a> (atteinte grave à l&#39;environnement) jugé par un tribunal international de justice écologique ou dans le cadre de la Cour pénale internationale.<br><strong><a href=\"https://laec.fr/s51m7\">Mettre fin au dumping à l&#39;intérieur de l&#39;UE</a></strong> par une politique volontariste et rapide d&#39;harmonisation sociale et fiscale par le haut dans toute l&#39;UE avec inscription d&#39;une clause de non-régression des droits sociaux.<br><a href=\"https://laec.fr/s49m2\">Cesser d&#39;appliquer unilatéralement la directive sur le détachement de travailleurs en France</a> : la législation nationale doit s&#39;appliquer totalement, y compris concernant les cotisations sociales patronales et salariales.<br><strong><a href=\"https://laec.fr/s57m2\">Sortir de l&#39;Organisation mondiale du commerce</a></strong> et renforcer la Cnuced comme organe légitime pour organiser le commerce mondial en fonction de l&#39;intérêt général des peuples, à la place des G20, G7, FMI et OMC.<br><strong><a href=\"https://laec.fr/s17m1\">Construire une autre politique internationale</a></strong> des échanges commerciaux, basée sur la coopération; <a href=\"https://laec.fr/s62m1\">En finir avec la Françafrique</a> : respecter l&#39;indépendance des États africains et la souveraineté des peuples.<br>Prévisions d&#39;inflation de <a href=\"https://fr.scribd.com/document/339809194/Chiffrage-projet-France-insoumise\">4,2%/an</a>.",
		"badge": {
			"text": "Dangereux",
			"color": "red"
		},
		"parent": "economie-finance",
		"slug": "economie-finance-protectionnisme",
		"relatives": [
			{
				"title": "Financement / Budget",
				"link": "economie-finance-budget"
			},
			{
				"title": "Economie Générale",
				"link": "economie-finance-economie"
			},
			{
				"title": "Finance",
				"link": "economie-finance-finance"
			},
			{
				"title": "Protectionnisme",
				"link": "economie-finance-protectionnisme"
			}
		]
	},
	"economie-finance": {
		"title": "Économie, Finance",
		"main": true,
		"image": "economie-finance",
		"pos": 3,
		"intro": "<a href=\"http://www.europe1.fr/politique/sur-tf1-le-pen-en-candidate-du-peuple-contre-le-candidat-de-loligarchie-3311654\">Face à Emmanuel Macron, Marine Le Pen aimait se présenter</a> comme la « candidate du peuple » luttant contre « le règne de l&#39;argent, l&#39;idée que le marché est le patron », contre « l&#39;oligarchie », « la finance » ou la « mondialisation sauvage ».<br>Depuis la crise de 2008, le Front National a fait mine de changer, prônant un état fort face à la mondialisation et la dérégulation. Pourtant, dans les faits, alors que Jean-Marie Le Pen se présentait comme « le Reagan Français », <a href=\"http://bfmbusiness.bfmtv.com/france/comment-le-fn-est-passe-de-l-ultra-liberalisme-a-l-etat-protecteur-933363.html\">le FN a juste mis un peu d&#39;eau dans son vin</a>. Les termes &quot;actionnaire&quot;, &quot;dividende&quot; &quot;cac40&quot;, &quot;oligarchie&quot; ou &quot;ouvrier&quot; ne figurent pas du tout dans son programme, &quot;finance&quot; et &quot;marché&quot; quasiment pas, mais on y trouve beaucoup de recettes économiques finalement très libérales, comme la <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">baisse des recettes de l&#39;État (impôts et taxes) et des dépenses publiques</a>. Accompagnées d&#39;une forte dose de « patriotisme économique » et de protectionnisme pour défendre le capital français, mais pas vraiment les travailleurs, ni l’écologie.",
		"subs": [
			{
				"title": "Financement / Budget",
				"link": "economie-finance-budget"
			},
			{
				"title": "Economie Générale",
				"link": "economie-finance-economie"
			},
			{
				"title": "Finance",
				"link": "economie-finance-finance"
			},
			{
				"title": "Protectionnisme",
				"link": "economie-finance-protectionnisme"
			}
		],
		"slug": "economie-finance"
	},
	"immigration-laicite-immigration": {
		"title": "Immigration",
		"main": false,
		"invisible": true,
		"image": "immigration-laicite",
		"fn": "→ [24] Rétablir les frontières nationales et sortir de l’espace Schengen (...).<br>→ [25] Rendre impossible la régularisation ou la naturalisation des étrangers en situation illégale. Simplifier et automatiser leur expulsion.<br>→ [26] Réduire l’immigration légale à un solde annuel de 10 000 (…).<br>→ [27] Supprimer le droit du sol : l’acquisition de la nationalité française sera possible uniquement par la filiation ou la naturalisation dont les conditions seront par ailleurs plus exigeantes (…).<br>→ [28] Revenir à l’esprit initial du droit d’asile qui ne pourra par ailleurs être accordé qu’à la suite de demandes déposées dans les ambassades et consulats français dans les pays d’origine ou les pays limitrophes.",
		"fi": "Un « solde annuel de 10 000 » pour l&#39;immigration légale induirait une fermeture quasi-totale du pays : En 2013, dernier chiffre connu pour les immigrés, <a href=\"http://www.lemonde.fr/societe/article/2015/10/13/l-insee-bouscule-les-idees-recues-sur-l-immigration_4788773_3224.html\">le solde migratoire était de 140 000</a> (dernier chiffre connu), soit à peine 0,2% de la population, et ce chiffre a baissé depuis 2006. On est donc bien loin d&#39;une « invasion », et <a href=\"http://www.lemonde.fr/societe/article/2015/10/13/l-insee-bouscule-les-idees-recues-sur-l-immigration_4788773_3224.html\">en 2014</a>, seule 8,9% de la population était immigrée, et il y avait <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/10/05/idee-recue-n-1-les-migrants-envahissent-la-france_5008359_4355770.html\">1063 demandeurs d&#39;asiles pour 1 million d&#39;habitants</a> en 2015. Cette mesure impliquerait une explosion du nombre d&#39;expulsions, alors qu&#39;il y en a déjà <a href=\"http://www.la-croix.com/France/Immigration/Les-expulsions-migrants-illegaux-diminuent-elles-2016-09-02-1200786321\">environ 30 000</a> par an. La suppression du droit du sol, pour ne plus appliquer que ce qu&#39;on appelle le « droit du sang », est une mesure xénophobe qui remet en cause un <a href=\"https://fr.wikipedia.org/wiki/Droit_du_sol\">principe en vigueur depuis plus de 150 ans</a>.</p>\n<p>Il faut aussi comprendre que l&#39;immigration est de plus en plus nécessaire pour la France afin de combler ses besoins en main d&#39;oeuvre. D&#39;après <a href=\"https://www.insee.fr/fr/statistiques/1280826\">l&#39;INSEE</a>, les plus de 65 ans représenteront plus de 40% de la population en 2050, tandis qu&#39;<a href=\"https://www.ined.fr/fr/tout-savoir-population/chiffres/france/flux-immigration/sexe-age/\">en 2014, 62% des bénéficiaires d&#39;un titre de séjour avaient entre 18 et 34 ans</a>. Et d&#39;un point de vue économique, rien ne prouve que l&#39;immigration soit coûteuse, comme le répète sans cesse le FN. <a href=\"http://www.courrierinternational.com/article/2010/12/02/les-tres-bons-comptes-de-l-immigration\">Une étude détaillée</a> montre même qu&#39;en 2009, les immigrés rapporteraient plus de 12 milliards à l&#39;Etat.</p>\n<p>En 2011, Marine Le Pen affirmait vouloir <a href=\"http://www.lepoint.fr/politique/marine-le-pen-il-faut-repousser-les-migrants-dans-les-eaux-internationales-25-02-2011-1299694_20.php\">« repousser dans les eaux internationales les migrants qui voudraient entrer en Europe »</a>. Mais en 2016, <a href=\"http://www.liberation.fr/planete/2016/12/23/plus-de-5-000-migrants-sont-morts-en-mediterranee-en-2016-un-nouveau-triste-record_1537174\">plus de 5 000 migrants sont morts en Méditerranée</a>, de loin la frontière migratoire la plus mortifère au monde. Sur le droit d&#39;asile, le FN vise en fait le contraire de ce qu&#39;il prétend, puisque « l&#39;esprit initial » de ce droit, c&#39;est à dire la <a href=\"https://fr.wikipedia.org/wiki/Convention_relative_au_statut_des_r%C3%A9fugi%C3%A9s\">convention de Genève</a>, ne <a href=\"https://www.mediapart.fr/journal/france/230317/programme-du-fn-5-immigration-une-politique-irrealiste-qui-met-la-france-en-peril\">permet pas d&#39;étudier uniquement les demandes qui auraient été déposées dans « les pays d&#39;origine ou limitrophes », ni l&#39;expulsion des demandeurs qui ne l&#39;auraient pas fait</a>. La sortie de l&#39;espace Schengen <a href=\"http://www.strategie.gouv.fr/publications/consequences-economiques-dun-abandon-accords-de-schengen\">coûterait plus de 10 milliards d’euros</a> à la France, et affaiblirait son poids en cas de négociations pour sortir de l&#39;UE.</p>\n<p>Derrière l&#39;obsession du FN sur l&#39;immigration se cache une profonde xénophobie, qui masque son absence de solutions crédibles face aux vrais problèmes, qui sont sociaux, économiques, écologiques et internationaux.",
		"aec": "<strong><a href=\"https://laec.fr/s6m1\">Défendre le droit du sol intégral</a></strong> pour les enfants nés en France, y compris dans les Outre-mer.<br/><br><strong><a href=\"https://laec.fr/s59m4\">Respecter la dignité humaine des migrants</a></strong>, leurs droits fondamentaux et accompagner les mineurs isolés ; Réaffirmer et faire vivre le droit d&#39;asile, accueillir les réfugiés qui en relèvent; En finir avec le placement en centre de rétention d&#39;enfants ; Construire des centres d&#39;accueil aux normes internationales.<br/><br><a href=\"https://avenirencommun.fr/le-livret-migrations/\">Soumettre l’octroi des titres de séjour à des critères objectifs</a> ne souffrant aucune différence d’interprétation d’une Préfecture à l’autre.<br><strong><a href=\"https://avenirencommun.fr/le-livret-migrations/\">Renégociation des accords de Schengen</a></strong> et remplacement de Frontex par une agence dont la mission première sera le sauvetage en mer ; Refonder la politique européenne de contrôle des frontières extérieures; Construire un programme pour l&#39;aide au retour des réfugiés qui le souhaitent.<br/><br><strong><a href=\"https://laec.fr/s59m2\">Éviter aux migrants de devoir fuir leur pays</a></strong> : Arrêter les guerres par une diplomatie active et indépendante au service de la paix ; Mettre fin aux accords commerciaux inégaux ; Agir contre le dérèglement climatique.<br/><br><strong><a href=\"https://laec.fr/s59m1\">Gérer enfin les migrations à l&#39;échelle internationale</a></strong> : Créer une organisation mondiale des migrations liée à l&#39;ONU et organiser une conférence internationale annuelle sur les migrations pour les réponses d&#39;urgence.",
		"badge": {
			"text": "Démagogique et dangereux",
			"color": "red"
		},
		"parent": "immigration-laicite",
		"slug": "immigration-laicite-immigration",
		"relatives": [
			{
				"title": "Immigration",
				"link": "immigration-laicite-immigration"
			},
			{
				"title": "« Priorité Nationale »",
				"link": "immigration-laicite-priorite-nationale"
			},
			{
				"title": "Laïcité",
				"link": "immigration-laicite-laicite"
			}
		]
	},
	"immigration-laicite-laicite": {
		"title": "Laïcité",
		"main": false,
		"invisible": true,
		"slug": "immigration-laicite-laicite",
		"image": "immigration-laicite",
		"fn": "→ [9] Défendre les droits des femmes : lutter contre l’islamisme qui fait reculer leurs libertés fondamentales (…).<br>→ [11] Garantir la liberté de scolariser ses enfants selon ses choix (...).<br>→ [29] Interdire et dissoudre les organismes de toute nature liés au fondamentalistes islamistes (...).<br>→ [30] Fermer toutes les mosquées extrémistes recensées par le ministère de l’Intérieur (...). Interdire tout financement public (…) des lieux de culte et des activités cultuelles.<br>→ [91] Défendre l’identité nationale, les valeurs et les traditions de la civilisation française. Inscrire dans la Constitution la défense et la promotion de notre patrimoine historique et culturel.<br>→ [95] Promouvoir la laïcité et lutter contre le communautarisme (…).<br>→ [98] Promouvoir l’assimilation républicaine, principe plus exigeant que celui d’intégration.",
		"fi": "Pour Marine Le Pen, <a href=\"http://www.rtl.fr/girls/identites/marine-le-pen-le-fn-applique-t-il-ses-discours-sur-l-egalite-hommes-femmes-7787275502\">« si nous perdons, le voile sera imposé à toutes les femmes, la charia remplacera notre Constitution, la barbarie s&#39;installera »</a>. Sur les prières de rue de musulmans, elle parlait d&#39; une <a href=\"http://www.lefigaro.fr/politique/2010/12/11/01002-20101211ARTFIG00475-islam-et-occupation-la-provocation-de-marine-le-pen.php\">« occupation de territoire » et évoquait la « seconde guerre mondiale »</a>. Mais la loi de 1905 n&#39;interdit pas les prières de rue, et le <a href=\"http://www.humanite.fr/pourquoi-marine-le-pen-ne-condamne-pas-les-prieres-de-rue-des-catholiques-integristes\">FN n&#39;a jamais condamné</a> celles de catholiques intégristes comme <a href=\"http://www.huffingtonpost.fr/2013/01/29/linstitut-civitas-fait-priere-rue-devahnt-assemblee-nationale-contre-mariage-gay_n_2575468.html\">« Civitas »</a>.<br>Le FN souhaite <a href=\"http://www.famillechretienne.fr/politique-societe/presidentielle-2017/marine-le-pen-certains-catholiques-aiment-se-faire-peur-214377\">élargir à l&#39;espace public la loi interdisant les signes religieux à l&#39;école</a>, mais pour sa candidate, <a href=\"http://www.la-croix.com/Religion/France/La-laicite-geometrie-variable-Marine-Le-Pen-2017-02-13-1200824424\">« les religions chrétiennes n’ont pas de signes ostensibles »</a>. Pour elle, dans le « patrimoine historique et culturel » de la France, <a href=\"http://www.famillechretienne.fr/politique-societe/presidentielle-2017/marine-le-pen-certains-catholiques-aiment-se-faire-peur-214377\">« les racines chrétiennes ont évidemment un poids important »</a>, et les crèches <a href=\"https://www.youtube.com/watch?v=NgDx6yRa2fM\">« ne sont pas des symboles religieux », mais des « traditions »</a>.</p>\n<p>Les droits des femmes n&#39;intéressent le FN que quand il s&#39;agit d&#39;islamisme. Marine Le Pen le dit clairement : <a href=\"http://www.rtl.fr/girls/identites/marine-le-pen-le-fn-applique-t-il-ses-discours-sur-l-egalite-hommes-femmes-7787275502\">« Je ne sais pas ce que ça recouvre, le féminisme. Ce que je vois c&#39;est qu&#39;un certain nombre de droits des femmes sont en train de reculer, notamment sous la poussée du fondamentalisme islamiste (...) »</a>.<br>En soutenant « la liberté de scolariser ses enfants », le FN affiche son soutien à la loi Debré qui permet le financement public des établissements privés (<a href=\"https://blogs.mediapart.fr/emancipation/blog/030413/financement-public-de-lenseignement-prive-lomerta-continue\">7 milliards d&#39;euros en 2013</a>), alors que <a href=\"http://www.laligue.org/wp-content/uploads/2017/03/Educ4_Liberte%CC%81Enseignement_Zoom3.pdf\">97,5% de ces établissements sous contrat</a> sont catholiques. Le FN ne remet pas non plus en cause le <a href=\"https://fr.wikipedia.org/wiki/Concordat_en_Alsace-Moselle\">« concordat » en Alsace/Moselle</a>, ou la loi de séparation de l&#39;Eglise et de l&#39;Etat ne s&#39;applique pas.</p>\n<p>Quant à l&#39;interdiction et la dissolution des « organismes liés aux fondamentalistes », <a href=\"http://www.associations.gouv.fr/1006-dissoudre-une-association.html#cas-8f2a79-4\">elle est déjà possible</a>, et <a href=\"http://www.la-croix.com/Religion/Islam/Dissolution-de-trois-associations-cultuelles-liees-a-la-mosquee-de-Lagny-2016-01-13-1404007\">plusieurs associations culturelles l&#39;ont été ces dernières années</a>. Idem pour la fermeture des « mosquées extrémistes » (<a href=\"http://www.rtl.fr/actu/societe-faits-divers/terrorisme-etat-d-urgence-operation-sentinelle-un-bilan-mitige-pour-des-mesures-critiquees-7783973780\">12 fermées en 2015</a>), ou pour <a href=\"http://www.slate.fr/story/121757/infographie-lieux-de-culte-france\">l&#39;interdiction du « financement public des lieux de culte »</a>.</p>\n<p>Le FN ne s&#39;intéresse donc pas vraiment à la laïcité, ni au féminisme, mais si il met en avant ces thèmes, c&#39;est avant tout pour s&#39;attaquer aux musulmans et aux banlieues.",
		"aec": "<strong><a href=\"https://avenirencommun.fr/le-livret-laicite/\">Abrogation de la Loi Debré</a></strong> pour mettre fin au détournement de fonds publics attribués à l’enseignement confessionnel privé, tout en respectant la « liberté de l’enseignement ».<br/><br><strong><a href=\"https://laec.fr/s7m1\">Étendre le bénéfice de l&#39;application de la loi de 1905</a></strong> à tout le territoire de la République (abroger le concordat d&#39;Alsace-Moselle et les divers statuts spécifiques en vigueur dans les Outre-mer).<br/><br><strong><a href=\"https://laec.fr/s7m2\">Garantir la liberté de conscience</a></strong> et l&#39;égalité de toutes les options spirituelles devant la loi.<br/><br><strong><a href=\"https://laec.fr/s7m3\">Combattre tous les communautarismes</a></strong> et l&#39;usage politique des religions.<br/><br><strong><a href=\"https://laec.fr/s7m5\">Refuser de rencontrer d&#39;État à État ceux qui obligent nos ministres femmes à porter des accoutrements</a></strong> contraires à la dignité républicaine.<br/><br><strong><a href=\"https://laec.fr/s7m6\">Interdire la présence de ministres et préfets aux cérémonies religieuses</a></strong> et refuser le titre de chanoine de Latran pour le président de la République.",
		"badge": {
			"text": "Mensonger et dangereux",
			"color": "red"
		},
		"parent": "immigration-laicite",
		"relatives": [
			{
				"title": "Immigration",
				"link": "immigration-laicite-immigration"
			},
			{
				"title": "« Priorité Nationale »",
				"link": "immigration-laicite-priorite-nationale"
			},
			{
				"title": "Laïcité",
				"link": "immigration-laicite-laicite"
			}
		]
	},
	"immigration-laicite-priorite-nationale": {
		"title": "« Priorité Nationale »",
		"main": false,
		"invisible": true,
		"image": "immigration-laicite",
		"fn": "→ [38] Supprimer sur notre territoire la directive « détachement des travailleurs » (...). Mettre en place une taxe additionnelle sur l’embauche de salariés étrangers.<br>→ [55] Mettre en oeuvre une vraie politique nataliste réservée aux familles françaises, en rétablissant l’universalité des allocations familiales et en maintenant leur indexation sur le coût de la vie.<br>→ [58] Revaloriser le minimum vieillesse (ASPA) partout en France, y compris Outre-mer, et le conditionner à la nationalité française ou à vingt ans de résidence en France, ce qui permettra également d’augmenter les très petites retraites.<br>→ [71] Réaliser des économies en supprimant l’Aide Médicale d’État réservée aux clandestins (…).<br>→ [92] Ériger la citoyenneté française en privilège pour tous les Français par l’inscription dans la Constitution de la « priorité nationale ».<br>→ [142] Réserver prioritairement aux Français l’attribution du logement social, sans effet rétroactif (…).",
		"fi": "La plupart des économistes contredisent l&#39;idée que les immigrés seraient une charge pour l&#39;Etat, comme <a href=\"http://archives.lesechos.fr/archives/cercle/2012/04/05/cercle_45347.htm\">ceux-ci, qui démontrent qu&#39;ils contribuent davantage au budget de l’État que les natifs</a>. Et l’idée selon laquelle les étrangers <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/10/10/idee-recue-sur-les-migrants-4-6-ils-volent-le-travail-des-francais_5011081_4355770.html\">« voleraient le travail des français »</a> et feraient baisser les salaires <a href=\"http://www.leparisien.fr/une/la-place-des-travailleurs-immigres-dans-l-economie-24-05-2011-1464212.php\">est contredite pas différents travaux</a>. Aussi, <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/10/10/idee-recue-sur-les-migrants-4-6-ils-volent-le-travail-des-francais_5011081_4355770.html\">certains métiers ne leurs sont déjà pas accessibles, les démarches pour pouvoir travailler sont souvent longues, et le préfet peut très bien refuser d&#39;accorder une autorisation provisoire de travail</a>. En 2009, <a href=\"https://www.insee.fr/fr/statistiques/1374014?sommaire=1374025\">le taux de pauvreté des ménages immigrés était de 37 %, contre 13,5 % pour l’ensemble de la population</a>. Quant à la directive européenne sur les « travailleurs détachés », il faut rappeler que <a href=\"http://www.lefigaro.fr/politique/le-scan/couacs/2014/04/30/25005-20140430ARTFIG00242-a-bruxelles-marine-le-pen-n-a-pas-vote-contre-la-nouvelle-directive-sur-les-travailleurs-detaches.php\">Marine Le Pen ne s&#39;est pas opposée au vote d&#39;une nouvelle directive plus restrictive sur le sujet</a>.</p>\n<p>Actuellement il faut avoir un titre de séjour depuis au moins 10 ans pour avoir droit au minimum vieillesse : Le FN veut étendre ce délai à 20 ans. L&#39;ASPA coûte 2,3 milliards au total. On ne sait pas exactement combien d&#39;étrangers en bénéficient, mais <a href=\"http://www.liberation.fr/france/2014/10/31/etrangers-et-minimum-vieillesse-l-intox-infinie-de-l-ump_1131728\">on sait qu&#39;ils sont très minoritaires parmi les bénéficiaires</a> : L&#39;augmentation des « très petites retraites » risque donc d&#39;être bien maigre...<br>Marine Le Pen disait que « les logements sociaux sont aujourd’hui prioritairement occupés par l’immigration », mais aujourd&#39;hui, <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/03/08/non-marine-le-pen-les-etrangers-ne-sont-pas-prioritaires-pour-obtenir-un-logement-social_1554040\">88% des logements sociaux sont occupés par des français. Les sans-papiers ou les demandeurs d’asile n’y ont pas droit, et les dossiers sont anonymisés</a>. L’ Aide Médicale d’Etat permet, sous conditions, la gratuité des soins, mais <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/10/07/idee-recue-sur-les-migrants-3-6-ils-viennent-en-france-pour-se-faire-soigner_5009730_4355770.html\">son budget 2016 n&#39;était que de 744 millions</a>, et empêcher les migrants de se soigner serait dangereux pour <a href=\"http://www.humanite.fr/la-verite-sur-le-programme-du-front-national-631681\">l&#39;ensemble de la population, par la diffusion d&#39;épidémies</a>.</p>\n<p>Face au chômage, à la pauvreté ou au mal-logement, le FN préfère encore une fois culpabiliser et pénaliser les étrangers et les immigrés, alors qu&#39;il ne propose aucune solution crédible à ces problèmes.",
		"aec": "  <strong><a href=\"https://laec.fr/s49m2\">Cesser d&#39;appliquer unilatéralement la directive sur le détachement</a></strong> de travailleurs en France : la législation nationale doit s&#39;appliquer totalement, y compris concernant les cotisations sociales patronales et salariales.<br/><br>  <strong><a href=\"https://laec.fr/s25m5\">Régulariser les travailleurs sans-papiers</a></strong> pour assurer l&#39;égalité sociale entre travailleurs.<br/><br>  <strong><a href=\"https://avenirencommun.fr/le-livret-migrations/\">Autoriser les demandeurs d’asile à travailler</a></strong> pendant la période d’attente d’examen de leur dossier.<br/><br>  <strong><a href=\"https://laec.fr/s3m5\">Reconnaître le droit de vote aux élections locales</a></strong> <a href=\"https://laec.fr/s3m5\">pour les résidents étrangers en situation régulière, comme en bénéficient déjà les ressortissants des pays de l&#39;Union européenne.</a><strong><a href=\"https://laec.fr/s31m2\">Revaloriser les pensions de retraite</a></strong> au niveau du smic pour une carrière complète et porter le minimum vieillesse au niveau du seuil de pauvreté.<br/><br>  <strong><a href=\"https://avenirencommun.fr/le-livret-migrations/\">Augmenter le nombre de classes</a></strong> et les moyens alloués pour les enfants nouvellement arrivés en France.",
		"badge": {
			"text": "Démagogique et dangereux",
			"color": "red"
		},
		"parent": "immigration-laicite",
		"slug": "immigration-laicite-priorite-nationale",
		"relatives": [
			{
				"title": "Immigration",
				"link": "immigration-laicite-immigration"
			},
			{
				"title": "« Priorité Nationale »",
				"link": "immigration-laicite-priorite-nationale"
			},
			{
				"title": "Laïcité",
				"link": "immigration-laicite-laicite"
			}
		]
	},
	"immigration-laicite": {
		"title": "Immigration, Laïcité",
		"main": true,
		"image": "immigration-laicite",
		"pos": 1,
		"intro": "Pour le Front National, depuis plusieurs décennies déjà, le clivage essentiel est celui qui oppose <a href=\"http://www.monde-diplomatique.fr/2017/05/LAMBERT/57493\">« le parti des étrangers contre le parti de la France »</a>, et l&#39;immigration est le problème central et le cœur de toute son argumentation. Marine Le Pen, dont le programme de 2012 prévoyait d&#39; <a href=\"http://www.frontnational.com/pdf/projet_mlp2012.pdf\">« interdire les manifestations de soutien aux clandestins »</a>, voit l&#39;immigration comme un véritable « raz-de-marée », une <a href=\"http://www.lepoint.fr/politique/marine-le-pen-compare-l-afflux-de-migrants-aux-invasions-barbares-14-09-2015-1964773_20.php\">« invasion » comparable à celles des barbares du IVème siècle »</a>.</p>\n<p><a href=\"http://www.lefigaro.fr/flash-actu/2017/03/20/97001-20170320FILWWW00355-le-pen-je-veux-arreter-l-immigration.php\">« Arrêter l&#39;immigration légale et illégale »</a> est donc la grande priorité du FN. Avec la fermeture des frontières et le durcissement des conditions d&#39;accès à la nationalité, le parti veut instaurer la <a href=\"http://www.humanite.fr/la-verite-sur-le-programme-du-front-national-631681\">« priorité nationale »</a>. Pour « ériger la citoyenneté française en privilège » et empêcher les immigrés d&#39;accéder aux droits fondamentaux, au profit des français « de souche », il veut d&#39;abord <a href=\"https://www.mediapart.fr/journal/france/200317/fn-la-priorite-nationale-une-doctrine-contraire-aux-fondements-republicains-0\">modifier la constitution</a>. Pour les quelques étrangers qui parviendraient à rester sur le territoire, le FN parle d&#39;« assimilation», un concept « développé dans le contexte des guerres coloniales françaises au XIXe siècle », qui s&#39;appliquait donc aux « indigènes » des colonies françaises, <a href=\"https://www.mediapart.fr/journal/france/230317/programme-du-fn-4-l-identite-nationale-machine-de-guerre-contre-l-islam\">d&#39;après l’historien Yvan Gastaud</a>. Quant aux musulmans, véritables « ennemis intérieurs » pour ce parti, Marion Maréchal-Le Pen expliquait fin 2015 qu&#39;ils devaient <a href=\"http://www.europe1.fr/politique/pour-marion-marechal-le-pen-les-musulmans-ne-peuvent-etre-francais-que-sous-condition-2629283\">« se plier aux mœurs et au mode de vie que l’influence grecque, romaine, et 16 siècles de chrétienté ont façonnés ».</a>",
		"subs": [
			{
				"title": "Immigration",
				"link": "immigration-laicite-immigration"
			},
			{
				"title": "« Priorité Nationale »",
				"link": "immigration-laicite-priorite-nationale"
			},
			{
				"title": "Laïcité",
				"link": "immigration-laicite-laicite"
			}
		],
		"slug": "immigration-laicite"
	},
	"politique-internationale-europe": {
		"title": "Europe",
		"main": false,
		"invisible": true,
		"image": "politique-internationale",
		"writing": false,
		"fn": "→ [1] Retrouver notre liberté et la maîtrise de notre destin en restituant au peuple français sa souveraineté (monétaire, législative, territoriale, économique). Pour cela, une négociation sera engagée avec nos partenaires européens suivie d’un référendum sur notre appartenance à l’Union européenne. L’objectif est de parvenir à un projet européen respectueux de l’indépendance de la France, des souverainetés nationales et qui serve les intérêts des peuples.</p>\n<p>→ [24] Rétablir les frontières nationales et sortir de l’espace Schengen (un dispositif particulier pour les travailleurs frontaliers sera mis en place pour leur faciliter le passage de la frontière).</p>\n<p>→ [35] Soutenir les entreprises françaises face à la concurrence internationale déloyale par la mise en place d’un protectionnisme intelligent et le rétablissement d’une monnaie nationale adaptée à notre économie, levier de notre compétitivité.</p>\n<p>→ [43] Remettre de l’ordre dans nos finances publiques par la fin des mauvaises dépenses publiques (notamment celles liées à l’immigration et à l’Union européenne) et par la lutte contre la fraude sociale et fiscale. Sortir de la dépendance aux marchés financiers en autorisant à nouveau le financement direct du Trésor par la Banque de France.",
		"fi": "Le rétablissement d&#39;une monnaie nationale aurait vraisemblablement des conséquences désastreuses, principalement à cause du fort déficit commercial (<a href=\"http://www.lefigaro.fr/flash-eco/2017/02/07/97002-20170207FILWWW00046-le-deficit-commercial-s-est-creuse-en-decembre.php\">presque 50 milliards d&#39;euros en 2016</a>) de la France. Le Front National envisage en même temps une dévaluation, pour améliorer la compétitivité des entreprises françaises. Mais le premier gros problème serait celui de « l’inflation importée », avec une forte augmentation des prix des biens qui ne sont pas produits en France. Un autre problème important serait celui de l&#39;augmentation de la dette publique, qui pourrait atteindre plusieurs centaines de milliards d&#39;euros, alors qu&#39;environ 60 % de cette dette est détenue par des investisseurs étrangers. Face à ce risque, le FN invoque la loi monétaire internationale qui lui permettrait de convertir la dette dans la nouvelle monnaie nationale, mais<a href=\"http://www.lemonde.fr/les-decodeurs/article/2014/08/18/les-nouveaux-arguments-du-fn-pour-sortir-de-l-euro_4473049_4355770.html\"> malgré cela, l&#39;augmentation de la dette risque d&#39;être importante</a>, et provoquerait sans doute une série de contentieux avec des investisseurs étrangers. Quoi qu&#39;il en soit, il sera alors plus difficile pour la France d’emprunter sur les marchés, et <a href=\"https://www.mediapart.fr/journal/france/230317/programme-du-fn-7-sortir-de-leuro-le-grand-bricolage\">le service de la dette augmenterait de plusieurs milliards d’euros par an</a>, alors que le FN <a href=\"https://analysonslefn.fr/themes/economie-finance-economie\">n&#39;envisage pas vraiment de mesures pour réduire la dépendance de l&#39;Etat vis à vis des marchés financiers</a>. Les entreprises verraient leurs dettes envers l&#39;étranger exploser, et contrairement à la dette publique, <a href=\"https://www.mediapart.fr/journal/france/230317/programme-du-fn-7-sortir-de-leuro-le-grand-bricolage\">ces dettes ne pourront pas êtres converties en monnaie nationale</a>.</p>\n<p>Le rétablissement des frontières et la sortie de l’espace Schengen supprimerait de fait la coopération policière en son sein, y compris en matière de lutte contre le terrorisme et de surveillance commune des frontières extérieures de l’Union. -&gt; L’espace Schengen permet aussi <a href=\"https://www.mediapart.fr/journal/france/230317/programme-du-fn-8-faire-de-la-france-un-fortin-en-europe\">aux polices des différents pays membres de coopérer</a>, y compris en matière de lutte contre le terrorisme, et de surveillance commune des frontières extérieures de l’Union. Avec la sortie de cet espace et le rétablissement des frontières nationales, nous cesserions donc d&#39;en bénéficier.</p>\n<p>Enfin, toutes ces mesures, en plus des mesures protectionnistes prévues, risquent de faire augmenter l&#39;inflation d&#39;une manière importante. Pourtant, le FN ne prévoit qu&#39;une <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">hausse progressive jusqu&#39;à « 2,5% à compter de 2020 »</a> seulement, une prévision qui nous semble peu réaliste.",
		"aec": "<strong><a href=\"https://laec.fr/s49m3\">Refuser</a></strong> les régressions du droit européen sur les questions sociales et écologiques par rapport au droit national.<br><strong><a href=\"https://laec.fr/s49m1\">S&#39;exonérer du pacte de stabilité et des règles européennes encadrant les déficits</a></strong> et dénoncer le Traité sur la stabilité, la coordination et la gouvernance (TSCG).<br><strong><a href=\"https://laec.fr/s51\">Le plan A de la France Insoumise</a></strong> consiste à proposer une refondation démocratique, sociale et écologique des traités européens par la négociation. Il s&#39;agit, entre autres, de :</p>\n<ul>\n<li><a href=\"https://laec.fr/s51m1\">Mettre fin à l&#39;indépendance de la Banque centrale européenne</a>, modifier ses missions et statuts, autoriser le rachat de la dette publique directement aux États, interdire à la BCE de couper les liquidités à un État membre.</li>\n<li><a href=\"https://laec.fr/s51m7\">Mettre fin au dumping à l&#39;intérieur de l&#39;UE</a> par une politique volontariste et rapide d&#39;harmonisation sociale et fiscale par le haut dans toute l&#39;UE avec inscription d&#39;une clause de non-régression des droits sociaux.</li>\n</ul>\n<p><br/><br>En cas d&#39;échec des négociations, il est prévu d&#39;appliquer un <strong><a href=\"https://laec.fr/s52\">plan B</a></strong>, et notamment de :</p>\n<ul>\n<li><a href=\"https://laec.fr/s52m1\">Stopper</a> la contribution de la France au budget de l&#39;Union Européenne (22 milliards d&#39;euros par an dont 7 milliards d&#39;euros de contribution nette).</li>\n<li><a href=\"https://laec.fr/s52m2\">Réquisitionner la Banque de France</a> pour reprendre le contrôle de la politique du crédit et de la régulation bancaire, et pour envisager un système monétaire alternatif avec ceux de nos partenaires qui, dans la phase A, auraient manifesté leur désir de transformer l&#39;euro en monnaie commune et non plus unique.</li>\n<li><a href=\"https://laec.fr/s52m3\">Mettre en place un contrôle des capitaux et des marchandises</a> aux frontières nationales pour éviter l&#39;évasion fiscale des plus riches et des grands groupes, et se protéger des attaques spéculatives et du dumping social, fiscal et écologique.</li>\n<li><a href=\"https://laec.fr/s52m4\">Construire de nouvelles coopérations</a> avec les États qui le souhaitent en matière culturelle, éducative, scientifique, etc.</li>\n</ul>\n<p>&nbsp;",
		"badge": {
			"text": "Mensonger",
			"color": "red"
		},
		"parent": "politique-internationale",
		"slug": "politique-internationale-europe",
		"relatives": [
			{
				"title": "Europe",
				"link": "politique-internationale-europe"
			},
			{
				"title": "International",
				"link": "politique-internationale-international"
			}
		]
	},
	"politique-internationale-international": {
		"title": "International",
		"main": false,
		"invisible": true,
		"image": "politique-internationale",
		"writing": false,
		"fn": "→ [122] Engager la France au service d’un monde multipolaire fondé sur l’égalité en droit des nations, leur concertation permanente et le respect de leur indépendance. Fonder la politique internationale sur le principe de réalisme et rendre à la France son rôle de puissance de stabilité et d’équilibre.</p>\n<p>→ [123] Renforcer les liens entre les peuples qui ont le français en partage.</p>\n<p>→ [124] Mettre en œuvre une véritable politique de co-développement avec les pays d’Afrique fondée prioritairement sur l’aide au développement de l’école primaire, l’aide à l’amélioration des systèmes agricoles et l’aide au renforcement des outils de Défense et de sécurité.",
		"fi": "Le programme du Front National n&#39;évoque pas du tout le problème de la guerre en Syrie. Marine Le Pen considère que <a href=\"http://www.europe1.fr/international/pour-le-pen-bachar-al-assad-est-la-seule-solution-viable-en-syrie-2983205\">Bachar Al-Assad est la seule « solution viable en Syrie »</a>, et le programme ne propose aucun soutien à l&#39;ONU ou au<a href=\"http://www.lefigaro.fr/international/2016/12/31/01003-20161231ARTFIG00128-le-conseil-de-securite-soutient-a-l-unanimite-l-initiative-de-paix-de-moscou-et-ankara.php\"> processus de Genève</a> pour une paix durable.</p>\n<p>En matière de politique africaine, Marine Le Pen <a href=\"http://www.lemonde.fr/afrique/article/2017/03/23/au-tchad-marine-le-pen-tente-de-renforcer-sa-stature-presidentielle-et-etrille-le-franc-cfa_5099580_3212.html\">a réussi début 2017 a être reçue au Tchad par son président Idriss Deby</a>. Elle y a annoncé vouloir rompre avec la &quot;Françafrique&quot;, mais il semble assez contradictoire d&#39;affirmer cette volonté en étant reçue par ce président autoritaire, qui a réussi <a href=\"http://www.monde-diplomatique.fr/2016/06/LECOUTRE/55774\">à se maintenir au pouvoir depuis 27 ans au fil d&#39;élections douteuses</a> et de <a href=\"https://www.letemps.ch/monde/2016/08/09/idriss-deby-itno-lindeboulonnable-president-tchad\">répression de l&#39;opposition</a>, en étant <a href=\"http://www.la-croix.com/Actualite/Monde/Afrique/La-France-alliee-inconditionnelle-du-president-tchadien-Idriss-Deby-2015-05-21-1314589\">fermement soutenu par la France</a>. Dans un complément du programme du FN sur la politique étrangère, il est question d&#39;« un soutien fort par l’Etat français des investissements privés français en Afrique en échange d’une inversion des flux migratoires ». Mais ce soutien est déjà un des piliers de la &quot;Françafrique&quot; et il s&#39;apparente plus souvent à une forme de pillage des ressources et d&#39;exploitation des populations, comme, parmi les nombreux exemples, dans les mines d&#39;uranium du Niger. Quant à l&#39;aide au développement, le FN semble surtout la voir comme un  <a href=\"http://www.lemonde.fr/afrique/article/2017/04/11/marine-le-pen-son-programme-en-afrique-l-aide-seul-rempart-contre-l-immigration-massive_5109633_3212.html\">« rempart contre l’immigration massive »</a>, et <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">n&#39;avance pas de chiffres précis</a>.</p>\n<p>On peut aussi s&#39;inquiéter de la grande proximité du FN avec le régime russe de Vladimir Poutine. Le FN <a href=\"http://www.lemonde.fr/politique/article/2017/01/04/la-justice-russe-saisie-sur-le-pret-bancaire-consenti-au-front-national_5057637_823448.html\">a bénéficié d&#39;un prêt important d&#39;une banque russe en 2014</a>, et <a href=\"https://www.lecanardenchaine.fr/la-une-du-21-decembre-2016/\"><em>Le Canard enchaîné</em></a> a évoqué <a href=\"http://www.lexpress.fr/actualite/politique/elections/le-fn-dement-avoir-obtenu-un-nouveau-pret-russe-de-30-millions-de-dollars_1862781.html\">un deuxième prêt durant la campagne</a>. Surtout, le FN affirme une volonté claire de rapprochement avec la Russie, en défendant <a href=\"http://www.marinelepen.fr/le-projet-de-marine-le-pen/politique-etrangere/notre-politique-etrangere/?doing_wp_cron=1496830224.7231628894805908203125\">« une alliance stratégique poussée, fondée sur un partenariat militaire et énergétique approfondi »</a> avec ce pays.</p>\n<p>Enfin, le FN n&#39;imagine rien au dessus des nations, ce qui explique que <a href=\"https://www.mediapart.fr/journal/france/230317/programme-du-fn-17-defense-politique-etrangere-des-moulinets-et-un-tropisme-russe\">l’ONU et les institutions internationales qui lui sont liées soient totalement absentes</a> de son projet.",
		"aec": "<strong><a href=\"https://laec.fr/s60m3\">Construire une solution politique en Syrie pour une paix durable sous l&#39;égide de l&#39;Onu</a></strong>, reposant sur :</p>\n<ul>\n<li>Un cessez-le-feu durable excluant les groupes islamistes</li>\n<li>Le soutien au processus de Genève en y intégrant les kurdes de Syrie</li>\n<li>L&#39;organisation d&#39;élections libres et pluralistes, sans ingérence étrangère, sous surveillance de l&#39;Onu pour que le peuple syrien décide souverainement et démocratiquement de ses dirigeants</li>\n<li>La garantie de l&#39;intégrité de l&#39;État syrien et de ses frontières</li>\n</ul>\n<p>Mettre en place <strong><a href=\"https://laec.fr/s60m2\">une coalition universelle sous mandat de l&#39;Onu pour éradiquer Daech</a></strong> et rétablir la paix et la stabilité en Syrie et en Irak, associant les combattants kurdes.</p>\n<p><strong><a href=\"https://laec.fr/s56m1\">Réaffirmer que l&#39;ONU est le seul organe légitime pour la sécurité collective</a></strong> aux yeux de la France :</p>\n<ul>\n<li>Refuser toute intervention militaire sans mandat de l&#39;Onu</li>\n<li>Faire vivre le comité d&#39;état-major de l&#39;Onu pour commander les opérations de maintien de la paix et enclencher un processus de démocratisation de l&#39;organisation</li>\n</ul>\n<p><strong><a href=\"https://laec.fr/s62m1\">En finir avec la Françafrique</a></strong> : respecter l&#39;indépendance des États africains et la souveraineté des peuples en s&#39;interdisant de se mêler des élections et en réprimant les corrupteurs.</p>\n<p>Tenir enfin <a href=\"https://laec.fr/s62m2\">l&#39;objectif de consacrer 0,7 % du revenu national brut au budget de l&#39;aide publique au développement</a>.</p>\n<p><strong><a href=\"https://laec.fr/s61m1\">Reconnaître l&#39;État palestinien</a></strong>, et <strong><a href=\"https://laec.fr/s61m2\">appuyer la solution à deux États</a></strong> coexistant pacifiquement par l&#39;application pleine et entière des résolutions de l&#39;Onu.</p>\n<p>Au niveau des institutions internationales, <strong><a href=\"https://laec.fr/s54m4\">sortir du FMI et de la Banque mondiale</a></strong> pour œuvrer à la création d&#39;un Fonds d&#39;urgence sociale et d&#39;une Banque solidaire d&#39;investissement. <strong><a href=\"https://laec.fr/s57m2\">Sortir de l&#39;Organisation mondiale du commerce et renforcer la Cnuced</a></strong>, à la place des G20, G7, FMI et OMC. Et <a href=\"https://laec.fr/s56m3\">réformer la FAO</a> (Organisation des Nations unies pour l&#39;alimentation et l&#39;agriculture) pour favoriser la souveraineté alimentaire, la régulation des marchés mondiaux et la conversion écologique de l&#39;agriculture.</p>\n<p><strong><a href=\"https://laec.fr/s64\">Passer à la francophonie politique</a></strong>, notamment en <a href=\"https://laec.fr/s64m1\">réorganisant les institutions de la francophonie</a>, en <a href=\"https://laec.fr/s64m2\">créant une académie et un Erasmus de la francophonie</a>, et en <a href=\"https://laec.fr/s64m7\">défendant l&#39;usage du français dans les institutions internationales</a>.",
		"badge": {
			"text": "Isolationniste",
			"color": "red"
		},
		"parent": "politique-internationale",
		"slug": "politique-internationale-international",
		"relatives": [
			{
				"title": "Europe",
				"link": "politique-internationale-europe"
			},
			{
				"title": "International",
				"link": "politique-internationale-international"
			}
		]
	},
	"politique-internationale": {
		"title": "Politique Internationale",
		"main": true,
		"image": "politique-internationale",
		"pos": 8,
		"intro": "En matière de politique étrangère, le Front National (FN) présente un projet très peu détaillé, que ce soit au niveau européen, ou vis à vis du reste du monde. Par rapport à l&#39;Union Européenne (UE), le parti n&#39;affiche pas d&#39;autres objectifs que de « restituer au peuple français sa souveraineté », et ne présente aucune stratégie ni aucune feuille de route concernant les négociations et un éventuel « Frexit ». Il évacue totalement le problème de l&#39;austérité (le mot « austérité » est même totalement absent de son programme), le problème des dettes des Etats et de leurs éventuelles restructurations, et les questions démocratiques.</p>\n<p>La politique internationale, hors UE, occupe une place très marginale dans le programme général du parti, avec seulement 3 propositions sur 144, essentiellement des principes généraux assez vagues. Défendant un <a href=\"http://www.slate.fr/story/111115/front-national-souverainisme-integral\">« souverainisme intégral »</a>  contre ce qu&#39;il présente comme son ennemi ultime, le <a href=\"http://www.la-croix.com/France/Politique/Le-FN-change-forme-fond-2017-02-05-1200822607\">« mondialisme »</a>, <a href=\"http://www.humanite.fr/dans-le-monde-multipolaire-de-marine-le-pen-chacun-chez-soi-portes-fermees-633957\">la vision internationale du FN</a> est celle de nationalismes multiples et fermés, dont les échanges sont basés sur la force et le commerce, tandis que les valeurs sociales, culturelles, et écologiques y sont quasiment absentes.",
		"subs": [
			{
				"title": "Europe",
				"link": "politique-internationale-europe"
			},
			{
				"title": "International",
				"link": "politique-internationale-international"
			}
		],
		"slug": "politique-internationale"
	},
	"progres-humain-culture": {
		"title": "Culture",
		"main": false,
		"invisible": true,
		"image": "progres-humain",
		"fn": "→ [109] Développer le mécénat populaire par la création d’une plate-forme numérique dédiée.<br>→ [110] Bâtir une loi de programmation du patrimoine pour permettre un meilleur soutien à l’entretien et à la préservation du patrimoine. Augmenter le budget alloué de 25 %.<br>→ [112] Lancer un grand plan national de création de filières (lycées, universités) des métiers d’art dans nos territoires et implanter un réseau de pépinières d’artistes sur tout le territoire. Restaurer une véritable éducation musicale généraliste dans les établissements scolaires.<br>→ [113] Réformer le Conseil Supérieur de l’Audiovisuel avec la création de trois collèges : l’un composé des représentants de l’État, le deuxième de professionnels, le troisième de représentants de la société civile (associations de consommateurs, de téléspectateurs, etc.).<br>→ [114] Remettre en ordre le statut d’intermittent du spectacle par la création d’une<br>carte professionnelle afin de préserver ce régime tout en opérant un meilleur contrôle des structures qui en abusent.",
		"fi": "Encore une fois, le FN réinvente la roue ! De <a href=\"http://financeparticipative.org/observatoire-des-crowdfunders/\">nombreux sites de &quot;crowfounding&quot;</a> (mécénat populaire) participent déjà au financement des productions culturelles. <a href=\"http://www.lefigaro.fr/culture/2014/12/10/03004-20141210ARTFIG00214-fleur-pellerin-encourage-le-crowdfunding-culturel.php\">Vanté par Fleur Pellerin</a> en 2014, le mécénat, &quot;populaire&quot; ou non, cache en réalité le désengagement de l&#39;Etat envers la jeune création contemporaine, car si le budget alloué reste relativement constant, peu en bénéficient.</p>\n<p><strong>Le mécénat privé, c&#39;est la loi des grands patrons</strong> ! L&#39;artiste reconnu trouvera des mécènes fortunés à qui il devra plaire. <a href=\"http://www.lemonde.fr/architecture/article/2017/03/08/lvmh-va-transformer-le-musee-des-arts-et-traditions-populaires_5091031_1809550.html\">Souvent dépendant du goût des financeurs</a>, ce financement ne permet pas l&#39;innovation et la prise de risque. Il ne pousse ni l&#39;artiste à garder son esprit critique ni le spectateur à se remettre en question ou à aller vers des territoires inconnus. Sans parler des <a href=\"http://www.latribune.fr/entreprises-finance/20140214trib000815504/crowdfunding-le-projet-de-reglementation-assoupli-en-faveur-des-acteurs.html\">avantages fiscaux consentis par l&#39;Etat</a> au privé, sans contrepartie sur une politique culturelle accessible à tous.</p>\n<p>Depuis des années, le <a href=\"http://www.humanite.fr/le-regime-des-intermittents-un-modele-porteur-631733\">régime des intermittents</a> est <a href=\"http://www.huffingtonpost.fr/2016/04/25/regime-des-intermittents-explosion_n_9771734.html\">en crise.</a>. Pour contrôler les artistes, rien de mieux que de s&#39;en prendre à leur indemnisation. <a href=\"http://www.liberation.fr/france/2016/04/28/ce-que-contient-le-projet-d-accord-sur-les-intermittents_1449158\">Le récent accord</a> sur ce régime est considéré comme &quot;équilibré&quot; par les organisations. Le FN dénonce le coût de ce régime en utilisant le chiffre exagéré de <a href=\"http://www.frontnational.com/2016/04/intermittents-jusquici-tout-va-bien/\">1,263 milliard d’euros</a>, mais il faut tenir compte du fait que sans ce régime, ses bénéficiaires seraient indemnisés comme les autres salariés. En réalité, le coût de ce régime serait donc d&#39;<a href=\"http://www.lemonde.fr/culture/article/2014/02/26/le-regime-des-intermittents-coute-t-il-un-milliard-d-euros_4373187_3246.html\">un peu plus de 300 millions</a>. Que le FN veuille &quot;remettre en ordre&quot; et &quot;opérer un meilleur contrôle des structures&quot; pour reconnaître &quot;les authentiques acteurs du spectacle&quot; n&#39;augure rien de bon pour les artistes et pour la création artistique. Le risque serait que le FN en profite pour couper le financement des artistes qui ne leur plairaient pas.</p>\n<p>Enfin, la réforme du CSA est à prendre avec prudence : qui nomme ? sur quels critères ? Rien ne garanti qu&#39;avec cette réforme, le CSA soit plus indépendant du pouvoir politique <a href=\"https://fr.wikipedia.org/wiki/Conseil_sup%C3%A9rieur_de_l%27audiovisuel_%28France%2ç#Composition_:_le_Coll.C3.A8ge_et_les_conseillers\">qu&#39;il ne l&#39;est actuellement</a>, alors qu&#39;un véritable contre-pouvoir citoyen garantissant le pluralisme des opinions et des supports est nécessaire.",
		"aec": "Pour la France Insoumise, l&#39;art et la culture sont indissociables de la vie. Ils doivent être partagés entre tous, pas seulement entre ceux qui en ont les moyens. Les affaires de l&#39;esprit doivent être libérés de l&#39;esprit des affaires grâce à un Etat qui assume son rôle de financeur de contenus avec l&#39;objectif d&#39;en favoriser la diversité et la pluralité. Il faut défendre et reconnaître tous les professionnels de la culture, y compris dans les médias dont il faut reconstruire l&#39;indépendance et garantir le pluralisme démocratique.<br/><br><strong><a href=\"https://avenirencommun.fr/le-livret-culture/\">Abroger les niches fiscales à l’avantage des mécènes</a></strong> et les autres règles sur-mesure faites au profit des fondations privées telles que la fondation Pinault à la Bourse du commerce ou la fondation Louis Vuitton au bois de Boulogne.<br><strong><a href=\"https://avenirencommun.fr/le-livret-culture/\">Interdire le sponsoring privé</a></strong> dans les services publics et les événements culturels et atteindre une part de 10 % de budgets participatifs dans les crédits locaux consacrés à la culture.<br><strong><a href=\"https://laec.fr/s77m2\">Porter le budget consacré à l&#39;art, à la culture et à la création à 1 %</a></strong> du PIB chaque année pour :<br>-&nbsp;<a href=\"https://laec.fr/s77m2\">Pérenniser le régime des intermittent·e·s du spectacle</a> sur la base de l’accord du 28 avril 2016.<br>-&nbsp;Soutenir la création, le spectacle vivant, et l&#39;appropriation par tous des œuvres et pratiques culturelles, et ce par le <a href=\"https://laec.fr/s77m2\">renouveau de l&#39;éducation artistique</a> à l&#39;école et dans les conservatoires, de l&#39;éducation populaire et de la culture en entreprise.<br><strong><a href=\"https://laec.fr/s77m2\">Titulariser les précaires et les intermittent·e·s</a></strong> du service public de la culture et de l’audiovisuel.<br><strong><a href=\"https://laec.fr/s8m2\">Lutter contre la concentration verticale pour un même type de média</a></strong>, en interdisant les situations de monopole (ou quasi-monopole) national ou régional dans la presse, l’audiovisuel et l’édition et en abaissant la part de marché qui peut être détenue par un seul éditeur.<br><strong><a href=\"https://laec.fr/s8\">Renforcer et pérenniser le financement de l’audiovisuel public</a></strong>, y compris l’audiovisuel extérieur pour atteindre un niveau comparable à celui de nos grands voisins européens.<br><strong><a href=\"https://laec.fr/s8m4\">Renforcer les sanctions</a></strong> (suspension, retrait d’autorisation d’émettre) lorsque les médias audiovisuels diffuseront des programmes sexistes, racistes, xénophobes, LGBTIphobes ou portant atteinte à la dignité des personnes en situation de handicap.",
		"badge": {
			"text": "Dangereux",
			"color": "red"
		},
		"parent": "progres-humain",
		"slug": "progres-humain-culture",
		"relatives": [
			{
				"title": "Santé",
				"link": "progres-humain-sante"
			},
			{
				"title": "Éducation",
				"link": "progres-humain-education"
			},
			{
				"title": "Culture",
				"link": "progres-humain-culture"
			}
		]
	},
	"progres-humain-education": {
		"title": "Éducation",
		"main": false,
		"invisible": true,
		"image": "progres-humain",
		"fn": "→ [97] Renforcer l’unité de la nation par la promotion du roman national et le refus des repentances d’État qui divisent.<br>→ [103] Rétablir l&#39;autorité et le respect du maitre et instaurer le port d&#39;un uniforme à l&#39;école<br>→ [81] Revaloriser le travail manuel par l’établissement de filières professionnelles d’excellence (suppression progressive du collège unique, autorisation de l’apprentissage à partir de 14 ans). Développer des lycées professionnels ou technologiques de la seconde chance sur tout le territoire pour les élèves sortis du système scolaire sans diplôme.<br>→ [106] À l’université, passer d’une sélection par l’échec à une sélection au mérite. Refuser le tirage au sort comme moyen de sélection. Revaloriser les bourses au mérite. Défendre le modèle d’enseignement supérieur français, qui passe par la complémentarité de l’université et des grandes écoles.",
		"fi": "Pour &quot;restaurer&quot; l&#39;autorité, le FN mise sur les <a href=\"https://www.collectifracine.fr/blog/2016/09/22/les-100-propositions-du-collectif-racine-pour-lecole-et-luniversite-de-demain/\">propositions du collectif Racine</a>, qui veut donner la priorité aux savoirs (le contenu des matières) plutôt qu&#39;aux méthodes d&#39;accompagnement (la pédagogie). Le recentrage exclusif sur les savoirs dits fondamentaux, vieille lune de la droite réactionnaire, a toujours eu pour effet d&#39;exclure les plus démunis, car tout le monde n&#39;a pas la possibilité de faire étudier son enfant le soir.</p>\n<p>Au-delà des grandes déclarations, le programme du FN ne prévoit rien pour réduire les inégalités. Le principe de &quot;méritocratie personnelle&quot; semble bien illusoire. D&#39;ailleurs, en dehors d&#39;une hausse du budget de la recherche, il ne propose aucune augmentation des moyens, donc de l&#39;encadrement, pour assurer de meilleurs conditions de scolarisation. L&#39;accompagnement est, pour nous, la clef de la réussite scolaire face aux déterminismes sociaux. L&#39;effectif par classe est essentiel : <a href=\"http://www.education.gouv.fr/cid195/les-chiffres-cles-du-systeme-educatif.html\">en 2016, les élèves étaient 25 par classe en collège, 19 en lycée professionnel et 30 en lycée général</a>. Le FN voudrait <a href=\"https://www.mediapart.fr/journal/france/230317/programme-du-fn-14-la-reforme-de-l-education-une-ode-un-passe-fantasme?onglet=full\">retrouver l&#39;école des années 1960</a> avec, par exemple, un <a href=\"http://www.unsa-education.com/spip.php?article743\">retour en arrière sur les méthodes pour apprendre à lire</a>, l&#39;instauration des uniformes à l&#39;école et la transformation du collège en &quot;collège de détermination&quot;, avec une orientation possible vers la voie professionnelle dès la cinquième — une organisation scolaire abandonnée en 1975. L&#39;Histoire montre que ce système sert principalement les intérêts du monde du travail dans une relation utilitariste : former les plus en difficulté pour travailler, et les meilleurs pour devenir l&#39;élite du pays. Elle permet aussi d’évacuer la problématique de l’échec scolaire par le biais de la formation professionnelle rapide.</p>\n<p>Restreindre l&#39;accès à l&#39;Université participe de cette vision élitiste, et réduire les difficultés de l’université française au système de sélection est idiot. Le taux d’échec en licence, en BTS et en DUT doit questionner au-delà du mode d’accès. C&#39;est en développant plus de filières et en garantissant l&#39;accès pour tous à une formation supérieure, et aussi en allant vers une société plus juste que nous préparerons l&#39;avenir du pays.",
		"aec": "<strong><a href=\"https://laec.fr/s73\">Recruter au moins 60 000 enseignants supplémentaires</a></strong> durant le quinquennat pour abaisser le nombre moyen d’élèves par classe, rétablir un véritable corps d’enseignants remplaçants et engager un plan de titularisation des précaires; <strong><a href=\"https://avenirencommun.fr/le-livret-education/\">Recruter</a></strong> 8 000 conseillers principaux d’éducation (CPE) et renforcer les équipes d’assistants d’éducation (AED).<br><a href=\"https://laec.fr/s73m1\">Étendre la scolarité obligatoire de 3 à 18 ans</a>, en adaptant les pédagogies et les parcours scolaires.<br><strong><a href=\"https://laec.fr/s73m2\">Réduire massivement les effectifs par classe</a></strong> : 20 élèves maximum en maternelle, primaire, collège, lycée professionnel et technologique, 25 en lycée général.<br><a href=\"https://avenirencommun.fr/le-livret-education/\">Reconstituer les Réseau d&#39;aides spécialisées aux élèves en difficulté</a> (RASED) pour atteindre 15 000 postes; Assurer un soutien scolaire gratuit par le service public d’éducation; Replacer les disciplines au coeur des apprentissages en rétablissant les heures disciplinaires; Renforcer les dispositions permettant la maîtrise de la culture écrite.<br><strong><a href=\"https://avenirencommun.fr/le-livret-education/\">Garantir la gratuité</a></strong> des cantines, du transport, des sorties scolaires, des manuels et de matériels sans marques, des équipements et fournitures ; Abroger la réforme des rythmes scolaires.<br><br><strong><a href=\"https://laec.fr/s74m1\">Arrêter les fermetures de lycées professionnels</a></strong> et augmenter le nombre d&#39;établissements.<br><strong><a href=\"https://laec.fr/s27m1\">Verser une allocation d’autonomie de 800 € /mois</a></strong> sous condition de ressources pour les jeunes engagé·e·s dans une formation qualifiante. Les bourses actuelles seront maintenues pour les cursus supérieurs à trois ans.<br><a href=\"https://laec.fr/s74m3\">Développer les cursus courts dans l&#39;enseignement supérieur</a> et la reconnaissance complète des qualifications du supérieur dans les conventions collectives. Encourager la poursuite d&#39;études après un bac professionnel ou technologique (BTS, DUT, licences professionnelles…).<br><a href=\"https://avenirencommun.fr/livret-de-lenseignement-de-recherche/\">Remise en cause du processus d&#39;autonomie des universités, mise en place de la gratuité</a> des universités dès la rentrée 2017, et doublement du budget de l’Enseignement Supérieur et de la Recherche en cinq ans.<br><a href=\"https://avenirencommun.fr/livret-de-lenseignement-de-recherche/\">Recrutement</a> de 5 000 chercheur·euse·s, enseignant·e·s-chercheur·euse·s et personnels techniques en trois ans est un minimum, et titularisation des précaires.",
		"badge": {
			"text": "Passéiste",
			"color": "orange"
		},
		"parent": "progres-humain",
		"slug": "progres-humain-education",
		"relatives": [
			{
				"title": "Santé",
				"link": "progres-humain-sante"
			},
			{
				"title": "Éducation",
				"link": "progres-humain-education"
			},
			{
				"title": "Culture",
				"link": "progres-humain-culture"
			}
		]
	},
	"progres-humain-sante": {
		"title": "Santé",
		"main": false,
		"invisible": true,
		"image": "progres-humain",
		"fn": "→ [65] Garantir la Sécurité sociale pour tous les Français ainsi que le remboursement de l’ensemble des risques pris en charge par l’Assurance maladie(...).<br>→ [66] Relever le numerus clausus d’accès aux études de santé pour éviter le recours massif aux médecins étrangers (...).<br>→ [67] Lutter contre les déserts médicaux en instaurant un stage d’internat dans les zones concernées, en permettant aux médecins retraités d’y exercer avec des déductions de charges et en y développant les maisons de santé.<br>→ [68] Maintenir au maximum les hôpitaux de proximité et augmenter les effectifs de la fonction publique hospitalière.<br>→ [69] Créer un cinquième risque de Sécurité sociale consacré à la dépendance afin de permettre à chaque Français de se soigner et de vivre dans la dignité.<br>→ [70] Soutenir les startups françaises pour moderniser le système de santé.<br>→ [71] Réaliser des économies en supprimant l’Aide Médicale d’État réservée aux clandestins, en luttant contre la fraude (...), en baissant le prix des médicaments coûteux (...), en développant la vente à l’unité des médicaments remboursables (en imposant aux laboratoires l’adaptation de leurs chaînes de production).<br>→ [72] Protéger la complémentarité du double système de santé public et libéral. Protéger le maillage territorial des acteurs indépendants de la santé (pharmacies, laboratoires d’analyses…).<br>→ [73] Réorganiser et clarifier le rôle et les obligations des agences de sécurité sanitaire et alimentaire et assurer leur indépendance.",
		"fi": "Marine Le Pen veut supprimer l&#39;Aide Médicale d&#39;Etat (AME) &quot;réservée aux clandestins&quot; pour faire des économies. Cette aide <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/10/07/idee-recue-sur-les-migrants-3-6-ils-viennent-en-france-pour-se-faire-soigner_5009730_4355770.html\">est l&#39;équivalent de la CMU pour les plus démunis en situation irrégulière</a>, et leur bénéficier de la gratuité des soins, dans <a href=\"https://www.service-public.fr/particuliers/vosdroits/F3079\">la limite des tarifs de la sécurité sociale</a>. Les conditions d&#39;attribution ont déjà été durcies en 1993 et en 2005: Il faut maintenant être majeur, résider en permanence sur le sol français, et surtout être en-dessous du seuil de pauvreté (<a href=\"https://www.service-public.fr/particuliers/vosdroits/F3079\">9709 euros sur l&#39;année</a>). L&#39;AME est un principe <a href=\"http://www.lemonde.fr/societe/article/2010/09/28/restreindre-l-acces-aux-soins-des-immigres-un-non-sens-en-terme-de-sante-publique_1417174_3224.html\">d&#39;urgence élémentaire</a>, qui <a href=\"http://www.alternatives-economiques.fr/sante-un-diagnostic-partage-remedes-differents/00078056\">limite la diffusion d&#39;épidémies</a>. Outre le caractère inhumain et xénophobe de cette mesure, la supprimer peut avoir de graves conséquences sanitaires.</p>\n<p>Les mesures prévues par le FN contre les déserts médicaux sont insuffisantes. Le numerus clausus a déjà été relevé très significativement à <a href=\"https://www.legifrance.gouv.fr/eli/arrete/2017/1/10/AFSH1700585A/jo\">8 000</a>, contre 3 000 en 2015, et cette mesure n&#39;aura d&#39;effet qu&#39;une dizaine d&#39;années après. Les internes en médecine sont des praticiens en formation, qui n&#39;ont pas la formation ni l&#39;expérience des professionnels, et qui doivent aussi parfois travailler à côté pour financer leurs études. L&#39;incitation à l&#39;installation de médecins dans les déserts médicaux <a href=\"http://www.la-croix.com/France/Deserts-medicaux-secu-parie-lincitation-financiere-2016-09-01-1200785878\">existe déjà, et n&#39;a pas montré son efficacité</a>, en plus de faire baisser les recettes de l&#39;Etat. Contre les déserts médicaux, il faudrait <a href=\"http://www.alternatives-economiques.fr/sante-un-diagnostic-partage-remedes-differents/00078056\">notamment remettre en cause les dépassements d&#39;honoraires</a>, ce que ne prévoit pas le FN. Développer les maisons de santé est une bonne chose, mais <a href=\"http://www.jim.fr/medecin/actualites/pro_societe/e-docs/louees_par_tous_les_candidats_les_maisons_de_sante_ne_seraient_pas_la_solution_miracle__164484/document_actu_pro.phtml\">certains professionnels n&#39;apprécient pas cette forme d&#39;organisation, et elles ont souvent des problèmes de financement</a>, qui touchent aussi les professionnels qui y exercent.</p>\n<p>Rien n&#39;est prévu contre la <a href=\"http://www.liberation.fr/france/2016/11/06/l-hopital-malade-de-sa-logique-financiere_1526631\">logique de privatisation progressive des hôpitaux et leur soumission à des objectifs de rentabilité</a>, à travers notamment la <a href=\"https://www.marianne.net/societe/t2a-l-hopital-public-une-situation-intenable-pour-les-soignants\">Tarification à l&#39;activité (« T2A »)</a>. Le programme de Marine Le Pen ne prévoit non plus aucun changement en terme de prévention. Cela montre que les problèmes de santé publique n&#39;y sont pas pris au sérieux.",
		"aec": "<strong><a href=\"https://laec.fr/section/67/faire-passer-la-sante-d-abord-et-pour-tous#mesure-1\">Rembourser à 100 % les soins de santé prescrits</a></strong>, dont les soins et appareils dentaires, optiques et auditifs, faire baisser les tarifs des lunettes et appareils auditifs.<br/><br><strong><a href=\"https://laec.fr/section/67/faire-passer-la-sante-d-abord-et-pour-tous#mesure-2\">Instaurer une politique de santé publique et de prévention</a></strong>: Plan de santé environnementale (contre la pollution, interdiction des pesticides…); Implantation d&#39;un réseau sans faille de médecine du travail; Eradication des maladies chroniques liées à l&#39;alimentation; Lutte contre le logement insalubre et le mal-logement; Renforcement de la médecine scolaire et la Protection maternelle et infantile; Plan de lutte contre les maladies sexuellement transmissibles; <strong><a href=\"https://laec.fr/section/67/faire-passer-la-sante-d-abord-et-pour-tous#mesure-7\">Plan national de lutte contre la résistance microbienne</a></strong> en faisant le bilan de l&#39;élevage productiviste.<br/><br><strong><a href=\"https://laec.fr/section/67/faire-passer-la-sante-d-abord-et-pour-tous#mesure-3\">Combler les déserts médicaux</a></strong> et créer un corps de médecins généralistes fonctionnaires rémunérés pendant leurs études, afin de pallier l&#39;insuffisance de médecins dans certaines zones; <strong><a href=\"https://avenirencommun.fr/le-livret-sante/\">Développer  massivement</a></strong>  les  centres  de  santé  locaux  et pluri-professionnels.<br/><br><strong><a href=\"https://laec.fr/section/67/faire-passer-la-sante-d-abord-et-pour-tous#mesure-4\">Abolir les dépassements d&#39;honoraires</a></strong>, renforcer le paiement au forfait.<br/><br><strong><a href=\"https://laec.fr/section/67/faire-passer-la-sante-d-abord-et-pour-tous#mesure-5\">Reconstruire le service public hospitalier</a></strong>, revenir sur la tarification à l&#39;acte et les suppressions de lits et de personnels, et engager un plan pluriannuel de <strong><a href=\"https://avenirencommun.fr/le-livret-sante/\">recrutement de 62 500 médecins, infirmiers, aides-soignants et personnels administratifs</a></strong>.<br/><br><strong><a href=\"https://laec.fr/section/67/faire-passer-la-sante-d-abord-et-pour-tous#mesure-6\">Créer un pôle public du médicament</a></strong> pour faciliter l&#39;égal accès aux traitements, protéger la recherche de la finance et supprimer l&#39;influence des entreprises privées dans les activités médicales et hospitalières, notamment par l&#39;arrêt de l&#39;accès libre des visiteurs médicaux à l&#39;hôpital public<br/><br> <strong><a href=\"https://avenirencommun.fr/le-livret-sante/\">Lutter contre les dépenses inutiles</a></strong> en définissant démocratiquement un périmètre de la solidarité de tous les biens et services médicaux dont l’utilité médicale est reconnue.",
		"badge": {
			"text": "Insuffisant",
			"color": "orange"
		},
		"parent": "progres-humain",
		"slug": "progres-humain-sante",
		"relatives": [
			{
				"title": "Santé",
				"link": "progres-humain-sante"
			},
			{
				"title": "Éducation",
				"link": "progres-humain-education"
			},
			{
				"title": "Culture",
				"link": "progres-humain-culture"
			}
		]
	},
	"progres-humain": {
		"title": "Progrès humain",
		"main": true,
		"image": "progres-humain",
		"pos": 7,
		"intro": "Pour le Front National, progrès humain rime avec préservation de l&#39;identité nationale. Une identité reposant entre autre sur le « roman national » de l&#39;Histoire de France, qui ferait de cette Histoire <a href=\"http://www.leshistoriensdegarde.fr/preuve-source/introduction/\">une fiction</a>, dont  Marine Le Pen voudrait mettre en avant<a href=\"http://la1ere.francetvinfo.fr/2013/02/28/marine-le-pen-pour-un-enseignement-des-aspects-positifs-de-la-colonisation-17719.html\"> les « éléments les plus glorieux », comme les « aspects positifs » de la colonisation</a>.<br>La logique de repli le conduit à proposer des mesures discriminatoires et inégalitaires. Comme sur beaucoup de thèmes, en matière de santé, le FN en profite pour s&#39;en prendre aux immigrés en voulant supprimer l&#39;Aide Medicale d&#39;Etat, qui d&#39;après Nicolas Bay, <a href=\"http://lelab.europe1.fr/Le-Front-national-s-empare-des-sans-dents-de-Francois-Hollande-16402\">« permet aux clandestins de ne pas être des &quot;sans-dents&quot; »</a>. Pour l&#39;éducation, Marine Le Pen a défendu la<a href=\"http://www.lefigaro.fr/elections/presidentielles/2016/12/08/35003-20161208ARTFIG00201-marine-le-pen-veut-restreindre-l-acces-des-enfants-d-etrangers-a-l-ecole-gratuite.php\"> fin de la scolarisation automatique et gratuite pour les enfants de clandestins</a>, mais a finalement retiré cette mesure.<br>Défendant toujours des solutions très libérales économiquement, le FN veut mettre en place un contrôle et un encadrement des soins, de l&#39;éducation, de la culture, sous prétexte de répondre à des attentes légitimes d&#39;élargissement des droits. Mais il s&#39;agit bien d&#39;asservir ces domaines du progrès humain à l&#39;idéologie d&#39;enfermement sur soi et de rejet des autres cultures, des autres civilisations qui font pourtant la richesse humaine.",
		"subs": [
			{
				"title": "Santé",
				"link": "progres-humain-sante"
			},
			{
				"title": "Éducation",
				"link": "progres-humain-education"
			},
			{
				"title": "Culture",
				"link": "progres-humain-culture"
			}
		],
		"slug": "progres-humain"
	},
	"securite-justice-defense-defense": {
		"title": "Défense",
		"main": false,
		"invisible": true,
		"image": "securite-justice-defense",
		"fn": "→ [118] Quitter le commandement militaire intégré de l’OTAN pour que la France ne soit pas entraînée dans des guerres qui ne sont pas les siennes<br>→ [120] Reconstituer dans tous les domaines de la Défense une offre industrielle française pour répondre aux besoins de nos armées et garantir notre indépendance stratégique.<br>→ [121] Augmenter dès la première année du mandat le budget de la Défense à 2 % du P.I.B. puis tendre vers 3 % à l’horizon de la fin du quinquennat<br>→ [121.1] Un second porte-avions baptisé « Richelieu », indispensable à la permanence à la mer de notre groupe aéronaval<br>→ [121.3] La pérennisation de notre force de dissuasion nucléaire;<br>→ [121.4] L’augmentation générale de notre format d’armée (davantage d’avions, de navires, de blindés) et la modernisation des équipements ;",
		"fi": "Le FN veut acquérir un porte-avion <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/01/26/mais-combien-ca-coute-en-vrai-un-porte-avions_1544198\">d’une valeur d&#39;environ 4,5 milliards d’euros</a> et de nombreux équipements, alors que des <a href=\"http://www.latribune.fr/entreprises-finance/industrie/aeronautique-defense/le-prochain-fusil-de-l-armee-francaise-sera-allemand-598514.html\">commandes sont déjà en cours</a>. Le parti promet une sortie du commandement militaire intégré de l’OTAN mais adhère au principe du <a href=\"http://www.ladepeche.fr/article/2017/03/31/2547807-otan-tillerson-exige-europe-depense-plus-defense.html\">« au moins 2 % du P.I.B. pour la défense de chaque pays membre »</a> que cette organisation exige, et va même bien plus loin. Amener le budget de la défense à 2% du PIB représenterait 7 milliards  de dépenses supplémentaires la 1ère année, pour monter à <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/05/01/comment-le-fn-deshabille-le-budget_1566602\">24 milliards/an d&#39;ici 2022</a> pour atteindre les 3%. Se pose alors le problème du financement, alors que <a href=\"http://analysonslefn.fr/themes/economie-finance-budget\">le budget présenté par le FN n&#39;a rien d&#39;équilibré</a>. De plus, il semble que le ministère de la Défense ne soit <a href=\"http://www.latribune.fr/entreprises-finance/industrie/aeronautique-defense/marine-le-pen-promet-un-effort-de-defense-a-3-du-pib-en-2022-669351.html\">pas en capacité de dépenser autant d&#39;argent aussi vite</a>.</p>\n<p>Ces hausses spectaculaires du budget militaire entraineraient une militarisation massive du pays qui nous paraît dangereuse. Nous ne savons pas vraiment au service de quelle politique étrangère elle se ferait, puisque celle-ci est quasi inexistante avec seulement 3 des 144 propositions du programme du FN. On peut donc s&#39;inquiéter de l&#39;absence d&#39;une politique cohérente et d&#39;une véritable stratégie dans ce domaine.</p>\n<p>L’arsenal nucléaire français est déjà <a href=\"http://www.lemonde.fr/les-decodeurs/article/2015/02/21/de-quoi-l-arsenal-nucleaire-de-la-france-est-il-compose_4580740_4355770.html\">important</a> et <a href=\"http://www.letelegramme.fr/france/nucleaire-la-bombe-en-sept-questions-03-11-2016-11278292.php\">constitué de centaines de bombes de 100kt</a>.  Son renouvellement augmente encore les risques d&#39;accidents nucléaires, qui ne sont  d&#39;ailleurs pas si rare puisque <a href=\"http://www.irenees.net/bdf_fiche-analyse-1049_fr.html\">toutes les puissances nucléaires ont déjà fait face à un accident de ce type </a>, avec des <a href=\"http://www.irenees.net/bdf_fiche-analyse-1049_fr.html\">conséquences terribles</a>.",
		"aec": "<strong><a href=\"https://laec.fr/s54m2\">Sortir de l&#39;Otan</a></strong> et refuser la participation de la France à toute alliance militaire permanente à l&#39;exception des opérations de maintien de la paix sous l&#39;égide de l&#39;Onu; <a href=\"https://avenirencommun.fr/livret-garde-nationale-defense/\">Retirer</a> la France de l’Europe de la défense ; <a href=\"https://avenirencommun.fr/livret-garde-nationale-defense/\">Mettre des moyens</a> pour former une force militaire onusienne permanente ; et de faire vivre le comité d’état-major de l’ONU pour commander les opérations de maintien de la paix ;<br><strong><a href=\"https://laec.fr/s55m1\">Rédiger un nouveau Livre blanc</a></strong> et adopter une nouvelle loi de programmation militaire ayant pour objectif la restauration pleine et entière de l&#39;indépendance militaire.<br><strong><a href=\"https://laec.fr/s55m2\">Stopper les programmes de privatisation</a></strong> des industries d&#39;armement et des missions de défense nationale et engager leur reconquête publique  ; Établir la règle de<a href=\"https://laec.fr/s55m3\"> l&#39;acquisition de matériel militaire français</a> par l&#39;armée (armement et fournitures).<br><strong><a href=\"https://laec.fr/s60m2\">Mettre en place une coalition universelle sous mandat de l&#39;Onu pour éradiquer Daech</a></strong> et rétablir la paix et la stabilité en Syrie et en Irak, associant les combattants kurdes.<br><strong><a href=\"https://avenirencommun.fr/livret-garde-nationale-defense/\">De nouveaux investissements</a></strong> seront nécessaires, et un coup d’arrêt immédiat sera porté à la diminution des effectifs combattants professionnels. Le recrutement sera élargi en compensation de ces coupes austéritaires ; Ouverture d’un <a href=\"https://avenirencommun.fr/livret-garde-nationale-defense/\">débat sur le droit à la syndicalisation</a> des militaires.<br><strong><a href=\"https://avenirencommun.fr/livret-garde-nationale-defense/\">Fin de l’opération Sentinelle</a></strong>, coûteuse et inefficace dans la lutte contre le terrorisme, et à toute autre forme de militarisation de la sécurité intérieure.<br>Ouvrir la possibilité d&#39;effectuer son <strong><a href=\"https://laec.fr/s55m4\">service citoyen obligatoire sous la forme d&#39;un service militaire</a></strong> de 9 mois rémunéré au smic ; <a href=\"https://avenirencommun.fr/livret-garde-nationale-defense/\">Renouvellement de la Garde nationale</a> qui sera placée sous commandement civil et mobilisable en cas de crise sécuritaire, écologique et industrielle, affectée à la sécurité des installations d’importance vitale pour la nation, et au renforcement des capacités de cyberdéfense.<br><strong><a href=\"https://avenirencommun.fr/livret-garde-nationale-defense/\">Relancer les processus multilatéraux de désarmement nucléaire</a></strong> et conventionnel dans le cadre de la Conférence du désarmement de l’ONU ; Mais la dissuasion nucléaire restera un élément de notre protection en l’absence d’accord de désarmement multilatéral.<br><strong><a href=\"https://avenirencommun.fr/livret-garde-nationale-defense/\">Mettre fin à la « Françafrique »</a></strong> et révision de nos accords militaires avec les pays africains.",
		"badge": {
			"text": "Inquiétant",
			"color": "orange"
		},
		"parent": "securite-justice-defense",
		"slug": "securite-justice-defense-defense",
		"relatives": [
			{
				"title": "Sécurité",
				"link": "securite-justice-defense-securite"
			},
			{
				"title": "Justice",
				"link": "securite-justice-defense-justice"
			},
			{
				"title": "Terrorisme",
				"link": "securite-justice-defense-terrorisme"
			},
			{
				"title": "Défense",
				"link": "securite-justice-defense-defense"
			}
		]
	},
	"securite-justice-defense-justice": {
		"title": "Justice",
		"main": false,
		"invisible": true,
		"image": "securite-justice-defense",
		"fn": "→ [17] Appliquer la tolérance zéro et en finir avec le laxisme judiciaire par l’abrogation des lois pénales laxistes (comme la loi Taubira), le rétablissement des peines planchers et la suppression des remises de peine automatiques.<br>→ [18] Lutter contre la délinquance des mineurs en responsabilisant les parents par la suppression du versement des aides sociales aux parents de mineurs récidivistes en cas de carence éducative manifeste.<br>→ [19] Instaurer une peine de prison de perpétuité réelle incompressible pour les crimes les plus graves.<br>→ [20] Créer 40000 places supplémentaires de prison en 5 ans.<br>→ [21] Rétablir l’expulsion automatique des criminels et des délinquants étrangers. Mettre en place des accords bilatéraux permettant que les étrangers condamnés purgent leur peine dans leur pays d’origine.<br>→ [22] Rattacher l’administration pénitentiaire au ministère de l’Intérieur et renforcer le renseignement pénitentiaire.<br>→ [23] Augmenter le nombre de postes de magistrats, notamment par un recrutement au tour extérieur. Afin de rompre avec la culture du laxisme, supprimer l’École Nationale de la Magistrature et créer une filière de formation commune aux carrières judiciaires (avec des écoles d’application).",
		"fi": "La peine de prison à perpétuité « réelle » ou « incompressible » <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/01/12/la-perpetuite-reelle-existe-t-elle-en-france_4846127_4355770.html\">existe déjà depuis 1994, pour certains cas</a> assez rares. La <a href=\"https://fr.wikipedia.org/wiki/R%C3%A9tention_de_s%C3%BBret%C3%A9_en_France\">rétention de sûreté</a> permet aussi la détention à vie. Il y a actuellement <a href=\"http://www.justice.gouv.fr/art_pix/mensuelle_avril_2017.pdf\">un peu plus de 70 000 détenu-e-s</a> en France, et 40 000 places supplémentaires serait une hausse énorme de presque 60%. On peut donc craindre une certaine criminalisation de la société avec cette doctrine de la « tolérance zéro ». Et s&#39;interroger sur le coût de la mesure, alors que Jean-Jacques Urvoas <a href=\"http://tempsreel.nouvelobs.com/justice/20160920.OBS8379/prisons-urvoas-promet-10-000-a-16-000-nouvelles-cellules.html\">demandait déjà un peu plus d&#39;1 milliards pour créer moins de 7000 places</a>.</p>\n<p><a href=\"https://www.legifrance.gouv.fr/affichTexte.do?cidTexte=JORFTEXT000029362502&amp;categorieLien=id\">La « loi Taubira » de 2014</a> partait du principe que la peine judiciaire doit servir un but de réinsertion et d&#39;éducation des coupables. Elle était aussi motivée par une <a href=\"http://www.europe1.fr/societe/la-surpopulation-carcerale-en-cinq-chiffres-2816041\">densité carcérale très élevée</a>, 119% en 2016, jusqu&#39;à 200%, avec parfois 3 ou 4 détenus dans des cellules de 9 m². Mais parler de « laxisme » semble très exagéré quand il y a eu 4000 emprisonnements supplémentaires entre 2012 et 2017 (de <a href=\"http://www.lepoint.fr/chroniqueurs-du-point/laurence-neuer/la-prison-en-chiffres-27-10-2012-1521704_56.php\">plus de 66 000</a>  à <a href=\"http://www.justice.gouv.fr/art_pix/mensuelle_avril_2017.pdf\">plus de 70 000</a>) , et que C. Taubira a fait voter la <a href=\"http://tempsreel.nouvelobs.com/justice/20160920.OBS8379/prisons-urvoas-promet-10-000-a-16-000-nouvelles-cellules.html\">construction de 6.500 places de prison</a>.</p>\n<p>Les parents de mineurs récidivistes sont souvent déjà pauvres, et les appauvrir encore plus ne les aidera certainement pas à mieux éduquer leurs enfants, en plus de les stigmatiser et de nier la responsabilité de la société. Passer des accords bilatéraux avec chaque pays d&#39;origine des délinquants serait long et fastidieux, alors que les détenus étrangers sont minoritaires (<a href=\"http://www.midilibre.fr/2014/06/04/justice-20-d-etrangers-en-prison-cible-de-discriminations,1001816.php\">moins de 20%</a>). Surtout, <a href=\"https://www.mediapart.fr/journal/france/230317/programme-du-fn-9-une-obsession-securitaire-tres-mal-renseignee\">la justice ne peut pas être automatique</a> et les procédures d’expulsion et d’extradition ne peuvent être arbitraires, mais doivent être examinées au cas par cas.</p>\n<p>Rattacher l&#39;administration pénitentiaire au ministère de la justice remettrait en cause l&#39;indépendance de la justice. En démocratie, la peine de prison est liée à une décision de justice, et non à une décision administrative. Les juges d&#39;application des peines et les conseillers d’insertion et de probation <a href=\"https://www.mediapart.fr/journal/france/230317/programme-du-fn-9-une-obsession-securitaire-tres-mal-renseignee\">dépendent aussi du ministère de la justice</a>. Le FN ne propose rien de précis aussi pour remplacer l&#39;Ecole Nationale de la Magistrature, sans doute trop indépendante à son goût.",
		"aec": "<strong><a href=\"https://laec.fr/s11m2\">Mettre fin à la paupérisation de la justice &amp; de l&#39;administration pénitentiaire</a></strong> :<br>-&nbsp;Mettre en œuvre un plan de recrutement de personnels pour désengorger les tribunaux,  en <a href=\"https://avenirencommun.fr/le-livret-justice/\">recrutant 18 000 magistrats, greffiers et personnels administratifs</a>.<br>-&nbsp;Rénover et construire de nouveaux locaux pour les tribunaux.<br>-&nbsp;Recruter 2 000 agents pénitentiaires pour les escortes des détenus.<br>-&nbsp;Mettre fin au tout-carcéral par des peines alternatives à la prison, rénover les prisons pour garantir la dignité humaine, assurer la socialisation des détenus.<br><strong><a href=\"https://laec.fr/s11m3\">Remplacer</a></strong> les instructions ministérielles au Parquet par des lois d&#39;orientation de politique pénale, débattues et votées par le Parlement.<br><strong><a href=\"https://laec.fr/s11m4\">Remplacer le Conseil supérieur de la magistrature par un Conseil supérieur de la justice</a></strong> désigné pour partie par les magistrats et le Parlement, devant lequel il sera responsable.<br><strong><a href=\"https://avenirencommun.fr/le-livret-justice/\">Supprimer la Cour de justice de la République</a></strong>, juridiction d’exception en charge de juger de la responsabilité pénale des ministres (pour les actes commis dans le cadre de leurs fonctions).<br><strong><a href=\"https://avenirencommun.fr/le-livret-justice/\">Supprimer</a></strong> la possibilité pour les magistrat·e·s de passer du parquet au « siège », c’est-à-dire d’être procureur puis juge ; <a href=\"https://avenirencommun.fr/le-livret-justice/\">Renforcement de l’indépendance des juges d’instruction</a> par la collégialité et le détachement d’officiers de police judiciaire auprès des juridictions, sur la base du volontariat et pour une période de trois ans renouvelable.<br><strong><a href=\"https://avenirencommun.fr/le-livret-justice/\">Renforcer</a></strong> la lutte contre la corruption, la délinquance en « col blanc », les infractions sanitaires, environnementales et de droit pénal du travail.<br><strong><a href=\"https://laec.fr/s11m1\">Garantir</a></strong> la protection judiciaire de la jeunesse, la justice des mineurs, la politique de prévention de la délinquance et les sanctions éducatives.<br><strong><a href=\"https://avenirencommun.fr/le-livret-justice/\">Priorité donnée aux mesures alternatives à l’emprisonnement</a></strong> et aux services pénitentiaires d’insertion et de probation en charge de leur suivi.<br><strong><a href=\"https://avenirencommun.fr/le-livret-justice/\">Abolir la rétention de sûreté</a></strong>, qui consiste à placer un criminel dans un centre de sûreté après sa peine de prison sur la base d’un supposé « risque » de dangerosité.",
		"badge": {
			"text": "Dangereux",
			"color": "red"
		},
		"parent": "securite-justice-defense",
		"slug": "securite-justice-defense-justice",
		"relatives": [
			{
				"title": "Sécurité",
				"link": "securite-justice-defense-securite"
			},
			{
				"title": "Justice",
				"link": "securite-justice-defense-justice"
			},
			{
				"title": "Terrorisme",
				"link": "securite-justice-defense-terrorisme"
			},
			{
				"title": "Défense",
				"link": "securite-justice-defense-defense"
			}
		]
	},
	"securite-justice-defense-securite": {
		"title": "Sécurité",
		"main": false,
		"invisible": true,
		"image": "securite-justice-defense",
		"fn": "→ [12] Rétablir la sécurité en veillant à la protection des libertés individuelles.<br>→ [13] Réarmer massivement les forces de l’ordre : en personnels (plan de recrutement de 15 000 policiers et gendarmes), en matériels (...), mais aussi moralement et juridiquement (notamment par la présomption de légitime défense). Garantir le statut militaire des gendarmes.<br>→ [14] Recentrer la police et la gendarmerie sur leur mission de sécurité publique en les libérant des tâches indues et administratives.<br>→ [15] Mettre en place un plan de désarmement des banlieues concernées et de reprise en main par l’État des zones de non-droit. Cibler les 5 000 chefs de bandes délinquantes et criminelles identifiées par le ministère de l’Intérieur. Afin d’empêcher leur reconstitution, instaurer en complément de la peine pénale l’injonction civile d’éloignement.<br>→ [16] Rétablir des services de renseignement de terrain pour lutter contre les trafics criminels.",
		"fi": "<a href=\"http://www.ladocumentationfrancaise.fr/var/storage/rapports-publics/134000185.pdf\">12 000 postes de policiers et gendarmes ont été supprimés</a> sous Sarkozy, tandis que  <a href=\"http://www.interieur.gouv.fr/Publications/Rapports-de-l-IGA/Rapports-recents-classes-par-date-de-mise-en-ligne/Evolution-des-effectifs-de-la-police-et-de-la-gendarmerie-nationales\">9 000</a> ont été créés sous Hollande. En promettant 15 000 postes supplémentaires, Marine Le Pen porterait les forces de sécurité à un nombre jamais égalé sous la Ve République. Mais la hausse de budget n&#39;est pas vraiment prévue dans <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">le chiffrage</a> du programme. Le programme ne remet pas en cause la <a href=\"https://www.franceinter.fr/societe/secrets-d-info\">politique « big data » de la DGSI</a> qui mise sur le tout numérique et le rassemblement de mégadonnées, comme le permet <a href=\"http://www.assemblee-nationale.fr/14/ta/ta0542.asp\">la récente loi relative au renseignement</a>, loi <a href=\"https://www.les-crises.fr/loi-sur-le-renseignement-tout-le-monde-sen-fiche-et-pourtant/\">liberticide</a> que le FN ne compte pas réviser. Quant à la présomption de légitime défense, elle a déjà été adoptée <a href=\"http://www.assemblee-nationale.fr/14/dossiers/securite_publique.asp\">début 2017</a>, et a déjà démontré son <a href=\"http://www.liberation.fr/france/2017/01/25/christine-lazerges-l-etat-d-urgence-cree-du-rejet-et-in-fine-des-discriminations_1544073\">danger pour la protection des libertés individuelles</a>. Marine Le Pen ne compte pas revenir non plus sur l&#39;état d&#39;urgence, pourtant <a href=\"http://www.latribune.fr/economie/france/un-an-apres-le-bilan-mitige-de-l-etat-d-urgence-624593.html\">peu efficace</a>, et soutient l&#39;<a href=\"https://www.publicsenat.fr/lcp/politique/etat-durgence-marine-pen-linterdiction-des-manifestations-1356378\">interdiction des manifestations</a> durant celui-ci.</p>\n<p>Aucune mesure ne répond à la <a href=\"http://www.assemblee-nationale.fr/14/rap-info/i4487.asp\">situation difficile</a> des forces de l&#39;ordre depuis l&#39;instauration de l&#39;état d&#39;urgence et de l&#39;opération Sentinelle : Heures supplémentaires, épuisement, taux de suicide, etc. Les tensions entre forces de l&#39;ordre et civils ne sont pas non plus abordées. Sur plusieurs affaires, le FN tient des positions inquiétantes : absence de déclaration sur l&#39;affaire Adama Traoré ; <a href=\"http://www.frontnational.com/2014/10/concernant-la-situation-a-sivens/\">Tient pour responsable les manifestants</a> de la mort de Rémi Fraisse ; <a href=\"http://www.liberation.fr/video/2017/02/07/marine-le-pen-ne-condamne-pas-les-violences-policieres-a-aulnay-sous-bois_1546837\">Ne condamne pas les violences policières</a> dans l&#39;affaire Theo et <a href=\"http://www.francetvinfo.fr/faits-divers/arrestation-violente-a-aulnay-sous-bois/affaire-theo-une-petition-du-fn-pour-soutenir-la-police_2059055.html\">lance une pétition de soutien à la police</a> sans attendre les conclusions de l&#39;enquête.</p>\n<p>L&#39;injonction civile d&#39;éloignement a déjà prouvé son inefficacité dans la lutte contre les trafics et ne contribue qu&#39;à déplacer le problème. Marine Le Pen est pour une <a href=\"http://www.cnewsmatin.fr/france/2017-05-03/depenalisation-du-cannabis-la-position-de-marine-le-pen-744487\">répression totale du cannabis</a>, excluant d&#39;office sa légalisation, thématique pourtant <a href=\"http://www.konbini.com/fr/tendances-2/infographie-legalisation-cannabis-etats-unis/\">en lien avec la lutte contre le trafic</a>. En général, le FN adopte une attitude purement répressive, là où il faudrait allier répression et prévention, et rapprocher la population et les forces de sécurité, tout en s&#39;attaquant en même temps à des problèmes de fond comme la pauvreté ou le chômage.",
		"aec": "<strong><a href=\"https://laec.fr/section/12/une-politique-antiterroriste-rationnelle#mesure-3\">Réaffirmer l&#39;État de droit</a></strong>. Permettre la sortie de l&#39;état d&#39;urgence ; Évaluer les lois antiterroristes existantes ; Arrêter progressivement les opérations <em>Sentinelle</em> pour confier la sécurité des lieux publics à la police ; Augmenter les moyens de la justice pour garantir une lutte respectueuse des droits et libertés fondamentaux.<br><strong><a href=\"https://laec.fr/section/13/garantir-la-securite-et-la-surete#mesure-1\">Refonder la politique de sûreté publique</a></strong> sur la base du triptyque prévention, dissuasion, sanction et réaffirmer son caractère national. Restaurer la police de proximité ; Abroger les dispositions inefficaces liées aux lois sécuritaires. <a href=\"https://avenirencommun.fr/le-livret-securite/\">Fin de la politique du chiffre</a> et suppression des primes aux résultats. Les montants seront redistribués via une hausse des salaires de façon progressive aux différentes catégories d’agents.<br><strong><a href=\"https://laec.fr/section/13/garantir-la-securite-et-la-surete#mesure-2\">Restaurer une police républicaine</a></strong>. Augmenter les effectifs de police en charge de la délinquance financière et du démantèlement des trafics ; Désencombrer l&#39;action policière par la contraventionnalisation de la consommation de stupéfiants et la légalisation de l&#39;usage du cannabis.<br><strong><a href=\"https://laec.fr/section/13/garantir-la-securite-et-la-surete#mesure-3\">Renforcer les moyens humains et matériels des forces de sécurité</a></strong>. Recruter <a href=\"https://avenirencommun.fr/le-livret-securite/\">5 000 agents administratifs</a> pour libérer les policiers et gendarmes aptes à aller sur le terrain, <a href=\"https://avenirencommun.fr/le-livret-securite/\">3 000 agents</a> de police ou gendarmerie ; Doubler les effectifs de la police technique et scientifique ; <a href=\"https://avenirencommun.fr/le-livret-securite/\">Titulariser des adjoints de sécurité</a> précaires qui le souhaitent ; Construire et rénover les commissariats de police pour lutter contre l&#39;abandon de certains territoires ; Renouveler le parc informatique.<br><strong><a href=\"https://laec.fr/section/14/la-jeunesse-au-service-de-l-interet-general-et-de-la-surete-de-la-nation#mesure-2\">Créer une garde nationale placée sous commandement civil</a></strong> et composée : Des jeunes en service citoyen obligatoire ayant choisi d&#39;intégrer la réserve ; Des unités existantes labellisées : réserve de sécurité nationale, réserve de sécurité civile, réserve citoyenne.",
		"badge": {
			"text": "Dangereux",
			"color": "red"
		},
		"parent": "securite-justice-defense",
		"slug": "securite-justice-defense-securite",
		"relatives": [
			{
				"title": "Sécurité",
				"link": "securite-justice-defense-securite"
			},
			{
				"title": "Justice",
				"link": "securite-justice-defense-justice"
			},
			{
				"title": "Terrorisme",
				"link": "securite-justice-defense-terrorisme"
			},
			{
				"title": "Défense",
				"link": "securite-justice-defense-defense"
			}
		]
	},
	"securite-justice-defense-terrorisme": {
		"title": "Terrorisme",
		"main": false,
		"invisible": true,
		"image": "securite-justice-defense",
		"fn": "→ [29] Interdire et dissoudre les organismes de toute nature liés aux fondamentalistes islamistes. Expulser tous les étrangers en lien avec le fondamentalisme islamiste (notamment les fichés S).<br>→ [30] Fermer toutes les mosquées extrémistes recensées par le ministère de l’Intérieur et interdire le financement étranger des lieux de culte et de leur personnel. Interdire tout financement public (État, collectivités territoriales…) des lieux de culte et des activités cultuelles.<br>→ [31] Lutter contre les filières djihadistes : déchéance de la nationalité française, expulsion et interdiction du territoire pour tout binational lié à une filière djihadiste. Appliquer l’article 411-4 du Code pénal sur l’intelligence avec l’ennemi et placer en détention préventive tout individu de nationalité française en lien avec une organisation étrangère suscitant des actes d’hostilité ou d’agression contre la France et les Français. Établir la liste de ces organisations.<br>→ [32] Rétablir l’indignité nationale pour les individus coupables de crimes et délits liés au terrorisme islamiste.<br>→ [33] Renforcer les moyens humains et techniques des services de renseignement intérieurs<br>et extérieurs et créer une agence unique de lutte antiterroriste rattachée directement au<br>Premier ministre, chargée de l’analyse de la menace et de la coordination opérationnelle.",
		"fi": "Ce problème est avant tout international. Sur la guerre en Syrie, Marine Le Pen considère que <a href=\"http://www.europe1.fr/international/pour-le-pen-bachar-al-assad-est-la-seule-solution-viable-en-syrie-2983205\">Bachar Al-Assad est la seule « solution viable en Syrie »</a>, et le FN ne propose aucun soutien à l&#39;ONU ou au <a href=\"http://www.lefigaro.fr/international/2016/12/31/01003-20161231ARTFIG00128-le-conseil-de-securite-soutient-a-l-unanimite-l-initiative-de-paix-de-moscou-et-ankara.php\">processus de Genève</a> pour une paix durable. Sa candidate n&#39;évoque pas non plus l&#39;affaire du cimentier Lafarge, qui, entre 2013 et 2014, <a href=\"http://www.lemonde.fr/proche-orient/article/2017/03/02/syrie-lafargeholcim-reconnait-que-son-usine-a-finance-des-groupes-armes_5087906_3218.html\">a commercé en Syrie avec l&#39;EI</a>, et est aussi <a href=\"http://www.la-croix.com/Economie/Monde/La-responsabilite-Lafarge-Syrie-2017-04-24-1200842032\">soupçonné de l&#39;avoir fait avec le régime syrien</a>. <a href=\"http://www.lemonde.fr/politique/article/2017/05/03/un-candidat-du-fn-implique-dans-les-negociations-de-lafarge-avec-l-etat-islamique_5121617_823448.html\">D&#39;après Mediapart</a>, l’un des dirigeants du groupe impliqué dans les négociations était d&#39;ailleurs candidat FN aux dernières municipales à Paris.</p>\n<p>Les « organismes liés aux fondamentalistes » sont déjà <a href=\"http://www.associations.gouv.fr/1006-dissoudre-une-association.html#cas-8f2a79-4\">interdits</a> et <a href=\"http://www.la-croix.com/Religion/Islam/Dissolution-de-trois-associations-cultuelles-liees-a-la-mosquee-de-Lagny-2016-01-13-1404007\">dissous</a>, les « mosquées extrémistes » <a href=\"http://www.rtl.fr/actu/societe-faits-divers/terrorisme-etat-d-urgence-operation-sentinelle-un-bilan-mitige-pour-des-mesures-critiquees-7783973780\">déjà fermées</a>, et le financement public des lieux de culte <a href=\"http://www.slate.fr/story/121757/infographie-lieux-de-culte-france\">déjà interdit avec la loi de 1905</a>. Quant aux financements étrangers, ils sont <a href=\"http://www.huffingtonpost.fr/2016/07/31/islam-financement-etranger-mosquees-imams-solution-miracle_n_11285558.html\">minoritaires (20 à 30%)</a>, et ne concernent <a href=\"http://www.la-croix.com/Religion/Judaisme/Quatre-questions-financement-lieux-culte-depuis-letranger-2016-09-02-1200786295\">pas que les mosquées</a>. Ceux venant d&#39;Etats étrangers sont <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/07/29/comment-est-organise-l-islam-de-france_4976389_4355770.html\">« faibles » et concentrés sur environ une vingtaine de mosquées</a>, la <a href=\"http://www.huffingtonpost.fr/2016/07/31/islam-financement-etranger-mosquees-imams-solution-miracle_n_11285558.html\">plupart non radicales</a>. Le plus important est finalement de pouvoir <a href=\"http://www.lemonde.fr/religions/article/2016/08/01/on-ne-reglera-pas-les-problemes-de-l-islam-en-france-en-suspendant-le-financement-etranger-des-mosquees_4977157_1653130.html\">contrôler ces financements</a>. La plupart des jihadistes ayant frappé la France n&#39;étaient d&#39;ailleurs <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/07/29/comment-est-organise-l-islam-de-france_4976389_4355770.html\">pas des salafistes ayant étudié longtemps le Coran, mais des jeunes délinquants radicalisés en prison ou sur internet</a>.</p>\n<p>Pour les fichés S, Marine Le Pen a déclaré vouloir expulser « l’intégralité des  étrangers », et condamner « <a href=\"http://www.lci.fr/elections/les-fiches-s-seront-juges-pourquoi-la-proposition-de-marine-le-pen-sur-le-terrorisme-pose-question-2027452.html\">à des peines de prison</a> » les français. Mais la fiche S n&#39;est qu&#39;une fiche de renseignement, regroupant des personnes soupçonnées de visées terroristes, ou de complicité, qui <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/04/20/marine-le-pen-divague-encore-sur-les-fiches-s_1563798\">peuvent aussi n&#39;être que de simples relations de personnes visées, suivies dans un but de renseignement</a>. De plus, environ <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/04/20/marine-le-pen-divague-encore-sur-les-fiches-s_1563798\">la moitié </a> d&#39;entre eux ne sont pas liés au terrorisme. Et en l&#39;absence de délit, un juge ne peut pas condamner quelqu&#39;un, ni le placer en « détention préventive ».  Quant à l&#39;article 411-4, il s&#39;applique surtout aux cas d&#39;espionnages, <a href=\"http://www.huffingtonpost.fr/2016/06/14/article-411-4-code-penal-pourquoi-pas-application-terroristes-reclame-marine-le-pen-les-republicains_n_10452270.html\">d&#39;autres chefs d&#39;inculpations sont utilisés depuis longtemps</a>, permettant d&#39;enquêter en même temps sur des étrangers. Enfin, le FN ne compte pas non plus remettre en cause l&#39;Etat d&#39;urgence, pourtant <a href=\"http://www.latribune.fr/economie/france/un-an-apres-le-bilan-mitige-de-l-etat-d-urgence-624593.html\">peu efficace</a> dans la lutte contre le terrorisme, en plus d&#39;être liberticide.",
		"aec": "Mise en oeuvre d’une <strong><a href=\"https://laec.fr/s60m3\">stratégie globale de lutte contre Daesh</a></strong> « hors limites » et la création d’une coalition universelle sous l’égide de l’ONU ciblant les composantes économiques (blanchiment d’argent, ressources pétrolières, approvisionnement, internet) ; <strong><a href=\"https://avenirencommun.fr/le-livret-securite/\">Renforcer et réinvestir l&#39;ONU, soutenir le processus de Genève</a></strong> et adopter, sur le conflit syrien, une position indépendante ayant pour seul objectif un règlement politique du conflit.<br/><br><strong><a href=\"https://laec.fr/s60m1\">Réviser les alliances hypocrites avec les pétromonarchies du Golfe</a></strong> (Qatar, Arabie saoudite…) et le régime turc actuel, tarir les financements des terroristes.<br/><br>Améliorer la prévention en engageant une stratégie politique pour <strong><a href=\"https://avenirencommun.fr/le-livret-securite/\">renforcer les anticorps républicains et supprimer le terreau des communautarismes</a></strong> par plus de République, de laïcité, d&#39;éducation, de justice sociale et d&#39;implication citoyenne. Soutien aux démarches de signalement par les proches permettra l’intégration des personnes suspectées dans des programmes de prise en charge contre l’embrigadement.<br/><br><strong><a href=\"https://laec.fr/s12m4\">Renforcer le renseignement territorial et humain en revenant sur la fusion de la DST et des RG</a></strong>, en privilégiant l&#39;infiltration par rapport au tout technologique, renforcer les moyens d&#39;analyse des renseignements collectés  ; <strong><a href=\"https://avenirencommun.fr/le-livret-securite/\">Focalisation du renseignement sur les menaces sécuritaires et économiques</a></strong>, et non sur la surveillance des mouvements sociaux.<br/><br>Instaurer une <strong><a href=\"https://laec.fr/s12m6\">peine de déchéance des droits civiques</a></strong> en cas de fraude fiscale ou d&#39;activités illicites permettant le financement d&#39;activités terroristes, punir les financements des trafics alimentant les réseaux terroristes et réquisitionner les entreprises qui collaborent avec les agresseurs  ; <strong><a href=\"https://avenirencommun.fr/le-livret-securite/\">Augmenter nettement les effectifs de police en charge de la délinquance en col blanc</a></strong> en lien avec le fisc, les douanes et la justice financière, en donnant la priorité au démantèlement des trafics et à la lutte contre la délinquance financière, la corruption et le terrorisme.<br/><br><strong><a href=\"https://avenirencommun.fr/le-livret-securite/\">Sortie de l’état d’urgence</a></strong> à l’initiative du Parlement et refus de l’État d’urgence permanent par l’abrogation des dispositions de la loi Urvoas ; <strong><a href=\"https://avenirencommun.fr/le-livret-securite/\">Arrêt progressif des opérations « Sentinelle »</a></strong> (type Vigipirate) et passage à une surveillance ciblée des lieux publics par les effectifs renforcés de la police, la gendarmerie, la garde nationale et non l’armée; <strong><a href=\"https://avenirencommun.fr/le-livret-securite/\">Judiciarisation de la lutte antiterroriste</a></strong> : Moins de mesures administratives sans suites judiciaires, accélération des procédures, suppression de toute juridiction spécialisée et augmentation des moyens de la justice anti-terroriste.",
		"badge": {
			"text": "Démagogique",
			"color": "red"
		},
		"parent": "securite-justice-defense",
		"slug": "securite-justice-defense-terrorisme",
		"relatives": [
			{
				"title": "Sécurité",
				"link": "securite-justice-defense-securite"
			},
			{
				"title": "Justice",
				"link": "securite-justice-defense-justice"
			},
			{
				"title": "Terrorisme",
				"link": "securite-justice-defense-terrorisme"
			},
			{
				"title": "Défense",
				"link": "securite-justice-defense-defense"
			}
		]
	},
	"securite-justice-defense": {
		"title": "Sécurité / Justice / Défense",
		"main": true,
		"image": "securite-justice-defense",
		"pos": 2,
		"intro": "40 000 places de prison supplémentaires, 15 000 policiers et gendarmes, un budget militaire à 3% du PIB.... Dans les domaines de la sécurité, de la défense et de la justice, le Front National cherche à  cultiver une image de force et de fermeté totale, à l&#39;opposé d&#39;un prétendu « laxisme » général.<br>Dans le domaine de la sécurité, il mise sur le tout-répressif et la « tolérance zero », et Marine Le Pen s&#39;est même déclarée <a href=\"http://www.lexpress.fr/actualite/politique/fn/pour-marine-le-pen-l-etat-d-urgence-aujourd-hui-c-est-de-la-com-du-bidon_1793987.html\">pour le renversement de la charge de la preuve en matière de légitime défense</a>. Un policier ayant tué quelqu&#39;un lors d&#39;une intervention n’aurait alors plus à prouver qu’il était en situation de légitime défense, et ce serait aux enquêteurs de démontrer l’inverse. Dans la lutte anti-terroriste, le parti focalise son attention sur les fichés S et les étrangers, sans véritablement s&#39;attaquer aux sources du terrorisme international. Concernant la justice, Marine Le Pen ne cesse de dénoncer un prétendu <a href=\"https://www.franceculture.fr/droit-justice/fillon-le-pen-emmanuelli-25-ans-de-rengaine-politique-contre-le-gouvernement-des-juges\">« gouvernement des juges »</a>, mais la justice risque d&#39;être encore moins indépendante avec le FN. Et en matière de défense, ce parti veut engager le pays dans une très coûteuse course à l&#39;armement militaire, dans un but très flou.",
		"subs": [
			{
				"title": "Sécurité",
				"link": "securite-justice-defense-securite"
			},
			{
				"title": "Justice",
				"link": "securite-justice-defense-justice"
			},
			{
				"title": "Terrorisme",
				"link": "securite-justice-defense-terrorisme"
			},
			{
				"title": "Défense",
				"link": "securite-justice-defense-defense"
			}
		],
		"slug": "securite-justice-defense"
	},
	"urgence-democratique-droit-education": {
		"title": "Droit à l'éducation",
		"main": false,
		"invisible": true,
		"image": "urgence-democratique",
		"fn": "→ [11] Garantir la liberté de scolariser ses enfants selon ses choix, tout en contrôlant plus strictement la compatibilité avec les valeurs de la République des enseignements dispensés dans les établissements privés hors-contrat.",
		"fi": "La scolarisation « selon [les] choix [des parents] » aura des conséquences désastreuses pour la majorité de la population. Concrètement, cela signifie que l&#39;application de la carte scolaire sera plus laxiste et que les parents pourront choisir où scolariser leurs enfants.<br>Bien que l&#39;idée puisse paraitre alléchante, cela signifie que certaines écoles ayant de bons résultats, ou « bien cotées » verront le nombre de dossiers de scolarisation qu&#39;elles reçoivent augmenter de manière drastique. Elles seront alors obligées de pratiquer une sélection à l&#39;entrée.</p>\n<p>Cela amènera donc à l&#39;accentuation dramatique d&#39;une situation déjà trop présente: l&#39;éducation à plusieurs vitesses. Selon l&#39;origine socio-culturelle (« aisés contre pauvres ») des parents et la localisation des écoles (« beaux quartiers contre banlieues »), des moyens différents seront alloués, et les élèves se retrouveront dans des écoles où les chances d&#39;obtenir une éducation de qualité ne seront pas les mêmes.</p>\n<p>Au final, alors que madame Le Pen prétend défendre le peuple, elle va le diviser. Ce sont les milieux ouvriers et populaires qui en subiront le plus les conséquences.",
		"aec": "<strong>Instaurer une <a href=\"https://laec.fr/s73m2\">nouvelle carte scolaire</a></strong> établissant la mixité sociale.<br/><br><strong>Mettre en œuvre un plan de lutte contre les inégalités</strong> à l&#39;école maternelle et primaire, notamment avec un droit à la scolarisation dès 2 ans, la baisse du nombre d&#39;élèves par classe en primaire, la présence de davantage d&#39;instituteurs que de classes dans les écoles, le développement des Réseaux d&#39;aide aux élèves en difficulté.<br/><br><strong>Assurer la <a href=\"https://laec.fr/s73m3\">gratuité réelle de l&#39;éducation</a> publique</strong>, y compris les cantines, le transport et les activités périscolaires, fournir gratuitement aux élèves les manuels scolaires, ainsi que des fournitures sans marque, pour assurer une réelle égalité des conditions entre élèves et lutter contre l&#39;intrusion marchande à l&#39;école.",
		"badge": {
			"text": "Mensonger",
			"color": "red"
		},
		"parent": "urgence-democratique",
		"slug": "urgence-democratique-droit-education",
		"relatives": [
			{
				"title": "République",
				"link": "urgence-democratique-republique"
			},
			{
				"title": "Égalité réelle",
				"link": "urgence-democratique-egalite-reelle"
			},
			{
				"title": "Libertés numériques",
				"link": "urgence-democratique-libertes-numeriques"
			},
			{
				"title": "Droit à l'éducation",
				"link": "urgence-democratique-droit-education"
			}
		]
	},
	"urgence-democratique-egalite-reelle": {
		"title": "Égalité réelle",
		"main": false,
		"invisible": true,
		"image": "urgence-democratique",
		"fn": "→ [9] Défendre les droits des femmes: lutter contre l’islamisme qui fait reculer leurs libertés fondamentales ; mettre en place un plan national pour l’égalité salariale femme/homme et lutter contre la précarité professionnelle et sociale.",
		"fi": "<strong>Tout en prétendant défendre les droits des femmes, le FN tente par des propositions sur le salaire des femmes de détourner l&#39;attention</strong> de son axe identitaire et xénophobe de lutte contre l&#39;islam.</p>\n<p><a href=\"http://www.terrafemina.com/article/6-tres-bonnes-raisons-pour-les-femmes-de-fuir-le-fn_a296925/1\">Il convient de rappeler pourtant les positions de certains de ses membres</a> vis à vis de l&#39;IVG (Marion Maréchal Le Pen proposait son déremboursement il y a peu), ou vis à vis de la place des femmes dans la société (l&#39;eurodéputé Dominique Martin<a href=\"http://www.lefigaro.fr/politique/le-scan/insolites/2015/03/26/25007-20150326ARTFIG00369-un-eurodepute-fn-prone-le-droit-des-femmes-a-rester-chez-elles.php\"> pronait il y a quelques mois</a> à Strasbourg le retour des femmes au foyer pour régler les problèmes de l&#39;emploi et de la sécurité des enfants)</p>\n<p>Pour finir, les députés FN ont systématiquement voté contre les lois ayant trait aux droits des femmes (<a href=\"http://www2.assemblee-nationale.fr/scrutins/detail/%28legislature%29/14/%28num%29/773#G6\">loi pour l&#39;égalité réelle entre les femmes et les hommes</a>, <a href=\"http://www2.assemblee-nationale.fr/scrutins/detail/%28legislature%29/14/%28num%29/738#G6\">loi pour la lutte contre le système prostitutionnel</a>, extension du délit d&#39;entrave à l&#39;IVG...)",
		"aec": "Nous pensons que la question de l&#39;égalité réelle femme-homme n&#39;est pas qu&#39;une question de salaire ou de précarité professionnelle.<br>Au delà du symptôme évident matérialisé sur la fiche de paie, la non-marchandisation des corps doit être constitutionalisée, ainsi que les droits fondamentaux qui vont avec.<br/><br><strong>Étendre à toutes les entreprises</strong> l&#39;obligation d&#39;adopter un plan ou un <a href=\"https://https://laec.fr/s32\">accord d&#39;entreprise</a> contre les inégalités de salaires et de carrière entre hommes et femmes.<br/><br><strong>Revaloriser les métiers</strong> occupés majoritairement par des femmes et agir pour l&#39;égal accès à toutes les formations et à tous les métiers.<br/><br><strong>Constitutionnaliser le droit à la contraception</strong> et à l&#39;Interruption Volontaire de Grossesse.<br/><br><strong>Imposer <a href=\"https://laec.fr/s6m3\">l&#39;égalité de conditions</a> entre les femmes et les hommes</strong> dans le secteur public, politique et syndical.<br/><br><strong>Renforcer la loi et les moyens</strong> contre les violences faites aux femmes et en adopter une loi de lutte contre le sexisme.<br/><br><strong>Généraliser le Planning familial</strong> dans ses missions de formation et d&#39;éducation.",
		"badge": {
			"text": "Mensonger",
			"color": "red"
		},
		"parent": "urgence-democratique",
		"slug": "urgence-democratique-egalite-reelle",
		"relatives": [
			{
				"title": "République",
				"link": "urgence-democratique-republique"
			},
			{
				"title": "Égalité réelle",
				"link": "urgence-democratique-egalite-reelle"
			},
			{
				"title": "Libertés numériques",
				"link": "urgence-democratique-libertes-numeriques"
			},
			{
				"title": "Droit à l'éducation",
				"link": "urgence-democratique-droit-education"
			}
		]
	},
	"urgence-democratique-libertes-numeriques": {
		"title": "Libertés numériques",
		"main": false,
		"invisible": true,
		"image": "urgence-democratique",
		"fn": "→ [7] Garantir la liberté d’expression et les libertés numériques par leur inscription dans les libertés fondamentales protégées par la Constitution, tout en renforçant la lutte contre le cyber-djihadisme et la pédo-criminalité.<br>→ [8] Créer une charte à valeur constitutionnelle qui inclura la protection des données personnelles des Français, notamment par une obligation de stockage de ces données sur des serveurs localisés en France.",
		"fi": "Si l&#39;intention de la première proposition peut paraître louable, il faut rappeler que la liberté d&#39;expression est déjà un droit constitutionnel. En effet, bien que n&#39;étant pas présente directement dans la Constitution de 1958, elle est sanctuarisée dans la Déclaration des Droits de l&#39;Homme et du Citoyen de 1789, elle-même incluse dans la Constitution. <a href=\"http://www.lemondepolitique.fr/cours/libertespubliques/libertes/liberte_expression.htm\">Le Conseil Constitutionnel a d&#39;ores et déjà</a> établi que cette déclaration avait valeur constitutionnelle lors d&#39;une jurisprudence.</p>\n<p>Concernant la protection des données personnelles, la proposition du Front National brouille encore les cartes. En effet, le stockage des données personnelles sur des serveurs localisés en France ne serait en aucun cas un gage de sécurité, étant donné que la loi Renseignement du 24 juillet 2015 autorise les services de renseignement français à utiliser des dispositifs d&#39;écoute sur les communications françaises ainsi qu&#39;à <a href=\"http://www.lexpress.fr/actualite/politique/infographie-boites-noires-mouchards-la-loi-renseignement-en-un-coup-d-oeil_1692913.html\">poser des &quot;boites noires&quot;</a> directement chez les fournisseurs d&#39;accès à internet. La charte de protection promise par le programme de Madame Le Pen commencerait donc sa vie avec un sérieux coup de plomb dans l&#39;aile.",
		"aec": "  <strong>L’évaluation de l’efficacité des solutions</strong> techniques utilisées par les services de renseignement. Les mesures inefficaces, disproportionnées ou contre-productives seront abrogées.<br/><br>  <strong>La remise en question des pratiques et dispositifs de surveillance</strong> de masse sur Internet et les réseaux téléphoniques.<br/><br>  <strong>L’interdiction du fichage</strong> généralisé et la suppression du fichier des « gens honnêtes ».<br/><br>  <strong>La protection des données personnelles</strong> de nos citoyens lorsqu&#39;elles sont hébergées à l&#39;étranger, en renégociant notamment l&#39;accord Privacy Shield (régulation du transfert de données personnelles de l&#39;UE vers les États-Unis.<br/><br>  <strong>Obliger à demander un consentement explicite</strong> pour la revente des données personnelles à un tiers.<br/><br>  <strong>Obliger les acteurs du web</strong> à informer l&#39;utilisateur s&#39;il fait l&#39;objet d&#39;un profilage et lui permettre de le refuser.",
		"badge": {
			"text": "Mensonger",
			"color": "red"
		},
		"parent": "urgence-democratique",
		"slug": "urgence-democratique-libertes-numeriques",
		"relatives": [
			{
				"title": "République",
				"link": "urgence-democratique-republique"
			},
			{
				"title": "Égalité réelle",
				"link": "urgence-democratique-egalite-reelle"
			},
			{
				"title": "Libertés numériques",
				"link": "urgence-democratique-libertes-numeriques"
			},
			{
				"title": "Droit à l'éducation",
				"link": "urgence-democratique-droit-education"
			}
		]
	},
	"urgence-democratique-republique": {
		"title": "République",
		"main": false,
		"invisible": true,
		"image": "urgence-democratique",
		"fn": "→ [2] Organiser un référendum en vue de réviser la Constitution et conditionner toute révision future de la Constitution à un référendum. Élargir le champ d’application de l’article 11 de la Constitution.<br>→ [3] Permettre la représentation de tous les Français par le scrutin proportionnel à toutes les élections. À l’Assemblée nationale, la proportionnelle sera intégrale avec une prime majoritaire de 30 % des sièges pour la liste arrivée en tête et un seuil de 5% des suffrages pour obtenir des élus.<br>→ [4] Abaisser le nombre de députés à 300 (contre 577 aujourd’hui) et le nombre de sénateurs à 200 (contre 348 aujourd’hui).",
		"fi": "Conditionner la révision de la Constitution à un référendum d&#39;approbation serait admirable, si cela permettait de garantir des politiques novatrices. Non seulement le reste du programme ne le laisse pas entendre, mais encore une fois le manque de précision du Front National ne laisse que peu de doute quant à l&#39;aspect électoraliste de la mesure. Le plus grand danger reste néanmoins dans la méthode, puisque <a href=\"https://fr.wikipedia.org/wiki/R%C3%A9f%C3%A9rendum_en_France#Le_r.C3.A9f.C3.A9rendum_l.C3.A9gislatif\">l&#39;adoption d&#39;une loi par le biais d&#39;un référendum</a> permet dans les faits de se passer du consentement du parlement.<br>La proportionnelle intégrale est ici dévoyée de son objectif premier. Il est en effet impossible d&#39;assurer la représentation de tous les français dans les élections lorsqu&#39;on commence par imposer un minimum de voix pour obtenir une représentation, les petits partis seraient évincés de ce parlement de la même manière qu&#39;aujourd&#39;hui.<br>Cela est encore plus accentué par la diminution proposée du nombre de représentants.<br>De plus, la prime majoritaire de 30 % (rien que ça) d&#39;élus pour la liste arrivée en tête diminue encore le nombre de sièges effectivement réservés pour les députés élus par suffrage, et ferait qu&#39;en cas d&#39;éclatement des voix, un parti atteignant les 20 % de suffrages exprimés <a href=\"https://www.slate.fr/story/144942/marine-le-pen-presidente-proportionnelle-dissolution\">obtiendrait automatiquement la majorité</a>. Une manne donc pour le Front National, qui détient un quasi monopole sur son aile et serait à même d&#39;effectuer n&#39;importe quelle réforme.<br>Le référendum d’initiative populaire que Marine Le Pen propose serait seulement législatif, c’est à dire que nous pourrions ajouter des lois et des articles de constitution, mais pas retirer ceux votés par le parlement, imposés par ordonnance ou par le 49.3. Il y a donc un risque non négligeable qu’il devienne un référendum uniquement consultatif (le gouvernement n&#39;aurait aucune obligation d&#39;adopter les propositions du référendum). Enfin, Marine Le Pen a bien dit qu&#39;elle<a href=\"http://www.bfmtv.com/mediaplayer/video/ue-regions-49-3-ce-que-ferait-marine-le-pen-si-elle-etait-elue-presidente-899537.html\"> ne comptait pas remettre en cause le 49.3</a>, qui permet d&#39;adopter une loi sans passer par le vote du parlement.",
		"aec": "<strong>Convoquer un référendum</strong> pour engager le processus constituant (modalités de la composition de <a href=\"https://laec.fr/s1\">l&#39;Assemblée constituante</a> — mode de scrutin, parité, tirage au sort et incompatibilités ; modalités de la délibération ; association des citoyens aux travaux…).<br><strong><a href=\"https://laec.fr/s1m2\">Aucun parlementaire des anciennes assemblées de la 5e République ne pourra siéger</a></strong> dans cette Assemblée constituante. Les délégués à l&#39;Assemblée constituante ne pourront être candidats aux élections suivant l&#39;entrée en vigueur de la nouvelle Constitution<br>Le projet de Constitution proposé par l&#39;Assemblée constituante sera soumis à un <a href=\"https://laec.fr/s1m3\">référendum d&#39;approbation</a>.<br>Abolir la <strong><a href=\"https://laec.fr/s4\">monarchie présidentielle</a></strong> en instaurant un régime parlementaire stable dans lequel le gouvernement sera responsable devant le Parlement, transférer le pouvoir de nomination du Gouvernement au Parlement.<br><strong><a href=\"https://laec.fr/s3m4\">Rendre obligatoire le recours au référendum</a></strong> pour réviser la Constitution ou ratifier tout nouveau traité européen et garantir le respect de la décision populaire.<br>Élire l&#39;Assemblée nationale à la <a href=\"https://avenirencommun.fr/livret-assemblee-constituante/\">proportionnelle totale</a>.<br><strong><a href=\"https://laec.fr/s4m3\">Supprimer le Sénat et le Conseil économique, social et environnemental</a></strong> et créer une Assemblée de l&#39;intervention populaire et du long terme émettant un avis sur l&#39;impact écologique et social des lois.<br><strong><a href=\"https://laec.fr/s4m4\">Supprimer la Cour de justice de la République</a></strong> et soumettre les membres du gouvernement à la justice ordinaire.<br>Instaurer le <strong><a href=\"https://laec.fr/s3m3\">référendum d&#39;initiative citoyenne</a></strong> et le droit des citoyens de proposer une loi.<br>Créer un <strong><a href=\"https://laec.fr/s3m2\">droit de révoquer un élu</a></strong> en cours de mandat, par référendum, sur demande d&#39;une partie du corps électoral.",
		"badge": {
			"text": "Mensonger",
			"color": "red"
		},
		"parent": "urgence-democratique",
		"slug": "urgence-democratique-republique",
		"relatives": [
			{
				"title": "République",
				"link": "urgence-democratique-republique"
			},
			{
				"title": "Égalité réelle",
				"link": "urgence-democratique-egalite-reelle"
			},
			{
				"title": "Libertés numériques",
				"link": "urgence-democratique-libertes-numeriques"
			},
			{
				"title": "Droit à l'éducation",
				"link": "urgence-democratique-droit-education"
			}
		]
	},
	"urgence-democratique": {
		"title": "Urgence démocratique",
		"main": true,
		"image": "urgence-democratique",
		"pos": 4,
		"intro": "  <strong>Que ce soit dans le domaine de la démocratie et de la représentation </strong>, ou dans celui des libertés fondamentales, le Front National a beaucoup de propositions à faire. Celles-ci, souvent floues, sont souvent à double tranchant, et menacent de fracturer la société encore plus qu&#39;elle ne l&#39;est. Quand au sujet de l&#39;égalité, que ce soit celle de tous les citoyens, ou plus spécifiquement de l&#39;égalité femme-homme, certains sujets sont passés sous silence par le parti d&#39;extrême-droite. Pour de bonnes raisons.",
		"subs": [
			{
				"title": "République",
				"link": "urgence-democratique-republique"
			},
			{
				"title": "Égalité réelle",
				"link": "urgence-democratique-egalite-reelle"
			},
			{
				"title": "Libertés numériques",
				"link": "urgence-democratique-libertes-numeriques"
			},
			{
				"title": "Droit à l'éducation",
				"link": "urgence-democratique-droit-education"
			}
		],
		"slug": "urgence-democratique"
	},
	"urgence-ecologique-agriculture": {
		"title": "Agriculture",
		"main": false,
		"invisible": true,
		"image": "urgence-ecologique",
		"fn": "→ [125] Appliquer le patriotisme économique aux produits agricoles français pour soutenir immédiatement nos paysans et nos pêcheurs, notamment au travers de la commande publique (État et collectivités).</p>\n<p>→ [126] Transformer la Politique Agricole Commune en Politique Agricole Française. Garantir le montant des subventions dont les critères seront fixés par la France et non plus par l’Union européenne, avec l’objectif de sauver et soutenir le modèle français des exploitations familiales.</p>\n<p>→ [127] (…) Développer les circuits courts de la production à la consommation, en réorganisant les filières.</p>\n<p>→ [128] Simplifier le quotidien des agriculteurs en stoppant l’explosion des normes administratives. Encourager l’installation des jeunes agriculteurs, par le biais de défiscalisations durant les premières années.</p>\n<p>→ [129] Défendre la qualité : afin de lutter contre la concurrence déloyale, interdire l’importation des produits agricoles et alimentaires qui ne respectent pas les normes de production françaises en matière de sécurité sanitaire, de bien-être animal et d’environnement. Imposer la traçabilité totale de l’origine géographique et du lieu de transformation sur l’étiquette, afin de garantir la transparence et l’information complète des consommateurs.</p>\n<p>→ [130] Promouvoir les exportations agricoles, notamment en soutenant les labels de qualité.</p>\n<p>→ [137] Faire de la protection animale une priorité nationale. Défendre le bien-être des animaux en interdisant l’abattage sans étourdissement préalable et en remplaçant le plus possible les expérimentations animales. Refuser le modèle des fermes-usines, du type « ferme des 1 000 vaches ».",
		"fi": "Le programme du FN n&#39;emploie même pas le mot « agriculture biologique », et ne propose aucune conversion écologique de l&#39;agriculture.  Il ne parle pas d&#39;interdire les <a href=\"http://www.francetvinfo.fr/replay-magazine/france-2/cash-investigation/cash-investigation-du-mardi-2-fevrier-2016_1286821.html\">pesticides</a>, qui polluent et sont <a href=\"http://www.pesticides-non-merci.com/pesticides-sante.html\">responsables de graves problèmes de santé</a>. Les « normes administratives » actuelles concernent aussi les normes environnementales, qui sont loin des exigences de l&#39;agriculture biologique.</p>\n<p>Actuellement un des plus gros problèmes est celui de la rémunération des agriculteurs : <a href=\"http://www.lefigaro.fr/conjoncture/2016/10/13/20002-20161013ARTFIG00166-plus-de-50-des-agriculteurs-devraient-gagner-moins-de-354-euros-par-mois-en-2016.php\">Plus de la moitié gagne moins de 354 euros par mois</a>. Face à ce problème, le « patriotisme économique » est loin de suffire. Les produits qui ne respectent pas les normes françaises sont déjà interdits, et le problème vient surtout de la concurrence déloyale de produits fabriqués dans des conditions sociales indignes. Le principal responsable de la faible rémunération des producteurs est <a href=\"https://reporterre.net/Voici-comment-la-grande-distribution-ecrase-l-agriculture-en-France\">la grande distribution, qui écrase littéralement les producteurs</a>. Et il s&#39;agit bien d&#39;entreprises française ! Face à elles, le FN ne prévoit pas de soutenir les producteurs. Marine Le Pen parle seulement de <a href=\"http://www.leparisien.fr/elections/presidentielle/macron-le-pen-leurs-potions-pour-l-ecologie-passees-a-la-loupe-05-05-2017-6918543.php\">supprimer la TVA sur « l&#39;élevage paysan »</a>, alors qu&#39;<a href=\"http://www.journaldunet.com/management/pratique/vie-de-l-entreprise/12235/le-taux-de-tva-en-2017.html\">elle est actuellement de 10%</a>. Mais les élevages industriels et l&#39;industrie agro-alimentaire s&#39;adapteront sans peine. La transformation de la PAC en « Politique agricole Française » ne dit rien sur le contenu de cette politique, à part un vague soutien aux « exploitations familiales ».</p>\n<p>Le problème essentiel est celui de la concentration des terres agricoles : <a href=\"https://www.bastamag.net/L-accaparement-de-terres-et-la\">Le nombre d’exploitations a été divisé par 4 ces 50 dernières années, et 10% des exploitations possèdent la moitié de la surface agricole</a>. Depuis 2006, <a href=\"https://www.bastamag.net/L-accaparement-de-terres-et-la\">une holding peut acquérir 99% d&#39;une ou de plusieurs exploitations, sans que personne ne le sache</a>. L&#39;autre problème important est celui de la réduction des terres : <a href=\"http://filiere-paysanne.blogspot.fr/p/preservation-des-terres.html\">78 000 ha de surface agricole disparaissent tous les ans</a>. « Simplifier les normes d&#39;urbanisme » serait poursuivre dans la même direction, <a href=\"https://www.bastamag.net/L-hyper-concentration-de-terres-aux-mains-d-une-elite-n-epargne-aucun-pays\">en permettant de rendre constructible de nombreux terrains</a>. La défiscalisation pour les jeunes agriculteurs ne changera pas grand chose, car rien n&#39;est prévu pour soutenir concrètement leur installation, et le problème essentiel est celui de l&#39;accès à la terre. Il faut donc avant tout  remettre en cause le modèle productiviste.",
		"aec": "<strong><a href=\"https://laec.fr/s46m1\">Engager la réforme agraire</a></strong> pour faciliter l&#39;installation des jeunes agriculteurs, et créer 300 000 emplois agricoles grâce à des prix rémunérateurs et une refonte de la PAC, avec <a href=\"https://avenirencommun.fr/livret-agriculture/\">suppression</a> du système actuel d’aides à l’hectare. <a href=\"https://laec.fr/s46m2\">Stopper</a> les projets de fermes usines.<br/><br><strong><a href=\"https://laec.fr/s46m4\">Plafonner les marges de la grande distribution</a></strong> par un coefficient multiplicateur limité pour garantir des prix rémunérateurs et interdire les ventes à perte pour les agriculteurs; <a href=\"https://avenirencommun.fr/livret-agriculture/\">Reconnaitre le droit des organisations de producteurs</a> de négocier collectivement les contrats avec l’aval.<br/><br>Mise en place pour certaines productions de <strong><a href=\"https://laec.fr/s17m2\">taxes à l’importation, et augmentation immédiate des droits de douane</a></strong> pour les pays aux droits sociaux limités.<br><strong><a href=\"https://avenirencommun.fr/livret-agriculture/\">Création d&#39;Établissements Publics Fonciers Ruraux (EPFR)</a></strong>, refondant et élargissant les missions des Sociétés d&#39;aménagement foncier et d&#39;établissement rural (SAFER). Mise sous condition stricte d’une surface maximale par actif agricole lors des nouvelles autorisations d’exploiter pour permettre la déconcentration de la production agricole.<br/><br><strong><a href=\"https://avenirencommun.fr/livret-agriculture/\">Politique de préemption</a></strong>, avec révision de prix, des terres mises en vente par les EPFR, pour favoriser l’installation d&#39;agriculteurs ; Dispositifs adaptés de transmission des exploitations agricoles permettant l’installation de jeunes à un coût abordable, et soutien à l’installation de nouveaux agriculteurs.<br/><br><strong><a href=\"https://laec.fr/s45m4\">Sanctuariser le foncier agricole et naturel</a></strong> et lutter contre l&#39;artificialisation des sols.<br/><br><strong><a href=\"https://avenirencommun.fr/livret-agriculture/\">Adopter une loi planifiant la transition écologique</a></strong> de l’agriculture sur 10 ans; <a href=\"https://laec.fr/s46m3\">Développer l&#39;agriculture biologique, proscrire les pesticides chimiques</a>, instaurer une agriculture diversifiée et écologique; <a href=\"https://laec.fr/s43m4\">Réduire la part des protéines carnées</a> dans l&#39;alimentation au profit des protéines végétales.<br/><br><strong><a href=\"https://avenirencommun.fr/livret-agriculture/\">Rémunération de services spécifiques fournis à la société par l’agriculture écologique</a></strong>, et de la préservation de l&#39;environnement; Subventions destinées à compenser les investissements et autres coûts générés par la transition écologique.<br/><br><strong><a href=\"https://laec.fr/s43m3\">Passer au 100 % bio et local</a></strong> dans la restauration collective; Création de <a href=\"https://laec.fr/s43m2\">coopératives de consommation</a> en lien direct avec les producteurs.",
		"badge": {
			"text": "Très insuffisant",
			"color": "red"
		},
		"parent": "urgence-ecologique",
		"slug": "urgence-ecologique-agriculture",
		"relatives": [
			{
				"title": "Nucléaire",
				"link": "urgence-ecologique-nucleaire"
			},
			{
				"title": "Énergies renouvelables",
				"link": "urgence-ecologique-renouvelables"
			},
			{
				"title": "Énergies fossiles et transports",
				"link": "urgence-ecologique-fossiles-transports"
			},
			{
				"title": "Agriculture",
				"link": "urgence-ecologique-agriculture"
			}
		]
	},
	"urgence-ecologique-fossiles-transports": {
		"title": "Énergies fossiles et transports",
		"main": false,
		"invisible": true,
		"image": "urgence-ecologique",
		"fn": "→ [135] Soutenir une filière française de l’hydrogène (énergie propre), par un appui de l’État en matière de recherche et développement, afin de réduire notre dépendance au pétrole.</p>\n<p>→ [136] Interdire l’exploitation du gaz de schiste, tant que des conditions satisfaisantes en matière d’environnement, de sécurité et de santé ne seront pas réunies, et appliquer le principe de précaution en interdisant les OGM.</p>\n<p>→ [138] Garantir l’égal accès aux services publics (administrations, gendarmerie, eau, santé, transport, hôpitaux de proximité et maisons de santé…) sur tout le territoire et en particulier en milieu rural. La libéralisation du rail voulue par l’Union européenne sera refusée. La Poste et la SNCF resteront des entreprises publiques.</p>\n<p>→ [139] Regrouper en un seul ministère l’aménagement du territoire, les transports et le logement. Rééquilibrer la politique de la ville vers les zones désertifiées et rurales.",
		"fi": "<a href=\"http://www.lemonde.fr/planete/article/2017/01/26/les-deputes-votent-l-interdiction-des-gaz-de-schiste_5069558_3244.html\">L&#39;exploitation du gaz de schiste est déjà interdite</a>. Mais l&#39;exploration de ce gaz aussi, alors que <a href=\"http://www.usinenouvelle.com/article/gaz-de-schiste-marine-le-pen-face-a-ses-contradictions.N187484\">Marine Le Pen s&#39;est prononcée pour</a>, ce qui est contradictoire, car l&#39;exploration est un premier pas vers l&#39;exploitation, qui est <a href=\"http://www.futura-sciences.com/planete/questions-reponses/energie-renouvelable-exploitation-gaz-schiste-elle-menace-4154/\">très néfaste pour l&#39;environnement</a>. Le FN ne prévoit pas non plus de fermer les <a href=\"https://fr.wikipedia.org/wiki/Liste_des_centrales_thermiques_%C3%A0_flamme_en_France#Centrales_.C3.A0_charbon\">4 centrales à charbon</a> du pays.</p>\n<p>En matière de transports, <a href=\"http://www.lepoint.fr/politique/marine-le-pen-contre-la-taxation-du-diesel-08-03-2017-2110200_20.php\">Marine Le Pen n&#39;envisage qu&#39;une taxation des camions étrangers</a>. Concernant le diesel, la candidate s&#39;oppose à une taxation spécifique qui pénaliserait selon elle les « classes modestes ». <a href=\"http://www.lepoint.fr/politique/marine-le-pen-contre-la-taxation-du-diesel-08-03-2017-2110200_20.php\">Elle attribue l&#39;essentiel de la pollution à l&#39;Allemagne</a>, alors que <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/12/12/le-pic-de-pollution-n-est-pas-venu-des-centrales-a-charbon-allemandes_5047702_4355770.html\">l&#39;étude de la composition des particules fines montre que c&#39;est faux</a>. Il faut aussi savoir que <a href=\"http://www.liberation.fr/futurs/2013/02/28/le-diesel-un-danger-enfin-confirme_885472\">le diesel est classé cancérigène depuis 2013</a>. Il n&#39;est pas question dans le programme de taxer aux frontières les transports longue distance, ce qui contribuerait à relocaliser l&#39;économie. Le FN semble beaucoup compter sur l&#39;hydrogène pour sortir du pétrole, mais pour l&#39;instant, <a href=\"https://www.notre-planete.info/actualites/livre-documentaire-hydrogene-carburant-apres-petrole\">les avis sont partagés sur la question</a>. L&#39;hydrogène est rarement pur dans la nature, <a href=\"http://www.futura-sciences.com/planete/questions-reponses/energie-renouvelable-hydrogene-elle-energie-propre-906/\">pour le séparer des autres éléments, puis le comprimer ou le liquéfier, il faut beaucoup d&#39;énergie</a>, et il semble enfin que <a href=\"https://www.contrepoints.org/2015/07/26/215595-lhydrogene-cet-hallucinogene\">beaucoup d&#39;énergie soit gaspillée dans ce cycle</a>. Pour l&#39;instant<a href=\"http://www.futura-sciences.com/planete/questions-reponses/energie-renouvelable-exploitation-gaz-schiste-elle-menace-4154/\"> il semble plus intéressant de développer les véhicules électriques</a>.</p>\n<p>Sur le projet d&#39;aéroport de Notre-Dame-des-Landes, si Marine Le Pen a indiqué être contre ce projet, <a href=\"https://reporterre.net/Marine-Le-Pen-veut-faire-l-aeroport-de-Notre-Dame-des-Landes\">elle a annoncé qu&#39;elle suivra les résultats du référendum organisé l&#39;année dernière</a>. Mais de nombreuses choses posent problème dans ce référendum : <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/06/27/referendum-sur-notre-dame-des-landes-le-non-l-emporte-essentiellement-autour-du-futur-aeroport_4958873_4355770.html\">Les communes situées aux alentours du futur aéroport ont clairement voté contre</a>, <a href=\"https://reporterre.net/Notre-Dame-des-Landes-Le-referendum-etait-pipe\">la campagne a largement favorisé le oui</a>, et <a href=\"https://www.marianne.net/societe/referendum-sur-notre-dame-des-landes-et-si-le-gouvernement-avait-choisi-une-autre-echelle\">le choix d&#39;un référendum sur le seul échelon départemental semble avoir été fait pour que le oui l&#39;emporte</a>. Il faut aussi rappeler qu&#39;<a href=\"http://www.lemonde.fr/planete/article/2015/10/21/notre-dame-des-landes-le-fn-denonce-un-projet-aberrant_4793937_3244.html\">en 2002, les élus FN au conseil régional avaient voté en faveur de ce projet</a>.",
		"aec": "<strong><a href=\"https://laec.fr/s39m1\">Sortir des énergies carbonées</a></strong> en commençant par l&#39;arrêt des subventions aux énergies fossiles et de toute exploration de gaz et pétrole de schiste et de houille.<br/><br><strong><a href=\"https://www.lafaqdelavenirencommun.com/article/13/23/fr/quel-est-le-co%C3%BBt-du-programme-l_avenir-en-commun-.html\">Plan d&#39;investissement de 100 milliards</a></strong> financé par un emprunt auprès de la Banque Publique d&#39;Investissements (BPI), dont 25 milliards sont prévus pour entamer la transitions vers le 100% renouvelable, et 5 milliards pour développer le ferroutage.<br/><br><strong><a href=\"https://laec.fr/s47m4\">Défendre et reconstruire</a></strong> le maillage de transports en commun et de services publics sur tout le territoire; <a href=\"https://avenirencommun.fr/livret-ruralite-amenagement-territoire/\">Stopper l&#39;étalement urbain</a> en incitant au rapprochement entre bassins de vie et bassins d&#39;emploi.<br/><br><strong><a href=\"https://laec.fr/s41m1\">Développer le transport ferroviaire</a></strong> : Développement du ferroutage et du report modal pour réduire le transport routier de marchandises ; Refuser la mise en concurrence du transport ferroviaire ; Revenir sur la loi Macron pour les autocars.<br/><br><strong><a href=\"https://laec.fr/s41m2\">Développer le cabotage maritime</a></strong> entre les ports français et le transport fluvial.<br/><br><strong><a href=\"https://laec.fr/s41m4\">Engager la sortie du diesel</a></strong> ; Développer les usages partagés de la voiture et les mobilités douces (vélo, etc.) ; <a href=\"https://laec.fr/s41m4\">Développer les véhicules électriques</a> pour les flottes captives, et les <a href=\"https://avenirencommun.fr/le-livret-energie/\">carburants alternatifs</a> (électricité, gaz de synthèse…).<br/><br><strong><a href=\"https://avenirencommun.fr/le-livret-energie/\">Evaluation systématique par l&#39;Etat</a></strong> de l’impact énergétique et en CO2 de la commande publique.<br/><br>Introduire une <strong><a href=\"https://laec.fr/s42m1\">contribution carbone</a></strong> sur le transport de marchandises, et une <a href=\"https://laec.fr/s42m2\">taxe kilométrique</a> aux frontières de la France pour intégrer le coût écologique dans les produits.<br/><br><strong><a href=\"https://laec.fr/s47m1\">Arrêter les grands projets inutiles</a></strong>, comme l&#39;aéroport de Notre-Dame-des-Landes.",
		"badge": {
			"text": "Très insuffisant",
			"color": "red"
		},
		"parent": "urgence-ecologique",
		"slug": "urgence-ecologique-fossiles-transports",
		"relatives": [
			{
				"title": "Nucléaire",
				"link": "urgence-ecologique-nucleaire"
			},
			{
				"title": "Énergies renouvelables",
				"link": "urgence-ecologique-renouvelables"
			},
			{
				"title": "Énergies fossiles et transports",
				"link": "urgence-ecologique-fossiles-transports"
			},
			{
				"title": "Agriculture",
				"link": "urgence-ecologique-agriculture"
			}
		]
	},
	"urgence-ecologique-nucleaire": {
		"title": "Nucléaire",
		"main": false,
		"invisible": true,
		"image": "urgence-ecologique",
		"fn": "→ [134] Pour maintenir, moderniser et sécuriser la filière nucléaire française, engager le Grand Carénage, et garder le contrôle de l’État sur EDF, en lui redonnant une véritable mission de service public. Refuser la fermeture de la centrale de Fessenheim.",
		"fi": "Le maintien du nucléaire pourrait coûter très cher : <a href=\"http://www.capital.fr/enquetes/strategie/votre-electricite-bientot-hors-de-prix-a-cause-du-nucleaire-1125816\">Le coût de l&#39;électricité nucléaire explose</a>, et surtout, lle grand carénage, pour prolonger l’exploitation des réacteurs nucléaires, est estimé à 51 milliards d&#39;euros par EDF, mais un rapport commandé par greenpeace estime qu&#39;il pourrait s&#39;élever <a href=\"http://www.lemonde.fr/planete/article/2014/02/25/prolonger-les-reacteurs-nucleaires-hors-de-prix-selon-greenpeace_4373122_3244.html\">à 116 milliards d&#39;euros pour une &quot;sûreté préservée&quot; et 261 milliards d&#39;euros pour une &quot;sûreté renforcée&quot;</a>. De plus, la France n&#39;est pas à l&#39;abri d&#39;un accident. <a href=\"https://www.lesechos.fr/06/02/2013/lesechos.fr/0202550379350_le-cout-d-un-accident-nucleaire-en-france---plus-de-400-milliards-d-euros.htm\">Le coût d&#39;un accident grave en France est estimé à plus de 400 milliards</a>, sans parler du coût sanitaire et en vies humaines. <a href=\"http://www.sortirdunucleaire.org/Pourquoi-il-faut-fermer-Fessenheim\">Un réacteur nucléaire de 900 MW (le minimum actuel en France) contient environ 900 fois la quantité de produits de fission radioactifs de la bombe d’Hiroshima</a>. A l&#39;origine, la durée de vie prévue des 58 réacteurs français se situait entre 25 et 40 ans. <a href=\"http://www.connaissancedesenergies.org/fiche-pedagogique/parc-nucleaire-francais\">Leur âge moyen actuel est de 33 ans</a>, et <a href=\"http://www.lefigaro.fr/sciences/2014/02/25/01008-20140225ARTFIG00230-nucleaire-greenpeace-veut-limiter-a-40-ans-la-duree-de-vie-des-centrales.php\">greenpeace recommande de limiter leur durée de vie à 40 ans</a>. Il y a aussi régulièrement <a href=\"https://resistanceinventerre.wordpress.com/2017/03/16/oublions-fukushima/\">des nouvelles inquiétantes</a> .</p>\n<p>L&#39;uranium (principal combustible) utilisé dans les centrales françaises provient surtout de mines du Niger. Les travailleurs y sont <a href=\"https://www.bastamag.net/Comment-Areva-laisse-mourir-ses\">exposés en permanence à des radiations</a>, et certains travaillent jusqu’à 12h par jour, 7 jours sur 7. La région connait des <a href=\"http://www.sortirdunucleaire.org/Les-mines-d-uranium-a-l-etranger-l\">niveaux très élevés de pollution qui ont fait fuir jusqu’à la faune sauvage</a>. Les réserves d’uranium connues et <a href=\"http://www.sortirdunucleaire.org/Pourquoi-il-faut-fermer-Fessenheim\">exploitables à prix raisonnable seront épuisées d’ici moins de 50 ans</a>, et les opérations d’extraction <a href=\"http://www.sortirdunucleaire.org/Eoliennes-vent-de-polemique-p-24\">émettent de plus en plus de CO2</a>. Si les centrales elles mêmes n&#39;émettent pas de gaz à effet de serre, c&#39;est le cas lors de leur démantèlement, de l&#39;extraction de l&#39;uranium, ou de la gestion des déchets. Au contraire des <a href=\"http://www.latribune.fr/entreprises-finance/industrie/energie-environnement/le-nucleaire-solution-miracle-pour-le-climat-pas-vraiment-517312.html\">chiffres d&#39;EDF</a>, <a href=\"http://www.terraeco.net/Oui-le-nucleaire-emet-bien-du-CO2,16535.html\">une étude d&#39;un chercheur</a>, et <a href=\"http://23dd.fr/images/stories/Documents/PV/Ademe_Metro_Chapitre_2_Energie.pdf\">une autre de l&#39;ADEME</a>, parlent de 66g d&#39;émission de CO2/kWh pour une centrale, soit une empreinte largement supérieure à celle des énergies renouvelables.</p>\n<p><a href=\"https://fr.wikipedia.org/wiki/Liste_des_r%C3%A9acteurs_nucl%C3%A9aires_en_France#R.C3.A9acteurs_en_service,%20celle%20de%20Fessenheim\">Fessenheim, la plus vieille centrale du pays</a> (1978), est située dans une région avec <a href=\"http://www.sortirdunucleaire.org/Pourquoi-il-faut-fermer-Fessenheim\">d&#39;importants risques sismiques</a>, face auxquels elle est très peu protégée, et il y a aussi un<a href=\"http://www.sortirdunucleaire.org/Pourquoi-il-faut-fermer-Fessenheim\"> risque d&#39;inondations en cas de rupture de la digue du grand canal d&#39;Alsace</a>. Autant de raisons qui nous incitent à envisager une sortie du nucléaire, pour permettre le développement d&#39;énergies renouvelables plus propres et moins dangereuses.",
		"aec": "<strong><a href=\"https://www.lafaqdelavenirencommun.com/article/13/23/fr/quel-est-le-co%C3%BBt-du-programme-l_avenir-en-commun-.htm\">Plan d&#39;investissement de 100 milliards</a></strong> financé par un emprunt auprès de la Banque Publique d&#39;Investissements (BPI), dont 25 milliards sont prévus pour entamer la transition vers le 100% renouvelable.<br><br><strong><a href=\"https://laec.fr/s39m2\">Sortir du nucléaire</a></strong> :<br>-Fermer immédiatement Fessenheim en garantissant l&#39;emploi des salariés et leur formation pour en faire un site pilote du démantèlement<br>-Abandonner l&#39;opération du grand carénage visant à prolonger la vie des centrales nucléaires au-delà de quarante ans<br>-Abandonner les projets d&#39;EPR (Flamanville et Hinkley Point) et d&#39;enfouissement des déchets nucléaires à Bure<br>-Rendre publiques les données sur l&#39;enfouissement des déchets nucléaires depuis soixante ans et informer sur les dangers sanitaires avérés et/ou éventuels<br><br><strong><a href=\"https://laec.fr/s39m3\">Créer un pôle public de l&#39;énergie</a></strong> pour mener une politique cohérente, en renationalisant EDF et Engie (ex-GDF) en lien avec des coopératives locales de production et de consommation d&#39;énergies renouvelables et en favorisant l&#39;autoproduction et le partage des excédents.",
		"badge": {
			"text": "Coûteux et dangereux",
			"color": "red"
		},
		"parent": "urgence-ecologique",
		"slug": "urgence-ecologique-nucleaire",
		"relatives": [
			{
				"title": "Nucléaire",
				"link": "urgence-ecologique-nucleaire"
			},
			{
				"title": "Énergies renouvelables",
				"link": "urgence-ecologique-renouvelables"
			},
			{
				"title": "Énergies fossiles et transports",
				"link": "urgence-ecologique-fossiles-transports"
			},
			{
				"title": "Agriculture",
				"link": "urgence-ecologique-agriculture"
			}
		]
	},
	"urgence-ecologique-renouvelables": {
		"title": "Énergies renouvelables",
		"main": false,
		"invisible": true,
		"image": "urgence-ecologique",
		"fn": "→ [132] Afin de lutter contre la précarité énergétique et agir directement sur le pouvoir d’achat des Français, faire de l’isolation de l’habitat une priorité budgétaire du quinquennat, parce que l’énergie la moins chère est celle que l’on ne consomme pas.<br>→ [133] Développer massivement les filières françaises des énergies renouvelables (solaire, biogaz, bois…) grâce à un protectionnisme intelligent, au patriotisme économique, à l’investissement public et privé et aux commandes d’EDF. Décréter un moratoire immédiat sur l’éolien.<br>→ [134] Pour maintenir, moderniser et sécuriser la filière nucléaire française, engager le Grand Carénage, et garder le contrôle de l’État sur EDF, en lui redonnant une véritable mission de service public. Refuser la fermeture de la centrale de Fessenheim.",
		"fi": "Aucun investissement pour développer les énergies renouvelables n&#39;est prévu dans <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">le chiffrage du programme</a>, ce qui rend cette mesure peu crédible. Il semble que le FN n&#39;envisage pas non plus de revenir sur la <a href=\"https://www.lesechos.fr/01/07/2014/LesEchos/21719-069-ECH_10-ans-de-liberalisation-du-marche-de-l-energie.htm\">libéralisation d&#39;EDF et de Engie</a> , dont <a href=\"http://www.lamarseillaise.fr/herault/social/31311-edf-gdf-les-degats-de-dix-ans-de-privatisation\">le bilan est très mauvais</a>. Cela permettrait de donner plus de poids à l&#39;action des pouvoirs publics dans ce domaine.</p>\n<p>Un moratoire sur l&#39;éolien limiterait considérablement le développement des énergies renouvelables, puisque <a href=\"http://www.connaissancedesenergies.org/fiche-pedagogique/mix-energetique-de-la-france\">en dehors de l&#39;hydroélectricité, l&#39;éolien a fourni 55% de la production d&#39;électricité renouvelable en 2016</a>. Le <a href=\"https://negawatt.org/IMG/pdf/synthese_scenario-negawatt_2017-2050.pdf\">dernier rapport de l&#39;association Négawatt</a> démontre que le 100% renouvelable d&#39;ici 2050 est possible, avec l&#39;éolien comme 1ère source d&#39;électricité. A ce sujet, Marine Le Pen évoque surtout la <a href=\"http://bfmbusiness.bfmtv.com/entreprise/quand-marine-le-pen-s-attaque-aux-eoliennes-1127782.html\">« pollution visuelle »</a>. Mais l’installation d’éoliennes fait l’objet de <a href=\"https://demosthene2012.wordpress.com/2015/02/15/les-eoliennes-contre-le-fn-1/\">nombreuses réglementations et études</a>, et <a href=\"http://eolienne.f4jr.org/idees_recues\">un volet de l&#39;étude d&#39;impact porte sur le paysage</a>. Elle pense aussi que <a href=\"http://bfmbusiness.bfmtv.com/entreprise/quand-marine-le-pen-s-attaque-aux-eoliennes-1127782.html\">« nous (en) découvrirons dans le futur les conséquences sur la santé des habitants qui vivent autour »</a>. Pour l&#39;instant,<a href=\"https://www.anses.fr/fr/content/impacts-sanitaires-du-bruit-g%C3%A9n%C3%A9r%C3%A9-par-les-%C3%A9oliennes\"> les études disent le contraire</a>, et s&#39;en tenir à d&#39;hypothétiques découvertes futures n&#39;est pas très sérieux, surtout quand par ailleurs on défend fermement l&#39;industrie nucléaire. De plus, l&#39;éolien émet très peu de CO2, et même beaucoup moins que l&#39;industrie nucléaire : D&#39;après l&#39;ADEME, <a href=\"http://reseaudurable.com/bilan-carbone-production-electricite-france/\">12,7 grammes de CO2 par kWh</a>, contre  <a href=\"https://www.bastamag.net/Les-nucleaire-une-energie-sans-CO2-les-intox-d-EDF\">66 pour le nucléaire</a>. <a href=\"http://www.connaissancedesenergies.org/leolien-en-france-en-europe-et-dans-le-monde-quel-developpement-en-2015-160215\">La France a déjà pas mal de retard dans ce domaine par rapport aux autres pays européens</a>. <a href=\"https://negawatt.org/IMG/pdf/synthese_scenario-negawatt_2017-2050.pdf\">L&#39;éolien est parvenu beaucoup plus vite que prévu à devenir compétitif avec le nucléaire en terme de coûts</a>  et<a href=\"http://www.sortirdunucleaire.org/Pourquoi-il-faut-fermer-Fessenheim\"> le coût de construction d&#39;une éolienne se rembourse rapidement (6 mois)</a>.</p>\n<p>Le programme du FN n&#39;évoque pas non plus <a href=\"http://www.latribune.fr/entreprises-finance/industrie/energie-environnement/les-energies-marines-un-potentiel-encore-inexploite-575957.html\">les énergies marines, peu développées jusqu&#39;ici</a>, et si développer la production de bois est une bonne chose, cela doit se faire dans des conditions respectueuses des forêts et de leurs écosystèmes. L&#39;isolation de nombreux logements est essentielle, mais cette mesure est trop floue, et <a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">aucun budget n&#39;est prévu dans le financement du programme</a>.",
		"aec": "<strong><a href=\"https://www.lafaqdelavenirencommun.com/article/13/23/fr/quel-est-le-co%C3%BBt-du-programme-l_avenir-en-commun-.html\">Plan d&#39;investissement de 100 milliards</a></strong> financé par un emprunt auprès de la Banque Publique d&#39;Investissements (BPI), dont 25 milliards sont prévus pour entamer la transitions vers le 100% renouvelable, et 20 milliards pour l&#39;isolation thermique des logements.<br/><br><strong><a href=\"https://laec.fr/s39m1\">Adopter un plan de transition énergétique</a></strong> avec un double axe sobriété/efficacité énergétique et transition vers les énergies renouvelables.<br/><br><strong><a href=\"https://laec.fr/s39m3\">Créer un pôle public de l&#39;énergie</a></strong> en renationalisant EDF et Engie (ex-GDF) en lien avec des coopératives locales de production et de consommation d&#39;énergies renouvelables, en favorisant l&#39;autoproduction et le partage des excédents, en intégrant des <a href=\"https://avenirencommun.fr/le-livret-energie/\">formes de décentralisation et de contrôle citoyen</a>; Abroger la loi NOME et <a href=\"https://laec.fr/s39m4\">revenir sur la libéralisation du marché de l&#39;électricité</a>.<br/><br><strong><a href=\"https://laec.fr/s48m2\">Développer la filière bois française</a></strong> pour permettre une exploitation forestière respectueuse du rythme des forêts et de la biodiversité.<br/><br><strong><a href=\"https://laec.fr/s81m1\">Développer les énergies marines renouvelables</a></strong> (EMR) dans le cadre du plan de transition énergétique.<br/><br><strong><a href=\"https://laec.fr/s43m1\">Instaurer une tarification progressive sur l&#39;eau et l&#39;énergie</a></strong> incluant la gratuité des quantités indispensables à une vie digne et pénalisant les mésusages et les gaspillages.<br/><br><strong><a href=\"https://laec.fr/s40m1\">Plan d&#39;isolation</a></strong> pour au moins 700 000 logements par an.<br/><br><strong><a href=\"https://laec.fr/s40m2\">Renforcer les programmes locaux de détection</a></strong> des passoires énergétiques; <a href=\"https://laec.fr/s40m4\">Former, labelliser et coordonner</a> les professionnels de la rénovation énergétique; <a href=\"https://laec.fr/s40m5\">Mise en place d&#39;un guichet unique</a> pour organiser la rénovation par les propriétaires individuels.",
		"badge": {
			"text": "Très insuffisant",
			"color": "red"
		},
		"parent": "urgence-ecologique",
		"slug": "urgence-ecologique-renouvelables",
		"relatives": [
			{
				"title": "Nucléaire",
				"link": "urgence-ecologique-nucleaire"
			},
			{
				"title": "Énergies renouvelables",
				"link": "urgence-ecologique-renouvelables"
			},
			{
				"title": "Énergies fossiles et transports",
				"link": "urgence-ecologique-fossiles-transports"
			},
			{
				"title": "Agriculture",
				"link": "urgence-ecologique-agriculture"
			}
		]
	},
	"urgence-ecologique": {
		"title": "Urgence écologique",
		"main": true,
		"image": "urgence-ecologique",
		"pos": 5,
		"intro": "La grande urgence de notre époque est écologique. Avec le réchauffement climatique, la destruction des éco-systèmes, les méfaits de l&#39;agriculture productiviste, ce sont les conditions même de notre existence qui sont remises en cause. Face à cette évidence, le Front National a commencé à « verdir » son discours et à faire des propositions dans le domaine, pour développer les énergies renouvelables, interdire l&#39;exploitation du gaz de schiste et des OGM, ou protéger les animaux.</p>\n<p>Pourtant, les contradictions ne manquent pas. Le parti soutient totalement le nucléaire, et Marine Le Pen déclarait n&#39;être <a href=\"http://biosphere.blog.lemonde.fr/2016/12/30/front-national-un-programme-superficiellement-ecolo/\">« pas sûre que l’activité humaine soit l’origine principale », du réchauffement climatique</a>, alors qu&#39;il y a <a href=\"http://www.lemonde.fr/les-decodeurs/article/2014/11/04/climat-5-rapports-du-giec-5-chiffres-alarmants_4517326_4355770.html\">bien peu de doutes à ce sujet</a> , et elle considérait que « le GIEC, ce sont les prêtres et les évêques du changement climatique », alors que <a href=\"https://fr.wikipedia.org/wiki/Groupe_d%27experts_intergouvernemental_sur_l%27%C3%A9volution_du_climat\">l&#39;organisme, créé par l&#39;ONU, est composé de scientifiques reconnus</a>.</p>\n<p>On a aussi parfois l&#39;impression que l&#39;écologie sert de prétexte pour revenir aux thématiques traditionnelles du FN. Par exemple, le collectif « Nouvelle Ecologie », l&#39;antenne verte du FN, créé fin 2014, considérait que <a href=\"https://demosthene2012.wordpress.com/2015/02/15/les-eoliennes-contre-le-fn-1/\">les « phénomènes migratoires » sont une cause importante  du « saccage des ressources naturelles »</a> .<br>Aussi, quand il est question d&#39;interdire  « l’abattage sans étourdissement préalable », <a href=\"http://www.ladepeche.fr/article/2017/04/25/2562704-pen-veut-interdire-abattage-animaux-etourdissement-prealable.html\">ce sont bien le halal et casher qui sont visés.</a>",
		"subs": [
			{
				"title": "Nucléaire",
				"link": "urgence-ecologique-nucleaire"
			},
			{
				"title": "Énergies renouvelables",
				"link": "urgence-ecologique-renouvelables"
			},
			{
				"title": "Énergies fossiles et transports",
				"link": "urgence-ecologique-fossiles-transports"
			},
			{
				"title": "Agriculture",
				"link": "urgence-ecologique-agriculture"
			}
		],
		"slug": "urgence-ecologique"
	},
	"urgence-sociale-emploi": {
		"title": "Emploi",
		"main": false,
		"invisible": true,
		"image": "urgence-sociale",
		"fn": "→ [10] (…) « Instaurer une véritable liberté syndicale par la suppression du monopole de représentativité et moraliser la vie syndicale par un contrôle public du financement des syndicats.<br>→ [38] Supprimer sur notre territoire la directive « détachement des travailleurs » qui y crée une concurrence déloyale inadmissible. Mettre en place une taxe additionnelle sur l’embauche de salariés étrangers afin d’assurer effectivement la priorité nationale à l’emploi des Français.<br>→ [44] (...) Remplacement du compte pénibilité, inapplicable dans sa forme actuelle, par un nouveau dispositif reposant sur une évaluation personnalisée grâce à une médecine du travail qui sera reconstituée. La pénibilité constatée sera compensée par une majoration des annuités de retraite.<br>→ [46] Abaisser les charges sociales des TPE-PME de façon lisible et significative en fusionnant l’ensemble des dispositifs d’allègement des charges sociales de manière dégressive (le CICE sera transformé en allègement de charges et entrera dans le dispositif). Cet allègement de charges sera conditionné au maintien de l’emploi.<br>→ [53] Retirer la loi Travail (dite loi El Khomri).<br>→ [63] Maintenir la durée légale hebdomadaire du travail à 35 heures. Autoriser la négociation sur l’allongement du temps de travail exclusivement au niveau des branches professionnelles et à la condition d’une compensation salariale intégrale (37 heures payées 37 ou 39 heures payées 39).<br>→ [64] Défiscaliser les heures supplémentaires et maintenir leur majoration.<br>→ [82] Créer un dispositif « premier emploi » qui exonère totalement de charges la première embauche d’un jeune de moins de 21 ans par une entreprise et ce pour un délai maximum de 2 ans.",
		"fi": "Le FN annonce vouloir abroger la loi El Khomri, mais à propos cette loi, la 1ère chose que met en avant Marine Le Pen n&#39;est pas <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/05/10/loi-travail-quelle-est-cette-inversion-de-la-hierarchie-des-normes-qui-fait-debat_4916497_4355770.html\">l&#39;inversion de la hiérarchie des normes</a>. Mais <a href=\"http://www.rtl.fr/actu/politique/marine-le-pen-sur-rtl-la-loi-travail-justifie-et-legalise-les-revendications-communautaires-dans-l-entreprise-7782408999\">« un sujet dont personne ne parle (…) l&#39;autorisation des revendications communautaristes dans l&#39;entreprise »</a>, alors que cette loi <a href=\"http://www.20minutes.fr/economie/1929675-20160922-fait-religieux-entreprise-fait-dit-loi-travail\">« ne dit rien de plus que le Code du travail </a>» sur ce sujet. Le FN promet le maintien des 35 heures et du code du travail, mais n&#39;exclut pas <a href=\"http://www.europe1.fr/politique/le-fn-commence-a-lever-le-voile-sur-son-programme-economique-pour-2017-2785654\">des accords de branches donnant la possibilité de travailler plus</a>, et Marine Le Pen déclarait devant le Medef que <a href=\"https://www.youtube.com/watch?v=04w8huVI7vw\">« nous avons toujours été opposés aux 35h »</a>. La défiscalisation des heures supplémentaires est aussi une manière d&#39;y déroger, en incitant à utiliser des heures supplémentaires plutôt que de nouvelles embauches. Pourtant, un rapport montre que <a href=\"http://lexpansion.lexpress.fr/actualite-economique/les-35-heures-ont-cree-350-000-emplois-affirme-un-rapport-censure-de-l-igas_1813373.html\">pendant 4 ans, les 35H auraient permis de créer 350 000 postes</a>, avant que <a href=\"https://fr.wikipedia.org/wiki/R%C3%A9forme_des_35_heures_en_France#La_question_des_heures_suppl.C3.A9mentaires\">de nouvelles réformes</a> ne réduisent leur efficacité.</p>\n<p>La suppression du compte pénibilité est une autre régression, alors qu&#39;il <a href=\"https://www.marianne.net/debattons/blogs/les-economistes-atterres/programme-economique-et-social-du-fn-marine-le-pen-est-tout\">permettait des mesures de formation, de prévention et d’aménagement de l’emploi suivant des critères objectifs de pénibilité</a>. Un peu d&#39;argent en plus pour les retraités ne leur rendra pas la santé. Sur les syndicats, on peut penser que le FN cherche surtout à <a href=\"https://www.marianne.net/debattons/blogs/les-economistes-atterres/programme-economique-et-social-du-fn-marine-le-pen-est-tout\">affaiblir la représentation des salariés et favoriser le retour de « syndicats maison » dominés par les patrons</a>.</p>\n<p>Le FN semble penser que l&#39;immigration est la principale cause du chômage. Mais le travail n&#39;est pas une quantité fixe, et <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/10/10/idee-recue-sur-les-migrants-4-6-ils-volent-le-travail-des-francais_5011081_4355770.html\">il y a pas mal de restrictions au travail des étrangers</a> (il y a <a href=\"http://www.immigration.interieur.gouv.fr/Immigration/L-immigration-professionnelle/Liste-par-region-des-metiers-ouverts-aux-etrangers-non-ressortissants-d-un-Etat-membre-de-l-Union-europeenne-d-un-autre-Etat-partie-a-l-Espace-economique-europeen-ou-de-la-Confederation-suisse-Arrete-du-18-janvier-2008\">une liste de métiers pour les demandeurs d&#39;asile</a> par exemple). <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/02/05/eliminer-l-immigration-ne-reglera-pas-le-probleme-du-chomage_1546487\">Certaines études</a> montrent aussi que l&#39;immigration n&#39;est pas responsable du chômage. Les allègements de « charges » se sont multipliés depuis plusieurs décennies et s&#39;avèrent <a href=\"http://www.humanite.fr/exonerations-de-cotisations-cout-exorbitant-efficacite-douteuse-523868\">peu efficaces en terme de création d&#39;emplois, en plus d&#39;être très couteux</a>. Les contrats aidés sont <a href=\"http://www.vie-publique.fr/actualite/dossier/contrats-aides-impact-emploi/contrats-aides-quel-impact-emploi.html\">plus efficaces</a>, et surtout moins couteux, mais sous certaines conditions, de formation par exemple, qui permettent aux bénéficiaires de sortir durablement du chômage.",
		"aec": "<strong><a href=\"https://laec.fr/s28m2\">Appliquer réellement et immédiatement les 35 heures</a></strong> : Majorer les heures supplémentaires (25 % pour les 4 premières et 50 % et plus au-delà) ; Revenir sur la flexibilisation, l&#39;annualisation, l&#39;intensification et les horaires fractionnés ; Revenir sur le forfait-jour et le limiter aux seuls cadres dirigeants ; Revenir sur les élargissements du travail du dimanche.<br><strong><a href=\"https://laec.fr/s26m3\">Établir le droit opposable à l&#39;emploi</a></strong> en faisant de l&#39;État l&#39;employeur en dernier ressort : en cas de chômage de longue durée, l&#39;État doit proposer un emploi au chômeur en lien avec sa qualification, sur une mission d&#39;intérêt général. L&#39;indemnisation par l&#39;allocation chômage se poursuit jusqu&#39;à ce qu&#39;un tel emploi soit proposé par l&#39;État.<br><strong><a href=\"https://laec.fr/s24\">Abrogation de la loi El Khomri</a></strong> et rétablissement de la hiérarchie des normes et du principe de faveur.<br><strong><a href=\"https://fr.scribd.com/document/339809194/Chiffrage-projet-France-insoumise\">Créer</a></strong> 440 000 emplois aidés, 420 000 emplois publics, et 820 000 contrats coopératifs; <a href=\"https://laec.fr/s25m6\">Titulariser</a> tous les précaires des trois fonctions publiques.<br>Instaurer un <a href=\"https://laec.fr/s25m2\">quota maximum de contrats précaires dans les entreprises</a> : pas plus de 10 % de contrats précaires dans les PME, pas plus de 5 % de contrats précaires dans les grandes entreprises; <a href=\"https://laec.fr/s25m1\">Réaffirmer dans les faits le CDI</a> comme norme du contrat de travail; <a href=\"https://laec.fr/s25m4\">Lutter contre le temps partiel contraint</a> qui touche 80 % des femmes.<br>Généraliser une <strong><a href=\"https://laec.fr/s28m1\">6e semaine de congés payés</a></strong> pour tous les salariés.<br><strong><a href=\"https://laec.fr/s23m5\">Garantir et renforcer les pouvoirs de l&#39;Inspection du travail</a></strong> et des instances représentatives de salariés, <a href=\"https://avenirencommun.fr/le-livret-travail/\">doubler ses effectifs</a> pour lui permettre d&#39;être plus efficace dans la protection de l&#39;emploi et des salariés, dans la lutte contre la souffrance au travail et dans l&#39;assistance juridique aux PME. <a href=\"https://laec.fr/s70m1\">Déclarer</a> la souffrance au travail grande cause nationale.",
		"badge": {
			"text": "Mensonger",
			"color": "red"
		},
		"parent": "urgence-sociale",
		"slug": "urgence-sociale-emploi",
		"relatives": [
			{
				"title": "Emploi",
				"link": "urgence-sociale-emploi"
			},
			{
				"title": "Pouvoir d'achat",
				"link": "urgence-sociale-pouvoir-achat"
			},
			{
				"title": "Logement",
				"link": "urgence-sociale-logement"
			},
			{
				"title": "Retraites",
				"link": "urgence-sociale-retraites"
			}
		]
	},
	"urgence-sociale-logement": {
		"title": "Logement",
		"main": false,
		"invisible": true,
		"image": "urgence-sociale",
		"fn": "→ [139] Regrouper en un seul ministère l’aménagement du territoire, les transports et le logement. Rééquilibrer la politique de la ville vers les zones désertifiées et rurales.<br>→ [140] Faciliter l’accès à la propriété en renforçant les dispositifs de prêts aidés et en améliorant les conditions de rachat par les locataires de leur logement social pour parvenir à 1 % du parc HLM vendu chaque année. Réduire les droits de mutation de 10 %.<br>→ [141] Réduire les dépenses de logement des ménages par un grand plan d’aide à la construction et à la réhabilitation des logements, par la baisse de la taxe d’habitation pour les plus modestes et le gel de son augmentation, et par la pérennisation des APL (suppression de la prise en compte du patrimoine dans leur calcul). Créer une «Protection-Logement-Jeunes» : lancer un grand plan de construction de logements étudiants et revaloriser de 25 % les APL pour les jeunes jusqu’à 27 ans dès la première année du quinquennat.<br>→ [142] Réserver prioritairement aux Français l’attribution du logement social, sans effet<br>rétroactif, et le mobiliser vers les publics qui en ont le plus besoin. Appliquer<br>réellement l’obligation de jouissance paisible sous peine de déchéance du bail.<br>→ [143] Rationaliser et simplifier les normes d’urbanisme et de construction afin de résorber les tensions sur le marché du logement.",
		"fi": "La réduction des droits de mutation, ou « frais de notaire », avantagerait surtout les plus gros propriétaires, d&#39;autant plus que ces droits sont actuellement <a href=\"http://www.capital.fr/immobilier/tribune/henry-buzy-cazaux/suppression-des-droits-de-mutation-la-drole-de-promesse-du-candidat-francois-fillon-1192824\">d&#39;environ 8% pour l&#39;ancien et de 2% pour le neuf</a>. La revente de HLM <a href=\"https://www.service-public.fr/particuliers/vosdroits/F282\">existe déjà</a>, comme <a href=\"https://ekonomia.fr/comment/immobilier/pret-accession-sociale/\">les prêts aidés pour leur achat</a>. En 2014, environ <a href=\"http://inovefa.com/chiffres-logement-social-france/\">10 000 des 4 760 500 logements logements sociaux étaient vendus</a>, soit un peu plus de 0,20%. Mais seule une petite partie des logements est vendable: Ils doivent avoir <a href=\"http://www.explorimmo.com/edito/actualite-immobiliere/detail/article/hlm-comment-acheter-un-logement-social.html\">plus de 10 ans, et être aux dernières normes</a>. Si on retire aussi ceux des <a href=\"http://www.vie-publique.fr/actualite/alaune/logement-social-1-115-communes-ne-respectent-pas-loi-sru.html\">nombreuses communes</a> qui ne respectent pas la <a href=\"https://fr.wikipedia.org/wiki/Loi_relative_%C3%A0_la_solidarit%C3%A9_et_au_renouvellement_urbains\">loi SRU</a>, qui exige 25% de logements sociaux, <a href=\"http://www.lemonde.fr/logement/article/2015/01/13/les-ventes-de-logements-sociaux-ne-decollent-pas_4555164_1653445.html\">d&#39;après Denis Landard</a> (de l’Union sociale pour l’habitat), en 2013 il n&#39;en restait qu&#39;environ 800 000. Avec environ 8000 ventes, on arrivait donc à 1%. Mais sans tenir compte de ces restrictions, atteindre les 1% réduirait fortement le parc social accessible à la location, alors qu&#39;il y a déjà actuellement <a href=\"http://www.logement.gouv.fr/les-chiffres-du-logement-social\">1,8 millions de demandes</a> en attente, et <a href=\"http://www.francetvinfo.fr/economie/mal-logement-cinq-chiffres-cles-a-retenir-du-rapport-annuel-de-la-fondation-abbe-pierre_1278051.htm\">3,8 millions personnes mal logées</a>. Pour l&#39;accès au logement, le FN ne compte encore une fois que sur la « priorité nationale », mais aujourd&#39;hui, <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/03/08/non-marine-le-pen-les-etrangers-ne-sont-pas-prioritaires-pour-obtenir-un-logement-social_1554040\">88% des logements sociaux sont occupés par des français, et les sans-papiers ou demandeurs d’asile n’y ont pas droit</a>.</p>\n<p>Pour le « grand plan d&#39;aide à la construction », les bénéficiaires pourraient être de petits propriétaires comme des promoteurs immobiliers ou des banques, et rien ne garantira alors que les loyers baisseront. La part des revenus qu&#39;un ménage consacre à son loyer ne cesse d&#39;augmenter, <a href=\"http://lexpansion.lexpress.fr/actualite-economique/logement-montee-des-inegalites-entre-proprietaires-et-locataires_1881238.html\">à court</a> ou à <a href=\"http://www.cgedd.fr/loyer-revenu-2013.pdf\">long-terme</a>, et la hausse des loyers est en grande partie due à la <a href=\"http://www.humanite.fr/le-grand-paris-voie-express-pour-la-speculation-immobiliere-611808\">spéculation immobilière de promoteurs qui cherchent à faire monter les prix</a>.</p>\n<p><a href=\"https://fr.wikipedia.org/wiki/Plan_local_d%27urbanisme\">Les plans d&#39;urbanisme sont essentiellement locaux</a>, et comportent de nombreuses règles, en particulier environnementales, sociales et légales, qu&#39;il serait dangereux de ne pas respecter. Cela pourrait <a href=\"https://www.bastamag.net/L-hyper-concentration-de-terres-aux-mains-d-une-elite-n-epargne-aucun-pays\">favoriser la spéculation foncière</a>, au détriment des forêts et des champs, alors que <a href=\"http://filiere-paysanne.blogspot.fr/p/preservation-des-terres.html\">pour l&#39;association « Filière paysanne »</a>, 78000 hectares de surface agricole disparaissent déjà tous les ans. Enfin, on peut penser que fusionner les ministères du logement et des transports serait une manière de diminuer leurs ressources.",
		"aec": "<strong><a href=\"https://laec.fr/s34m2\">Construire 200 000 logements publics</a></strong> par an pendant cinq ans aux normes écologiques en augmentant notamment le mécanisme d’« aide à la pierre » ; Produire <a href=\"https://avenirencommun.fr/le-livret-logement/\">15 000 logements sociaux étudiants</a> par an ; Assurer <a href=\"https://laec.fr/s40m1\">l&#39;isolation d&#39;au moins 700 000 logements</a> par an.<br><strong>Mettre en place une <a href=\"https://laec.fr/s34m3\">garantie universelle des loyers</a></strong> pour favoriser l&#39;accès de tous au logement, par l&#39;intermédiaire d&#39;une caisse de solidarité alimentée par les bailleurs.<br><strong><a href=\"https://avenirencommun.fr/le-livret-logement/\">Revaloriser les aides personnelles au logement</a></strong> et supprimer le mois de carence avant la perception des premières APL ;<a href=\"https://avenirencommun.fr/le-livret-logement/\"> Encadrer véritablement les loyers à la baisse</a>, autour du loyer médian dans les zones normales et en imposant une décote de 20 % au loyer médian dans les zones très tendues ; <a href=\"https://avenirencommun.fr/le-livret-logement/\">Plafonner les loyers dans le secteur HLM</a> pour ne pas dépasser 20 % du revenu des ménages.<br><a href=\"https://laec.fr/s34m4\">Renforcer les sanctions</a> des communes trop faiblement dotées en parc social ; <a href=\"https://avenirencommun.fr/le-livret-logement/\">Augmenter à 30 % le quota minimum de logements sociaux</a> dans les communes soumises à une forte tension locative ; Introduire une obligation de 30 % de logements sociaux dans les opérations neuves et de 40 % en zones tendues.<br><strong><a href=\"https://avenirencommun.fr/le-livret-logement/\">Rendre plus justes et transparentes les attributions de logements</a></strong>, veiller au respect des obligations sociales dans ces procédures et permettre aux associations de mal logés de siéger dans les commissions d’attribution.<br><strong><a href=\"https://avenirencommun.fr/le-livret-logement/\">Généraliser</a></strong> les mesures du type clauses anti-spéculatives et les chartes promoteurs qui permettent d’encadrer les prix à la vente ; <a href=\"https://avenirencommun.fr/le-livret-logement/\">Interdire</a> les ventes à la découpe ; Arrêter immédiatement les aides fiscales à l’investissement locatif privé ; <a href=\"https://laec.fr/s34m5\">Imposer les hautes transactions immobilières</a> par une taxe progressive.<br><strong><a href=\"https://avenirencommun.fr/le-livret-logement/\">Réformer le financement de la rénovation</a></strong> pour permettre aux propriétaires les plus modestes d’en bénéficier; <a href=\"https://avenirencommun.fr/le-livret-logement/\">Mettre en place un « guichet unique »</a> pour organiser la rénovation par les propriétaires individuels, pour les demandes de financement, l’évaluation des besoins et la coordination des professionnels.<br><strong><a href=\"https://avenirencommun.fr/le-livret-logement/\">Développer un patrimoine foncier public échappant à la spéculation</a></strong> au niveau des collectivités et des agences foncières. La propriété du sol serait publique et l’usage serait loué aux particuliers, aux bailleurs privés et publics.",
		"badge": {
			"text": "Mensonger",
			"color": "red"
		},
		"parent": "urgence-sociale",
		"slug": "urgence-sociale-logement",
		"relatives": [
			{
				"title": "Emploi",
				"link": "urgence-sociale-emploi"
			},
			{
				"title": "Pouvoir d'achat",
				"link": "urgence-sociale-pouvoir-achat"
			},
			{
				"title": "Logement",
				"link": "urgence-sociale-logement"
			},
			{
				"title": "Retraites",
				"link": "urgence-sociale-retraites"
			}
		]
	},
	"urgence-sociale-pouvoir-achat": {
		"title": "Pouvoir d'achat",
		"main": false,
		"invisible": true,
		"image": "urgence-sociale",
		"fn": "→ [59] Instaurer une Prime de Pouvoir d’Achat (PPA) à destination des bas revenus et des petites retraites (pour les revenus jusqu’à 1 500 euros par mois), financée par une Contribution Sociale sur les Importations de 3 %.<br>→ [60] Baisser immédiatement de 5 % les tarifs réglementés du gaz et de l’électricité.<br>→ [64] Défiscaliser les heures supplémentaires et maintenir leur majoration.<br>→ [74] Assurer une juste contribution fiscale, en refusant toute hausse de la TVA et de la CSG et en maintenant l’ISF.<br>→ [75] Baisser de 10 % l’impôt sur le revenu sur les trois premières tranches.<br>→ [76] Opérer une simplification fiscale en supprimant les impôts à très faible rendement.<br>→ [86] Dégeler et revaloriser le point d’indice pour les fonctionnaires. Préserver le<br>statut de la fonction publique. Dans un souci d’égalité, établir à deux jours le délai de carence dans le public et le privé<br>→ [141] Réduire les dépenses de logement des ménages par un grand plan d’aide à la construction et à la réhabilitation des logements, par la baisse de la taxe d’habitation pour les plus modestes et le gel de son augmentation, et par la pérennisation des APL (suppression de la prise en compte du patrimoine dans leur calcul). Créer une «Protection-Logement-Jeunes» : lancer un grand plan de construction de logements étudiants et revaloriser de 25 % les APL pour les jeunes jusqu’à 27 ans dès la première année du quinquennat.",
		"fi": "La baisse de l&#39;impôt sur le revenu des plus basses tranches devrait augmenter leur pouvoir d&#39;achat, mais l&#39;impôt sur le revenu <a href=\"http://www.lefigaro.fr/economie/le-scan-eco/dessous-chiffres/2015/07/29/29006-20150729ARTFIG00006-en-france-pour-100-euros-nets-il-faut-235-euros-de-salaire-super-brut.php\">ne représente que 7% des prélèvements obligatoires </a>, là où la TVA en représente 16% par exemple. <a href=\"http://www.lefigaro.fr/economie/le-scan-eco/dessous-chiffres/2016/04/12/29006-20160412ARTFIG00206-7-chiffres-etonnants-sur-les-impots-de-2015.php\">Moins d&#39;un foyer sur deux le paye</a> actuellement, et cette mesure ne changera donc rien pour les plus pauvres. Sur les impôts à très faible rendement, on ne sait pas desquels il s&#39;agit.</p>\n<p>Les mesures du FN n&#39;augmenteront quasiment pas le pouvoir d&#39;achat des locataires, sauf pour les moins de 27 ans touchant les APL. Pour la taxe d&#39;habitation, les plus modestes sont déjà exonérés (ceux au RSA par exemple), et <a href=\"http://atterres.org/sites/default/files/Note%20Macron_1.pdf\">40% des ménages ont une exonération ou un plafonnement</a>. Et les réduire encore fera baisser le budget des collectivités locales. Pas de quoi enrayer donc la <a href=\"http://lexpansion.lexpress.fr/actualite-economique/logement-montee-des-inegalites-entre-proprietaires-et-locataires_1881238.html\">hausse continuelle</a> de la part des revenus que les ménages consacrent à leurs loyers <a href=\"http://www.cgedd.fr/loyer-revenu-2013.pdf\">depuis des décénnies</a>. Baisser les tarifs d&#39;électricité et de gaz de 5% est une bonne chose, mais c&#39;est assez faible quand on sait qu&#39;<a href=\"http://www.capital.fr/finances-perso/actualites/la-verite-sur-la-facture-edf-elle-a-augmente-de-plus-de-37-en-10-ans-1138729\">entre 2006 et 2016, le prix de l&#39;électricité à augmenté de 37%</a>.</p>\n<p>Pour les fonctionnaires, on ne sait pas à quel niveau le point d&#39;indice sera revalorisé. <a href=\"http://www.lagazettedescommunes.com/433832/salaires-des-fonctionnaires-le-point-dindice-augmente-de-12-en-deux-temps/\">Son dégel a déjà eu lieu, même d&#39;une manière très modeste</a>, alors qu&#39;il avait été gelé 6 ans entre 2010 et 2016, <a href=\"http://france-inflation.com/calculateur_inflation.php\">pendant lesquels l&#39;inflation a été d&#39;environ 7%</a>. Ils perdront aussi en pouvoir d&#39;achat <a href=\"http://www.francetvinfo.fr/politique/marine-le-pen/salarie-chomeur-retraite-si-marine-le-pen-devenait-presidente-voici-ce-qui-changerait-pour-vous_2051145.html\">en n&#39;étant plus indemnisés dès le premier jour lors d&#39;un arrêt maladie</a>, alors que les salariés du privé le seront dès le 2ème jour (au lieu du 3ème actuellement).</p>\n<p>Les mesures protectionnistes prévues par le FN devraient aussi provoquer une hausse des prix bien plus importante que ce que prévoit le parti (<a href=\"https://www.marine2017.fr/wp-content/uploads/2017/02/texte-chiffrage-version-finale-.pdf\">« hausse progressive jusqu&#39;à « 2,5% à compter de 2020 »</a>). Cette inflation devrait annuler en grande partie les gains de pouvoir d&#39;achat de la Prime de Pouvoir d&#39;Achat (PPA), sans compter les effets d&#39;une éventuelle sortie de l&#39;euro.",
		"aec": "<strong><a href=\"https://laec.fr/s30m1\">Augmenter immédiatement le smic</a></strong> net mensuel de 16 % pour le porter à 1 326 euros net pour 35 heures  ; Engager une <a href=\"https://laec.fr/s30m2\">revalorisation des salaires des fonctionnaires</a>, gelés depuis 2010  . Revaloriser le point d’indice de <a href=\"https://fr.scribd.com/document/339809194/Chiffrage-projet-France-insoumise\">6,7% </a>.<br>Créer une <strong><a href=\"https://laec.fr/s33m2\">garantie dignité</a></strong> en revalorisant les minima sociaux (aucun niveau de vie en dessous du seuil de pauvreté)  ; <a href=\"https://laec.fr/s31m2\">Revaloriser les pensions de retraite </a>au niveau du smic pour une carrière complète et porter le minimum vieillesse au niveau du seuil de pauvreté.<br>Instaurer une <strong><a href=\"https://laec.fr/s27m1\">allocation d&#39;autonomie pour les jeunes</a></strong> de 18 à 25 ans, d&#39;une durée de trois ans, sous réserve d&#39;une formation qualifiante et sous condition de ressources.<br>Instaurer la <strong><a href=\"https://laec.fr/s33m5\">gratuité de l&#39;accès et des quantités d&#39;eau, électricité et gaz indispensables à une vie digne</a></strong> en commençant par faire appliquer l&#39;interdiction de coupure d&#39;eau et de réduction de débit au domicile principal  ; Instaurer une <a href=\"https://laec.fr/s43m1\">tarification progressive</a> sur l&#39;eau et l&#39;énergie.<br><strong><a href=\"https://laec.fr/s36m1\">Refonder</a></strong> l&#39;imposition sur les revenus.<br>Réduire la <strong><a href=\"https://laec.fr/s36m6\">TVA sur les produits de première nécessité</a></strong>.<br><strong><a href=\"https://laec.fr/s68m3\">Augmenter l&#39;allocation aux adultes handicapés</a></strong> (808 euros de base aujourd&#39;hui) au niveau du smic pour les personnes en situation de handicap dans l&#39;incapacité totale de travailler.<br>Verser une <strong><a href=\"https://laec.fr/s72m1\">allocation familiale dès le premier enfant</a></strong>.<br>Assurer la <strong><a href=\"https://laec.fr/s73m3\">gratuité réelle de l&#39;éducation publique</a></strong>, pour les fournitures, la cantine, les transports et les activités périscolaires.",
		"badge": {
			"text": "Mensonger",
			"color": "red"
		},
		"parent": "urgence-sociale",
		"slug": "urgence-sociale-pouvoir-achat",
		"relatives": [
			{
				"title": "Emploi",
				"link": "urgence-sociale-emploi"
			},
			{
				"title": "Pouvoir d'achat",
				"link": "urgence-sociale-pouvoir-achat"
			},
			{
				"title": "Logement",
				"link": "urgence-sociale-logement"
			},
			{
				"title": "Retraites",
				"link": "urgence-sociale-retraites"
			}
		]
	},
	"urgence-sociale-retraites": {
		"title": "Retraites",
		"main": false,
		"invisible": true,
		"image": "urgence-sociale",
		"fn": "→ [52] Fixer l’âge légal de la retraite à 60 ans avec 40 annuités de cotisations pour percevoir une retraite pleine.<br>→ [54] Rehausser progressivement le plafond du quotient familial, rétablir la demi-part des veuves et veufs et la défiscalisation de la majoration des pensions de retraite pour les parents de famille nombreuse.<br>→ [55] Mettre en œuvre une vraie politique nataliste réservée aux familles françaises, en rétablissant l’universalité des allocations familiales et en maintenant leur indexation sur le coût de la vie. Rétablir la libre répartition du congé parental entre les deux parents.<br>→ [56] Renforcer la solidarité intergénérationnelle en permettant à chaque parent de transmettre sans taxation 100 000 euros à chaque enfant tous les cinq ans (au lieu de quinze ans actuellement) et en augmentant le plafond des donations sans taxation aux petits-enfants à 50 000 euros, également tous les cinq ans.<br>→ [58] Revaloriser le minimum vieillesse (ASPA) partout en France, y compris Outre-mer, et le conditionner à la nationalité française ou à vingt ans de résidence en France, ce qui permettra également d’augmenter les très petites retraites.",
		"fi": "Sur la réforme des retraites, Marine Le Pen <a href=\"https://www.politis.fr/articles/2016/07/marine-le-pen-tombe-le-masque-35119/\">à indiqué que</a> si « récupérer les dépenses exorbitantes de l’immigration, de la fraude sociale, de la décentralisation anarchique » ne suffisait pas à la financer, « alors nous nous tournerons vers les Français en leur disant la vérité », et ceux-ci « accepteront les sacrifices qu’on leur demandera ». Comme <a href=\"http://analysonslefn.fr/themes/economie-finance-budget\">les dépenses en question n&#39;ont rien d&#39; « exorbitantes »</a>, on peut penser que ce sera l&#39;option « sacrifice » qui sera choisie. Pendant le second tour des présidentielles, <a href=\"http://www.liberation.fr/elections-presidentielle-legislatives-2017/2017/05/03/le-pen-et-la-retraite-a-60-ans-le-grand-revirement_1567014\">elle a aussi déclaré</a> que sa promesse sera effective « probablement à la fin du quinquennat » parce qu&#39;avant « il faut qu’on la finance, par évidemment l’emploi ». Mais comme le mot « chômage » ne figure même pas dans le programme...</p>\n<p>Le FN veut réduire l&#39;accès des étrangers au minimum vieillesse (ou ASPA, accès déjà réduit car il faut avoir un titre de séjour depuis au moins 10 ans), mais on sait qu&#39;<a href=\"http://www.liberation.fr/france/2014/10/31/etrangers-et-minimum-vieillesse-l-intox-infinie-de-l-ump_1131728\">actuellement les étrangers sont très minoritaires parmi les bénéficiaires</a>. Marine Le Pen a évoqué une <a href=\"http://www.la-croix.com/France/Politique/Retraite-quenvisagent-Emmanuel-Macron-Marine-Le-Pen-2017-05-02-1200844026\">revalorisation de 20%</a>, ce qui <a href=\"https://www.insee.fr/fr/statistiques/fichier/2492211/FPORSOC16l2_F4.2_pauvrete.pdf\">maintiendrait ce revenu en dessous du seuil de pauvreté</a>. Défiscaliser la majoration des pensions de retraite pour les parents de familles nombreuses et rétablir la demi-part des veuves et veufs devrait leur faire gagner un peu de pouvoir d&#39;achat, mais avec ces nouvelles baisses de recettes, se pose encore <a href=\"http://analysonslefn.fr/themes/economie-finance-budget\">le problème du financement</a>.</p>\n<p>Pour le Front National, la politique familiale relève comme d&#39;autres domaines de la <a href=\"http://analysonslefn.fr/themes/immigration-laicite-priorite-nationale\">« priorité nationale »</a> que le parti veut imposer. Elle se révèle surtout des plus injustes et discriminatoires, et aggraverait sûrement des problèmes comme la délinquance juvénile, ou l&#39;exclusion sociale. Il faut aussi savoir que les demandeurs d’asile, comme les sans-papiers, <a href=\"http://www.lemonde.fr/les-decodeurs/article/2016/10/11/idee-recue-sur-les-migrants-5-6-ils-viennent-profiter-des-allocations_5011832_4355770.html\">ne peuvent déjà pas toucher d&#39;allocations familiales</a>. Enfin, la « solidarité intergénérationnelle » voulue par le FN vise surtout à donner plus de ressources aux enfants de bonne famille, favorisant la reproduction sociale au détriment de la méritocratie. Par exemple, une famille pourrait transmettre à chaque enfant jusqu&#39;à 20 000 euros/an contre moins de 7000 aujourd&#39;hui.",
		"aec": "<strong><a href=\"https://laec.fr/s31m1\">Restaurer le droit à la retraite à 60 ans</a></strong> à taux plein, ramener la durée de cotisation pour une retraite complète à quarante ans.<br><strong><a href=\"https://laec.fr/s31m2\">Revaloriser les pensions de retraite</a></strong> au niveau du smic pour une carrière complète et porter le minimum vieillesse au niveau du seuil de pauvreté.<br>Verser une <strong><a href=\"https://laec.fr/s72m1\">allocation familiale dès le premier enfant</a></strong>.<br><strong><a href=\"https://laec.fr/s71m3\">Développer un réseau public de maisons de retraite</a></strong> avec des tarifs harmonisés et accessibles, créer 10 000 places par an en EHPAD publics pendant cinq ans.<br><strong><a href=\"https://laec.fr/s31m3\">Assurer le financement durable des régimes de retraites solidaires</a></strong>, intergénérationnelles et par répartition, par la mise en contribution des revenus financiers des entreprises, par l&#39;augmentation du nombre de cotisants et de l&#39;assiette des cotisations (créations d&#39;emplois, hausse des salaires, recul de la précarité, hausse de l&#39;activité des femmes, etc.) et de leur taux, la fin des exonérations fiscales pour les régimes de retraite par capitalisation.<br><strong><a href=\"https://laec.fr/s71m1\">Réduire le reste à charge de 500 euros par mois</a></strong> pour les personnes en établissement et augmenter de 50 % le montant de l&#39;APA (aujourd&#39;hui de 700 euros) pour les personnes restant à domicile, pour faire face en urgence aux frais engagés par les personnes concernées.<br>Créer un <strong><a href=\"https://laec.fr/s72m2\">service public de la petite enfance et ouvrir 500 000 places en crèche</a></strong> et modes de garde adaptés dans les cinq ans.<br><strong><a href=\"https://laec.fr/s32m4\">Favoriser</a></strong> des congés parentaux de durée identique entre les parents.",
		"badge": {
			"text": "Méfiance",
			"color": "orange"
		},
		"parent": "urgence-sociale",
		"slug": "urgence-sociale-retraites",
		"relatives": [
			{
				"title": "Emploi",
				"link": "urgence-sociale-emploi"
			},
			{
				"title": "Pouvoir d'achat",
				"link": "urgence-sociale-pouvoir-achat"
			},
			{
				"title": "Logement",
				"link": "urgence-sociale-logement"
			},
			{
				"title": "Retraites",
				"link": "urgence-sociale-retraites"
			}
		]
	},
	"urgence-sociale": {
		"title": "Urgence sociale",
		"main": true,
		"image": "urgence-sociale",
		"pos": 6,
		"intro": "Depuis la crise du libéralisme économique de 2008, qui a servi de prétexte à la précarisation des travailleurs et à l&#39;abaissement des droits sociaux, <a href=\"http://bfmbusiness.bfmtv.com/france/comment-le-fn-est-passe-de-l-ultra-liberalisme-a-l-etat-protecteur-933363.html\">le Front National s&#39;est mis à prôner un Etat fort</a>, face à la mondialisation et la dérégulation. Si les problématiques sociales semblent importantes dans les discours du FN, dans le programme, elles le sont beaucoup moins. Malgré un chômage toujours proche de 10%, une flexibilisation et une précarisation du travail accélérée par la loi El Khomri, l&#39;emploi semble être un problème secondaire pour ce parti. Le terme « chômage » n&#39;apparait même pas dans son programme, et « précarité » seulement deux fois (une pour le droit des femmes, et l&#39;autre pour la « précarité énergétique »). Dans ce domaine, comme en matière de logement, de retraites ou de pouvoir d&#39;achat, le FN défend la <a href=\"https://analysonslefn.fr/themes/immigration-laicite-priorite-nationale\">« priorité nationale »</a> et pense que « le problème de l&#39;immigration » est prioritaire. Tout en défendant des solutions au fond très libérales, accompagnées de quelques mesures sociales finalement très réduites.",
		"subs": [
			{
				"title": "Emploi",
				"link": "urgence-sociale-emploi"
			},
			{
				"title": "Pouvoir d'achat",
				"link": "urgence-sociale-pouvoir-achat"
			},
			{
				"title": "Logement",
				"link": "urgence-sociale-logement"
			},
			{
				"title": "Retraites",
				"link": "urgence-sociale-retraites"
			}
		],
		"slug": "urgence-sociale"
	}
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * Vue.js v2.3.0
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
/*  */

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return typeof value === 'string' || typeof value === 'number'
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

var toString = Object.prototype.toString;

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return toString.call(v) === '[object RegExp]'
}

/**
 * Convert a value to a string that is actually rendered.
 */
function _toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /([^-])([A-Z])/g;
var hyphenate = cached(function (str) {
  return str
    .replace(hyphenateRE, '$1-$2')
    .replace(hyphenateRE, '$1-$2')
    .toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 */
function noop () {}

/**
 * Always return false.
 */
var no = function () { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      return JSON.stringify(a) === JSON.stringify(b)
    } catch (e) {
      // possible circular reference
      return a === b
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

var emptyObject = Object.freeze({});

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

var warn = noop;
var tip = noop;
var formatComponentName;

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.error("[Vue warn]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var name = typeof vm === 'string'
      ? vm
      : typeof vm === 'function' && vm.options
        ? vm.options.name
        : vm._isVue
          ? vm.$options.name || vm.$options._componentTag
          : vm.name;

    var file = vm._isVue && vm.$options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  var generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

function handleError (err, vm, info) {
  if (config.errorHandler) {
    config.errorHandler.call(null, err, vm, info);
  } else {
    if (false) {
      warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
    }
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
      console.error(err);
    } else {
      throw err
    }
  }
}

/*  */
/* globals MutationObserver */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    } )); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

/**
 * Defer a task to execute it asynchronously.
 */
var nextTick = (function () {
  var callbacks = [];
  var pending = false;
  var timerFunc;

  function nextTickHandler () {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  }

  // the nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:
  /* istanbul ignore if */
  if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p = Promise.resolve();
    var logError = function (err) { console.error(err); };
    timerFunc = function () {
      p.then(nextTickHandler).catch(logError);
      // in problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.
      if (isIOS) { setTimeout(noop); }
    };
  } else if (typeof MutationObserver !== 'undefined' && (
    isNative(MutationObserver) ||
    // PhantomJS and iOS 7.x
    MutationObserver.toString() === '[object MutationObserverConstructor]'
  )) {
    // use MutationObserver where native Promise is not available,
    // e.g. PhantomJS IE11, iOS7, Android 4.4
    var counter = 1;
    var observer = new MutationObserver(nextTickHandler);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
      characterData: true
    });
    timerFunc = function () {
      counter = (counter + 1) % 2;
      textNode.data = String(counter);
    };
  } else {
    // fallback to setTimeout
    /* istanbul ignore next */
    timerFunc = function () {
      setTimeout(nextTickHandler, 0);
    };
  }

  return function queueNextTick (cb, ctx) {
    var _resolve;
    callbacks.push(function () {
      if (cb) {
        try {
          cb.call(ctx);
        } catch (e) {
          handleError(e, ctx, 'nextTick');
        }
      } else if (_resolve) {
        _resolve(ctx);
      }
    });
    if (!pending) {
      pending = true;
      timerFunc();
    }
    if (!cb && typeof Promise !== 'undefined') {
      return new Promise(function (resolve, reject) {
        _resolve = resolve;
      })
    }
  }
})();

var _Set;
/* istanbul ignore if */
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
]
.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var arguments$1 = arguments;

    // avoid leaking arguments:
    // http://jsperf.com/closure-with-arguments
    var i = arguments.length;
    var args = new Array(i);
    while (i--) {
      args[i] = arguments$1[i];
    }
    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
        inserted = args;
        break
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true,
  isSettingProps: false
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value)) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
        }
        if (Array.isArray(value)) {
          dependArray(value);
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && typeof key === 'number') {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (hasOwn(target, key)) {
    target[key] = val;
    return val
  }
  var ob = (target ).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && typeof key === 'number') {
    target.splice(key, 1);
    return
  }
  var ob = (target ).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        childVal.call(this),
        parentVal.call(this)
      )
    }
  } else if (parentVal || childVal) {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm)
        : undefined;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (parentVal, childVal) {
  var res = Object.create(parentVal || null);
  return childVal
    ? extend(res, childVal)
    : res
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal) {
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key in childVal) {
    var parent = ret[key];
    var child = childVal[key];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key] = parent
      ? parent.concat(child)
      : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.computed = function (parentVal, childVal) {
  if (!childVal) { return Object.create(parentVal || null) }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  extend(ret, childVal);
  return ret
};

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    var lower = key.toLowerCase();
    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
      warn(
        'Do not use built-in or reserved HTML elements as component ' +
        'id: ' + key
      );
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  }
  options.props = res;
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (false) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      'Invalid prop: type check failed for prop "' + name + '".' +
      ' Expected ' + expectedTypes.map(capitalize).join(', ') +
      ', got ' + Object.prototype.toString.call(value).slice(8, -1) + '.',
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    valid = typeof value === expectedType.toLowerCase();
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      "referenced during render. Make sure to declare reactive data " +
      "properties in the data option.",
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.functionalContext = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
};

var prototypeAccessors = { child: {} };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function () {
  var node = new VNode();
  node.text = '';
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isCloned = true;
  return cloned
}

function cloneVNodes (vnodes) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i]);
  }
  return res
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      for (var i = 0; i < fns.length; i++) {
        fns[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, cur, old, event;
  for (name in on) {
    cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    last = res[res.length - 1];
    //  nested
    if (Array.isArray(c)) {
      res.push.apply(res, normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i)));
    } else if (isPrimitive(c)) {
      if (isDef(last) && isDef(last.text)) {
        (last).text += String(c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isDef(c.text) && isDef(last) && isDef(last.text)) {
        res[res.length - 1] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isDef(c.tag) && isUndef(c.key) && isDef(nestedIndex)) {
          c.key = "__vlist" + ((nestedIndex)) + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            reject(
               false
                ? ("timeout (" + (res.timeout) + "ms)")
                : null
            );
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && isDef(c.componentOptions)) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once$$1) {
  if (once$$1) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        this$1.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (arguments.length === 1) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        cbs[i].apply(vm, args);
      }
    }
    return vm
  };
}

/*  */

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  var defaultSlot = [];
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.functionalContext === context) &&
        child.data && child.data.slot != null) {
      var name = child.data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children);
      } else {
        slot.push(child);
      }
    } else {
      defaultSlot.push(child);
    }
  }
  // ignore whitespace
  if (!defaultSlot.every(isWhitespace)) {
    slots.default = defaultSlot;
  }
  return slots
}

function isWhitespace (node) {
  return node.isComment || node.text === ' '
}

function resolveScopedSlots (
  fns
) {
  var res = {};
  for (var i = 0; i < fns.length; i++) {
    res[fns[i][0]] = fns[i][1];
  }
  return res
}

/*  */

var activeInstance = null;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // remove reference to DOM nodes (prevents leak)
    vm.$options._parentElm = vm.$options._refElm = null;
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure((name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure((name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  vm._watcher = new Watcher(vm, updateComponent, noop);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render
  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    if (false) {
      observerState.isSettingProps = true;
    }
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    if (false) {
      observerState.isSettingProps = false;
    }
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }
  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdateHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdateHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i >= 0 && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(Math.max(i, index) + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options
) {
  this.vm = vm;
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  if (this.user) {
    try {
      value = this.getter.call(vm, vm);
    } catch (e) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    }
  } else {
    value = this.getter.call(vm, vm);
  }
  // "touch" every property so they are all tracked as
  // dependencies for deep watching
  if (this.deep) {
    traverse(value);
  }
  popTarget();
  this.cleanupDeps();
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
var seenObjects = new _Set();
function traverse (val) {
  seenObjects.clear();
  _traverse(val, seenObjects);
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || !Object.isExtensible(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch) { initWatch(vm, opts.watch); }
}

var isReservedProp = {
  key: 1,
  ref: 1,
  slot: 1
};

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      if (isReservedProp[key] || config.isReservedAttr(key)) {
        warn(
          ("\"" + key + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (vm.$parent && !observerState.isSettingProps) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var i = keys.length;
  while (i--) {
    if (props && hasOwn(props, keys[i])) {
      "production" !== 'production' && warn(
        "The data property \"" + (keys[i]) + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(keys[i])) {
      proxy(vm, "_data", keys[i]);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  var watchers = vm._computedWatchers = Object.create(null);

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      if (getter === undefined) {
        warn(
          ("No getter function has been defined for computed property \"" + key + "\"."),
          vm
        );
        getter = noop;
      }
    }
    // create internal watcher for the computed property.
    watchers[key] = new Watcher(vm, getter, noop, computedWatcherOptions);

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (target, key, userDef) {
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = createComputedGetter(key);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
    if (false) {
      if (methods[key] == null) {
        warn(
          "method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
    }
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (vm, key, handler) {
  var options;
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  vm.$watch(key, handler, options);
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    // isArray here
    var isArray = Array.isArray(inject);
    var result = Object.create(null);
    var keys = isArray
      ? inject
      : hasSymbol
        ? Reflect.ownKeys(inject)
        : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = isArray ? key : inject[key];
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
    }
    return result
  }
}

/*  */

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  context,
  children
) {
  var props = {};
  var propOptions = Ctor.options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var _context = Object.create(context);
  var h = function (a, b, c, d) { return createElement(_context, a, b, c, d, true); };
  var vnode = Ctor.options.render.call(null, h, {
    data: data,
    props: props,
    children: children,
    parent: context,
    listeners: data.on || {},
    injections: resolveInject(Ctor.options.inject, context),
    slots: function () { return resolveSlots(children, context); }
  });
  if (vnode instanceof VNode) {
    vnode.functionalContext = context;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }
  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  if (isUndef(Ctor.cid)) {
    Ctor = resolveAsyncComponent(Ctor, baseCtor, context);
    if (Ctor === undefined) {
      // return nothing if this is indeed an async component
      // wait for the callback to trigger parent update.
      return
    }
  }

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  data = data || {};

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners
    data = {};
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }
  );
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var vnodeComponentOptions = vnode.componentOptions;
  var options = {
    _isComponent: true,
    parent: parent,
    propsData: vnodeComponentOptions.propsData,
    _componentTag: vnodeComponentOptions.tag,
    _parentVnode: vnode,
    _parentListeners: vnodeComponentOptions.listeners,
    _renderChildren: vnodeComponentOptions.children,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnodeComponentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
      typeof children[0] === 'function') {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (vnode !== undefined) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    return
  }
  if (Array.isArray(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && isUndef(child.ns)) {
        applyNS(child, ns);
      }
    }
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      extend(props, bindObject);
    }
    return scopedSlotFn(props) || fallback
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes && "production" !== 'production') {
      slotNodes._rendered && warn(
        "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
        "- this will likely cause render errors.",
        this
      );
      slotNodes._rendered = true;
    }
    return slotNodes || fallback
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (Array.isArray(keyCodes)) {
    return keyCodes.indexOf(eventKeyCode) === -1
  } else {
    return keyCodes !== eventKeyCode
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      for (var key in value) {
        if (key === 'class' || key === 'style') {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];
        }
      }
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var tree = this._staticTrees[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = this._staticTrees[index] =
    this.$options.staticRenderFns[index].call(this._renderProxy);
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null;
  var parentVnode = vm.$vnode = vm.$options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(vm.$options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };
}

function renderMixin (Vue) {
  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var staticRenderFns = ref.staticRenderFns;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // clone slot nodes on re-renders
      for (var key in vm.$slots) {
        vm.$slots[key] = cloneVNodes(vm.$slots[key]);
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    if (staticRenderFns && !vm._staticTrees) {
      vm._staticTrees = [];
    }
    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render function");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        vnode = vm.$options.renderError
          ? vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e)
          : vm._vnode;
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };

  // internal render helpers.
  // these are exposed on the instance prototype to reduce generated render
  // code size.
  Vue.prototype._o = markOnce;
  Vue.prototype._n = toNumber;
  Vue.prototype._s = _toString;
  Vue.prototype._l = renderList;
  Vue.prototype._t = renderSlot;
  Vue.prototype._q = looseEqual;
  Vue.prototype._i = looseIndexOf;
  Vue.prototype._m = renderStatic;
  Vue.prototype._f = resolveFilter;
  Vue.prototype._k = checkKeyCodes;
  Vue.prototype._b = bindObjectProps;
  Vue.prototype._v = createTextVNode;
  Vue.prototype._e = createEmptyVNode;
  Vue.prototype._u = resolveScopedSlots;
}

/*  */

var uid$1 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$1++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-init:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(((vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  opts.parent = options.parent;
  opts.propsData = options.propsData;
  opts._parentVnode = options._parentVnode;
  opts._parentListeners = options._parentListeners;
  opts._renderChildren = options._renderChildren;
  opts._componentTag = options._componentTag;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;
  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if (false) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    /* istanbul ignore if */
    if (plugin.installed) {
      return
    }
    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    plugin.installed = true;
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn(
          'Invalid component name: "' + name + '". Component names ' +
          'can only contain alphanumeric characters and the hyphen, ' +
          'and must start with a letter.'
        );
      }
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          if (type === 'component' && config.isReservedTag(id)) {
            warn(
              'Do not use built-in or reserved HTML elements as component ' +
              'id: ' + id
            );
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

var patternTypes = [String, RegExp];

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (cache, current, filter) {
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        if (cachedNode !== current) {
          pruneCacheEntry(cachedNode);
        }
        cache[key] = null;
      }
    }
  }
}

function pruneCacheEntry (vnode) {
  if (vnode) {
    vnode.componentInstance.$destroy();
  }
}

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes
  },

  created: function created () {
    this.cache = Object.create(null);
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache[key]);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this.cache, this._vnode, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this.cache, this._vnode, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var vnode = getFirstComponentChild(this.$slots.default);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      if (name && (
        (this.include && !matches(this.include, name)) ||
        (this.exclude && matches(this.exclude, name))
      )) {
        return vnode
      }
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (this.cache[key]) {
        vnode.componentInstance = this.cache[key].componentInstance;
      } else {
        this.cache[key] = vnode;
      }
      vnode.data.keepAlive = true;
    }
    return vnode
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Vue$3.version = '2.3.0';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return genClassFromData(data)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function genClassFromData (data) {
  var dynamicClass = data.class;
  var staticClass = data.staticClass;
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (isUndef(value)) {
    return ''
  }
  if (typeof value === 'string') {
    return value
  }
  var res = '';
  if (Array.isArray(value)) {
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
      if (isDef(value[i])) {
        if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
          res += stringified + ' ';
        }
      }
    }
    return res.slice(0, -1)
  }
  if (isObject(value)) {
    for (var key in value) {
      if (value[key]) { res += key + ' '; }
    }
    return res.slice(0, -1)
  }
  /* istanbul ignore next */
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (Array.isArray(refs[key]) && refs[key].indexOf(ref) < 0) {
        refs[key].push(ref);
      } else {
        refs[key] = [ref];
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *

/*
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key &&
    a.tag === b.tag &&
    a.isComment === b.isComment &&
    isDef(a.data) === isDef(b.data) &&
    sameInputType(a, b)
  )
}

// Some browsers do not support dynamically changing type for <input>
// so they need to be treated as different nodes
function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  var inPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          inPre++;
        }
        if (
          !inPre &&
          !vnode.ns &&
          !(config.ignoredElements.length && config.ignoredElements.indexOf(tag) > -1) &&
          config.isUnknownElement(tag)
        ) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        inPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref) {
    if (isDef(parent)) {
      if (isDef(ref)) {
        if (ref.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    var ancestor = vnode;
    while (ancestor) {
      if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
        nodeOps.setAttribute(vnode.elm, i, '');
      }
      ancestor = ancestor.parent;
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
        i !== vnode.context &&
        isDef(i = i.$options._scopeId)) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, elmToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : null;
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          newStartVnode = newCh[++newStartIdx];
        } else {
          elmToMove = oldCh[idxInOld];
          /* istanbul ignore if */
          if (false) {
            warn(
              'It seems there are duplicate keys that is causing an update error. ' +
              'Make sure each v-for item has a unique key.'
            );
          }
          if (sameVnode(elmToMove, newStartVnode)) {
            patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, newStartVnode.elm, oldStartVnode.elm);
            newStartVnode = newCh[++newStartIdx];
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
            newStartVnode = newCh[++newStartIdx];
          }
        }
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }
    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
        isTrue(oldVnode.isStatic) &&
        vnode.key === oldVnode.key &&
        (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
      vnode.elm = oldVnode.elm;
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }
    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var bailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  var isRenderedModule = makeMap('attrs,style,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue) {
    if (false) {
      if (!assertNodeMatch(elm, vnode)) {
        return false
      }
    }
    vnode.elm = elm;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          var childrenMatch = true;
          var childNode = elm.firstChild;
          for (var i$1 = 0; i$1 < children.length; i$1++) {
            if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue)) {
              childrenMatch = false;
              break
            }
            childNode = childNode.nextSibling;
          }
          // if childNode is not null, it means the actual childNodes list is
          // longer than the virtual children list.
          if (!childrenMatch || childNode) {
            if (false) {
              bailed = true;
              console.warn('Parent: ', elm);
              console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
            }
            return false
          }
        }
      }
      if (isDef(data)) {
        for (var key in data) {
          if (!isRenderedModule(key)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode) {
    if (isDef(vnode.tag)) {
      return (
        vnode.tag.indexOf('vue-component') === 0 ||
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }
        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        if (isDef(vnode.parent)) {
          // component root element replaced.
          // update parent placeholder node element, recursively
          var ancestor = vnode.parent;
          while (ancestor) {
            ancestor.elm = vnode.elm;
            ancestor = ancestor.parent;
          }
          if (isPatchable(vnode)) {
            for (var i = 0; i < cbs.create.length; ++i) {
              cbs.create[i](emptyNode, vnode.parent);
            }
          }
        }

        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  /* istanbul ignore if */
  if (isIE9 && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, key);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + "," + args)
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }
  // check capture modifier
  if (modifiers && modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers && modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers && modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }
  var events;
  if (modifiers && modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }
  var newHandler = { value: value, modifiers: modifiers };
  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

function getAndRemoveAttr (el, name) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
        "? " + baseValueExpression + ".trim()" +
        ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var modelRs = parseModel(value);
  if (modelRs.idx === null) {
    return (value + "=" + assignment)
  } else {
    return "var $$exp = " + (modelRs.exp) + ", $$idx = " + (modelRs.idx) + ";" +
      "if (!Array.isArray($$exp)){" +
        value + "=" + assignment + "}" +
      "else{$$exp.splice($$idx, 1, " + assignment + ")}"
  }
}

/**
 * parse directive model to do the array update transform. a[idx] = val => $$a.splice($$idx, 1, val)
 *
 * for loop possible cases:
 *
 * - test
 * - test[idx]
 * - test[test1[idx]]
 * - test["a"][idx]
 * - xxx.test[a[a].test1[idx]]
 * - test.xxx.a["asa"][test1[idx]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;

function parseModel (val) {
  str = val;
  len = str.length;
  index$1 = expressionPos = expressionEndPos = 0;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    return {
      exp: val,
      idx: null
    }
  }

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.substring(0, expressionPos),
    idx: val.substring(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    var dynamicType = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (tag === 'input' && dynamicType) {
      warn$1(
        "<input :type=\"" + dynamicType + "\" v-model=\"" + value + "\">:\n" +
        "v-model does not support dynamic input types. Use v-if branches instead."
      );
    }
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
      "?_i(" + value + "," + valueBinding + ")>-1" + (
        trueValueBinding === 'true'
          ? (":(" + value + ")")
          : (":_q(" + value + "," + trueValueBinding + ")")
      )
  );
  addHandler(el, CHECKBOX_RADIO_TOKEN,
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$c){$$i<0&&(" + value + "=$$a.concat($$v))}" +
      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
    el,
    value,
    modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, CHECKBOX_RADIO_TOKEN, genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
    el,
    value,
    modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;
  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number || type === 'number') {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  var event;
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    // Chrome fires microtasks in between click/change, leads to #4521
    event = isChrome ? 'click' : 'change';
    on[event] = [].concat(on[CHECKBOX_RADIO_TOKEN], on[event] || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  if (once$$1) {
    var oldHandler = handler;
    var _target = target$1; // save current target element in closure
    handler = function (ev) {
      var res = arguments.length === 1
        ? oldHandler(ev)
        : oldHandler.apply(null, arguments);
      if (res !== null) {
        remove$2(event, handler, capture, _target);
      }
    };
  }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(event, handler, capture);
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = cur == null ? '' : String(cur);
      if (shouldUpdateValue(elm, vnode, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (
  elm,
  vnode,
  checkVal
) {
  return (!elm.composing && (
    vnode.tag === 'option' ||
    isDirty(elm, checkVal) ||
    isInputChanged(elm, checkVal)
  ))
}

function isDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is not equal to the updated value
  return document.activeElement !== elm && elm.value !== checkVal
}

function isInputChanged (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if ((isDef(modifiers) && modifiers.number) || elm.type === 'number') {
    return toNumber(value) !== toNumber(newVal)
  }
  if (isDef(modifiers) && modifiers.trim) {
    return value.trim() !== newVal.trim()
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var prefixes = ['Webkit', 'Moz', 'ms'];

var testEl;
var normalize = cached(function (prop) {
  testEl = testEl || document.createElement('div');
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in testEl.style)) {
    return prop
  }
  var upper = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < prefixes.length; i++) {
    var prefixed = prefixes[i] + upper;
    if (prefixed in testEl.style) {
      return prefixed
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
      isUndef(oldData.staticStyle) && isUndef(oldData.style)) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likley wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    el.setAttribute('class', cur.trim());
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser && window.requestAnimationFrame
  ? window.requestAnimationFrame.bind(window)
  : setTimeout;

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  (el._transitionClasses || (el._transitionClasses = [])).push(cls);
  addClass(el, cls);
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var ref = (data);
  var css = ref.css;
  var type = ref.type;
  var enterClass = ref.enterClass;
  var enterToClass = ref.enterToClass;
  var enterActiveClass = ref.enterActiveClass;
  var appearClass = ref.appearClass;
  var appearToClass = ref.appearToClass;
  var appearActiveClass = ref.appearActiveClass;
  var beforeEnter = ref.beforeEnter;
  var enter = ref.enter;
  var afterEnter = ref.afterEnter;
  var enterCancelled = ref.enterCancelled;
  var beforeAppear = ref.beforeAppear;
  var appear = ref.appear;
  var afterAppear = ref.afterAppear;
  var appearCancelled = ref.appearCancelled;
  var duration = ref.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
          pendingNode.tag === vnode.tag &&
          pendingNode.elm._leaveCb) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb) || el.nodeType !== 1) {
    return
  }

  var ref = (data);
  var css = ref.css;
  var type = ref.type;
  var leaveClass = ref.leaveClass;
  var leaveToClass = ref.leaveToClass;
  var leaveActiveClass = ref.leaveActiveClass;
  var beforeLeave = ref.beforeLeave;
  var leave = ref.leave;
  var afterLeave = ref.afterLeave;
  var leaveCancelled = ref.leaveCancelled;
  var delayLeave = ref.delayLeave;
  var duration = ref.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var model$1 = {
  inserted: function inserted (el, binding, vnode) {
    if (vnode.tag === 'select') {
      var cb = function () {
        setSelected(el, binding, vnode.context);
      };
      cb();
      /* istanbul ignore if */
      if (isIE || isEdge) {
        setTimeout(cb, 0);
      }
    } else if (vnode.tag === 'textarea' || el.type === 'text' || el.type === 'password') {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },
  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var needReset = el.multiple
        ? binding.value.some(function (v) { return hasNoMatchingOption(v, el.options); })
        : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, el.options);
      if (needReset) {
        trigger(el, 'change');
      }
    }
  }
};

function setSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  for (var i = 0, l = options.length; i < l; i++) {
    if (looseEqual(getValue(options[i]), value)) {
      return false
    }
  }
  return true
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition && !isIE9) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition = vnode.data && vnode.data.transition;
    if (transition && !isIE9) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: model$1,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag; });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (oldChild && oldChild.data && !isSameChild(child, oldChild)) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild && (oldChild.data.transition = extend({}, data));
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    var body = document.body;
    var f = body.offsetHeight; // eslint-disable-line

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      if (this._hasMove != null) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
setTimeout(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if (false) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if (false) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

// check whether current browser encodes a char inside attribute values
function shouldDecode (content, encoded) {
  var div = document.createElement('div');
  div.innerHTML = "<div a=\"" + content + "\">";
  return div.innerHTML.indexOf(encoded) > 0
}

// #3663
// IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? shouldDecode('\n', '&#10;') : false;

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/*  */

var decoder;

function decode (html) {
  decoder = decoder || document.createElement('div');
  decoder.innerHTML = html;
  return decoder.textContent
}

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var singleAttrIdentifier = /([^\s"'<>/=]+)/;
var singleAttrAssign = /(?:=)/;
var singleAttrValues = [
  // attr value double quotes
  /"([^"]*)"+/.source,
  // attr value, single quotes
  /'([^']*)'+/.source,
  // attr value, no quotes
  /([^\s"'=<>`]+)/.source
];
var attribute = new RegExp(
  '^\\s*' + singleAttrIdentifier.source +
  '(?:\\s*(' + singleAttrAssign.source + ')' +
  '\\s*(?:' + singleAttrValues.join('|') + '))?'
);

// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = '((?:' + ncname + '\\:)?' + ncname + ')';
var startTagOpen = new RegExp('^<' + qnameCapture);
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp('^<\\/' + qnameCapture + '[^>]*>');
var doctype = /^<!DOCTYPE [^>]+>/i;
var comment = /^<!--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10);/g;

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          continue
        }
      }

      var text = (void 0), rest$1 = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest$1 = html.slice(textEnd);
        while (
          !endTag.test(rest$1) &&
          !startTagOpen.test(rest$1) &&
          !comment.test(rest$1) &&
          !conditionalComment.test(rest$1)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest$1.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest$1 = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var endTagLength = 0;
      var rest = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!--([\s\S]*?)-->/g, '$1')
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest.length;
      html = rest;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || tagName === 'html' && lastTag === 'head' || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      attrs[i] = {
        name: args[1],
        value: decodeAttr(
          value,
          options.shouldDecodeNewlines
        )
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});

function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      tokens.push(JSON.stringify(text.slice(lastIndex, index)));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    tokens.push(JSON.stringify(text.slice(lastIndex)));
  }
  return tokens.join('+')
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
var forIteratorRE = /\((\{[^}]*\}|[^,]*),([^,]*)(?:,([^,]*))?\)/;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;
  platformGetTagNamespace = options.getTagNamespace || no;
  platformMustUseProp = options.mustUseProp || no;
  platformIsPreTag = options.isPreTag || no;
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  transforms = pluckModuleFunction(options.modules, 'transformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function endPre (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = {
        type: 1,
        tag: tag,
        attrsList: attrs,
        attrsMap: makeAttrsMap(attrs),
        parent: currentParent,
        children: []
      };
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        preTransforms[i](element, options);
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else {
        processFor(element);
        processIf(element);
        processOnce(element);
        processKey(element);

        // determine whether this is a plain element after
        // removing structural attributes
        element.plain = !element.key && !attrs.length;

        processRef(element);
        processSlot(element);
        processComponent(element);
        for (var i$1 = 0; i$1 < transforms.length; i$1++) {
          transforms[i$1](element, options);
        }
        processAttrs(element);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        endPre(element);
      }
      // apply post-transforms
      for (var i$2 = 0; i$2 < postTransforms.length; i$2++) {
        postTransforms[i$2](element, options);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      endPre(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
          currentParent.tag === 'textarea' &&
          currentParent.attrsMap.placeholder === text) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var expression;
        if (!inVPre && text !== ' ' && (expression = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: expression,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var inMatch = exp.match(forAliasRE);
    if (!inMatch) {
      "production" !== 'production' && warn$2(
        ("Invalid v-for expression: " + exp)
      );
      return
    }
    el.for = inMatch[2].trim();
    var alias = inMatch[1].trim();
    var iteratorMatch = alias.match(forIteratorRE);
    if (iteratorMatch) {
      el.alias = iteratorMatch[1].trim();
      el.iterator1 = iteratorMatch[2].trim();
      if (iteratorMatch[3]) {
        el.iterator2 = iteratorMatch[3].trim();
      }
    } else {
      el.alias = alias;
    }
  }
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    }
    if (el.tag === 'template') {
      el.slotScope = getAndRemoveAttr(el, 'scope');
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || platformMustUseProp(el.tag, el.attrsMap.type, name)) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var expression = parseText(value, delimiters);
        if (expression) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      walkThroughConditionsBlocks(node.ifConditions, isInFor);
    }
  }
}

function walkThroughConditionsBlocks (conditionBlocks, isInFor) {
  for (var i = 1, len = conditionBlocks.length; i < len; i++) {
    markStaticRoots(conditionBlocks[i].block, isInFor);
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  native,
  warn
) {
  var res = native ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    var handler = events[name];
    // #5330: warn click.right, since right clicks do not actually fire click events.
    if (false
      ) {
      warn(
        "Use \"contextmenu\" instead of \"click.right\" since right clicks " +
        "do not actually fire \"click\" events."
      );
    }
    res += "\"" + name + "\":" + (genHandler(name, handler)) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    return isMethodPath || isFunctionExpression
      ? handler.value
      : ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? handler.value + '($event)'
      : isFunctionExpression
        ? ("(" + (handler.value) + ")($event)")
        : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var alias = keyCodes[key];
  return ("_k($event.keyCode," + (JSON.stringify(key)) + (alias ? ',' + JSON.stringify(alias) : '') + ")")
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + (dir.modifiers && dir.modifiers.prop ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  bind: bind$1,
  cloak: noop
};

/*  */

// configurable state
var warn$3;
var transforms$1;
var dataGenFns;
var platformDirectives$1;
var isPlatformReservedTag$1;
var staticRenderFns;
var onceCount;
var currentOptions;

function generate (
  ast,
  options
) {
  // save previous staticRenderFns so generate calls can be nested
  var prevStaticRenderFns = staticRenderFns;
  var currentStaticRenderFns = staticRenderFns = [];
  var prevOnceCount = onceCount;
  onceCount = 0;
  currentOptions = options;
  warn$3 = options.warn || baseWarn;
  transforms$1 = pluckModuleFunction(options.modules, 'transformCode');
  dataGenFns = pluckModuleFunction(options.modules, 'genData');
  platformDirectives$1 = options.directives || {};
  isPlatformReservedTag$1 = options.isReservedTag || no;
  var code = ast ? genElement(ast) : '_c("div")';
  staticRenderFns = prevStaticRenderFns;
  onceCount = prevOnceCount;
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: currentStaticRenderFns
  }
}

function genElement (el) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el)
  } else if (el.for && !el.forProcessed) {
    return genFor(el)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el);
    } else {
      var data = el.plain ? undefined : genData(el);

      var children = el.inlineTemplate ? null : genChildren(el, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < transforms$1.length; i++) {
      code = transforms$1[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el) {
  el.staticProcessed = true;
  staticRenderFns.push(("with(this){return " + (genElement(el)) + "}"));
  return ("_m(" + (staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && warn$3(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el)
    }
    return ("_o(" + (genElement(el)) + "," + (onceCount++) + (key ? ("," + key) : "") + ")")
  } else {
    return genStatic(el)
  }
}

function genIf (el) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice())
}

function genIfConditions (conditions) {
  if (!conditions.length) {
    return '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return el.once ? genOnce(el) : genElement(el)
  }
}

function genFor (el) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (
    false
  ) {
    warn$3(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genElement(el)) +
    '})'
}

function genData (el) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < dataGenFns.length; i++) {
    data += dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, warn$3)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, warn$3)) + ",";
  }
  // slot target
  if (el.slotTarget) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  return data
}

function genDirectives (el) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = platformDirectives$1[dir.name] || baseDirectives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, warn$3);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el) {
  var ast = el.children[0];
  if (false) {
    warn$3('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, currentOptions);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (slots) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) { return genScopedSlot(key, slots[key]); }).join(',')) + "])")
}

function genScopedSlot (key, el) {
  return "[" + key + ",function(" + (String(el.attrsMap.scope)) + "){" +
    "return " + (el.tag === 'template'
      ? genChildren(el) || 'void 0'
      : genElement(el)) + "}]"
}

function genChildren (el, checkSkip) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
        el$1.for &&
        el$1.tag !== 'template' &&
        el$1.tag !== 'slot') {
      return genElement(el$1)
    }
    var normalizationType = checkSkip ? getNormalizationType(children) : 0;
    return ("[" + (children.map(genNode).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (children) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function maybeComponent (el) {
  return !isPlatformReservedTag$1(el.tag)
}

function genNode (node) {
  if (node.type === 1) {
    return genElement(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genSlot (el) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (componentName, el) {
  var children = el.inlineTemplate ? null : genChildren(el, true);
  return ("_c(" + componentName + "," + (genData(el)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// check valid identifier for v-for
var identRE = /[A-Za-z_$][\w$]*/;

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (ident, type, text, errors) {
  if (typeof ident === 'string' && !identRE.test(ident)) {
    errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
      );
    } else {
      errors.push(("invalid expression: " + (text.trim())));
    }
  }
}

/*  */

function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  optimize(ast, options);
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
}

function makeFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompiler (baseOptions) {
  var functionCompileCache = Object.create(null);

  function compile (
    template,
    options
  ) {
    var finalOptions = Object.create(baseOptions);
    var errors = [];
    var tips = [];
    finalOptions.warn = function (msg, tip$$1) {
      (tip$$1 ? tips : errors).push(msg);
    };

    if (options) {
      // merge custom modules
      if (options.modules) {
        finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
      }
      // merge custom directives
      if (options.directives) {
        finalOptions.directives = extend(
          Object.create(baseOptions.directives),
          options.directives
        );
      }
      // copy other options
      for (var key in options) {
        if (key !== 'modules' && key !== 'directives') {
          finalOptions[key] = options[key];
        }
      }
    }

    var compiled = baseCompile(template, finalOptions);
    if (false) {
      errors.push.apply(errors, detectErrors(compiled.ast));
    }
    compiled.errors = errors;
    compiled.tips = tips;
    return compiled
  }

  function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = options || {};

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (functionCompileCache[key]) {
      return functionCompileCache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = makeFunction(compiled.render, fnGenErrors);
    var l = compiled.staticRenderFns.length;
    res.staticRenderFns = new Array(l);
    for (var i = 0; i < l; i++) {
      res.staticRenderFns[i] = makeFunction(compiled.staticRenderFns[i], fnGenErrors);
    }

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (functionCompileCache[key] = res)
  }

  return {
    compile: compile,
    compileToFunctions: compileToFunctions
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var expression = parseText(staticClass, options.delimiters);
    if (expression) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData$1
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var expression = parseText(staticStyle, options.delimiters);
      if (expression) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$2 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$2
};

var modules$1 = [
  klass$1,
  style$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue$3.prototype.$mount;
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        delimiters: options.delimiters
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(((this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue$3.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(38)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = "/dist/76da3d414f13d49edbca71dbf32c07d7.eot";

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = "/dist/911dffc57b3739f0f1faa1a23e5d6dbc.eot";

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = "/dist/da732a679fdbe965d87ffbcee6ab3bd7.eot";

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = "/dist/de70266798097f4ad42807a2918ad97d.eot";

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = "/dist/ffe5c79b34f32dd525a543310b03c405.eot";

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = "/dist/19ebf9fdef99c0bd73e43778070e21a0.eot";

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = "/dist/c9bfcdf2d50d8c1b333f957cb1e12d7c.eot";

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = "/dist/3917e9d99675f49bc9b8c53180759a62.eot";

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = "/dist/be5cfaf67b2cc6ab503a90502ce1441e.eot";

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = "/dist/fbf51e5ef6dc07bf53bb2b6896a96b99.eot";

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = "/dist/e1158760006aaadbb9251b4e89b73e32.eot";

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = "/dist/d2f4cde6a312ff5c6160ac36c1f443b2.eot";

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = "/dist/d9e11714b6724063c0b14e783c1be40b.eot";

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = "/dist/6ef7418ccdfdc86cf92327030ea5eed9.eot";

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "/dist/3ba8032740f336682ca1f7498bc060fc.eot";

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = "/dist/bc7fdc5d4bd61da9f8ba268a266649c8.eot";

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = "/dist/b125be9d4669b48ecb697ec90cc999c3.eot";

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = "/dist/b301c4cd6dd23e14ddec9e633ecbb703.eot";

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = "/dist/e2085b4924b30d8b80f9b81597543d6a.eot";

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = "/dist/fafacae60c9b5a39505cf2307cac81d1.eot";

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = "/dist/c3547b2ec6f5eb324b44d8a0c6b2dd31.eot";

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = "/dist/2f1aacc1587e8f78a21079f754850cc8.eot";

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = "/dist/9f916e330c478bbfa2a0dd6614042046.eot";

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = "/dist/16a42151226d9c09e44340821c0e2f16.eot";

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = "/dist/2a52a20f9a56010ec5d985abe9bebcc9.eot";

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = "/dist/e50328c08c4a180a683e2dfe9c5cb7ed.eot";

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = "/dist/128879da78c6c8eb4e2c07fa3732cea7.eot";

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = "/dist/96166ad6756842b4f7389f7486b02181.eot";

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = "/dist/355550fa89b82ad35ae1c66af10d798b.eot";

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports = "/dist/822eba9c24e79985a0c0f9135787a470.eot";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(178),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(186)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(177),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_vue__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Theme_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Theme_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Theme_vue__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);




var routes = [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_2__Home_vue___default.a }, { path: '/themes/:theme', component: __WEBPACK_IMPORTED_MODULE_3__Theme_vue___default.a }];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (from.params.theme && to.params.theme) {
      return { x: 0, y: window.scrollTop };
    }
    return savedPosition ? savedPosition : { x: 0, y: 0 };
  },
  routes: routes
}));

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(55);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!./normalize.css", function() {
			var newContent = require("!!../css-loader/index.js!./normalize.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(56);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(57);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!./index.css", function() {
			var newContent = require("!!../css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(176),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header_vue__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'alp-header': __WEBPACK_IMPORTED_MODULE_0__Header_vue___default.a
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__themes__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var assetsCtx = __webpack_require__(194);

var pictures = {};

Object.keys(__WEBPACK_IMPORTED_MODULE_0__themes___default.a).map(function (themeName) {
  return __WEBPACK_IMPORTED_MODULE_0__themes___default.a[themeName];
}).forEach(function (theme) {
  pictures[theme.slug] = assetsCtx('./' + theme.image + '.jpg');
});

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['image', 'link'],

  computed: {
    to: function to() {
      return '/themes/' + this.link;
    },
    backgroundImage: function backgroundImage() {
      return { backgroundImage: 'url(' + pictures[this.image] + ')' };
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['link', 'shadow', 'href', 'blue'],

  computed: {
    classes: function classes() {
      return {
        'alp-button': true,
        'alp-button--shadowed': this.shadow,
        'alp-button--blued': this.blue
      };
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['background'],

  computed: {
    backgroundColor: function backgroundColor() {
      switch (this.background) {
        case 'blue':
          return { backgroundColor: '#23b9d0', color: '#fff' };
        default:
          return { color: '#222' };
      }
    }
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    goBack: function goBack(e) {
      if (document.body.className === 'alp--on-theme') {
        console.log(e.x);
        if (e.x > 170) {
          this.$router.push('/');
        }
      }
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes_json__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__themes_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Button_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BigTheme_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BigTheme_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BigTheme_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'alp-button': __WEBPACK_IMPORTED_MODULE_1__Button_vue___default.a,
    'alp-big-theme': __WEBPACK_IMPORTED_MODULE_2__BigTheme_vue___default.a
  },

  computed: {
    themes: function themes() {
      return Object.keys(__WEBPACK_IMPORTED_MODULE_0__themes_json___default.a).map(function (themeName) {
        return __WEBPACK_IMPORTED_MODULE_0__themes_json___default.a[themeName];
      }).filter(function (theme) {
        return !theme.invisible && theme.main;
      }).sort(function (a, b) {
        return a.pos - b.pos;
      });
    }
  },

  methods: {
    getLink: function getLink(theme) {
      return theme.subs ? theme.subs[0].link : theme.slug;
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['theme'],

  computed: {
    color: function color() {
      if (this.theme === 'orange') {
        return {
          background: '#f0ad4e'
        };
      } else {
        return {
          background: '#c9462c'
        };
      }
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__themes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Button_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BigTheme_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BigTheme_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BigTheme_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card_vue__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Card_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tag_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tag_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Tag_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'alp-button': __WEBPACK_IMPORTED_MODULE_1__Button_vue___default.a,
    'alp-big-theme': __WEBPACK_IMPORTED_MODULE_2__BigTheme_vue___default.a,
    'alp-card': __WEBPACK_IMPORTED_MODULE_3__Card_vue___default.a,
    'alp-tag': __WEBPACK_IMPORTED_MODULE_4__Tag_vue___default.a
  },

  data: function data() {
    return {
      themes: __WEBPACK_IMPORTED_MODULE_0__themes___default.a
    };
  },


  computed: {
    theme: function theme() {
      var theme = __WEBPACK_IMPORTED_MODULE_0__themes___default.a[this.$route.params.theme];

      theme.intro = theme.intro ? theme.intro.replace(/« /g, '«&nbsp;').replace(/ »/g, '&nbsp;»') : null;

      theme.fn = theme.fn ? theme.fn.replace(/« /g, '«&nbsp;').replace(/ »/g, '&nbsp;»') : null;

      theme.fi = theme.fi ? theme.fi.replace(/« /g, '«&nbsp;').replace(/ »/g, '&nbsp;»') : null;

      theme.aec = theme.aec ? theme.aec.replace(/« /g, '«&nbsp;').replace(/ »/g, '&nbsp;»') : null;

      return theme;
    },
    intro: function intro() {
      return this.theme.parent ? __WEBPACK_IMPORTED_MODULE_0__themes___default.a[this.theme.parent].intro : this.theme.intro;
    },
    title: function title() {
      return this.theme.parent ? __WEBPACK_IMPORTED_MODULE_0__themes___default.a[this.theme.parent].title : this.theme.title;
    },
    isWriting: function isWriting() {
      return this.theme.writing;
    },
    themeClasses: function themeClasses() {
      return this.isWriting ? ['alp-theme', 'alp-theme--writing'] : ['alp-theme'];
    }
  },

  mounted: function mounted() {
    if (!__WEBPACK_IMPORTED_MODULE_0__themes___default.a.hasOwnProperty(this.$route.params.theme)) {
      this.$router.push('/');
    }

    if (this.theme.subs) {
      this.$router.push(this.theme.subs[0].link);
    }

    document.body.className = 'alp--on-theme';
  },
  destroyed: function destroyed() {
    document.body.className = '';
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_typeface_montserrat__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_typeface_montserrat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_typeface_montserrat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_typeface_roboto__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_typeface_roboto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_typeface_roboto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalize_css__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(39);









window.app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue___default.a);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(53)
var ieee754 = __webpack_require__(168)
var isArray = __webpack_require__(169)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*! normalize.css v6.0.0 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}article,aside,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}audio,video{display:inline-block}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{display:inline-block;vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details,menu{display:block}summary{display:list-item}canvas{display:inline-block}[hidden],template{display:none}", ""]);

// exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "@font-face{font-family:Montserrat;font-style:italic;font-weight:100;src:url(" + __webpack_require__(7) + ");src:local(\"Montserrat Thin italic\"),local(\"Montserrat-Thinitalic\"),url(" + __webpack_require__(7) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(111) + ") format(\"woff2\"),url(" + __webpack_require__(110) + ") format(\"woff\"),url(" + __webpack_require__(67) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:normal;font-weight:200;src:url(" + __webpack_require__(8) + ");src:local(\"Montserrat Extra Light \"),local(\"Montserrat-Extra Light\"),url(" + __webpack_require__(8) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(113) + ") format(\"woff2\"),url(" + __webpack_require__(112) + ") format(\"woff\"),url(" + __webpack_require__(68) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:italic;font-weight:300;src:url(" + __webpack_require__(11) + ");src:local(\"Montserrat Light italic\"),local(\"Montserrat-Lightitalic\"),url(" + __webpack_require__(11) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(119) + ") format(\"woff2\"),url(" + __webpack_require__(118) + ") format(\"woff\"),url(" + __webpack_require__(71) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:normal;font-weight:600;src:url(" + __webpack_require__(16) + ");src:local(\"Montserrat SemiBold \"),local(\"Montserrat-SemiBold\"),url(" + __webpack_require__(16) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(129) + ") format(\"woff2\"),url(" + __webpack_require__(128) + ") format(\"woff\"),url(" + __webpack_require__(76) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:normal;font-weight:100;src:url(" + __webpack_require__(6) + ");src:local(\"Montserrat Thin \"),local(\"Montserrat-Thin\"),url(" + __webpack_require__(6) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(109) + ") format(\"woff2\"),url(" + __webpack_require__(108) + ") format(\"woff\"),url(" + __webpack_require__(66) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:normal;font-weight:300;src:url(" + __webpack_require__(10) + ");src:local(\"Montserrat Light \"),local(\"Montserrat-Light\"),url(" + __webpack_require__(10) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(117) + ") format(\"woff2\"),url(" + __webpack_require__(116) + ") format(\"woff\"),url(" + __webpack_require__(70) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:normal;font-weight:400;src:url(" + __webpack_require__(12) + ");src:local(\"Montserrat Regular \"),local(\"Montserrat-Regular\"),url(" + __webpack_require__(12) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(121) + ") format(\"woff2\"),url(" + __webpack_require__(120) + ") format(\"woff\"),url(" + __webpack_require__(72) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:italic;font-weight:200;src:url(" + __webpack_require__(9) + ");src:local(\"Montserrat Extra Light italic\"),local(\"Montserrat-Extra Lightitalic\"),url(" + __webpack_require__(9) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(115) + ") format(\"woff2\"),url(" + __webpack_require__(114) + ") format(\"woff\"),url(" + __webpack_require__(69) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:italic;font-weight:400;src:url(" + __webpack_require__(13) + ");src:local(\"Montserrat Regular italic\"),local(\"Montserrat-Regularitalic\"),url(" + __webpack_require__(13) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(123) + ") format(\"woff2\"),url(" + __webpack_require__(122) + ") format(\"woff\"),url(" + __webpack_require__(73) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:normal;font-weight:700;src:url(" + __webpack_require__(18) + ");src:local(\"Montserrat Bold \"),local(\"Montserrat-Bold\"),url(" + __webpack_require__(18) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(133) + ") format(\"woff2\"),url(" + __webpack_require__(132) + ") format(\"woff\"),url(" + __webpack_require__(78) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:normal;font-weight:500;src:url(" + __webpack_require__(14) + ");src:local(\"Montserrat Medium \"),local(\"Montserrat-Medium\"),url(" + __webpack_require__(14) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(125) + ") format(\"woff2\"),url(" + __webpack_require__(124) + ") format(\"woff\"),url(" + __webpack_require__(74) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:italic;font-weight:500;src:url(" + __webpack_require__(15) + ");src:local(\"Montserrat Medium italic\"),local(\"Montserrat-Mediumitalic\"),url(" + __webpack_require__(15) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(127) + ") format(\"woff2\"),url(" + __webpack_require__(126) + ") format(\"woff\"),url(" + __webpack_require__(75) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:italic;font-weight:700;src:url(" + __webpack_require__(19) + ");src:local(\"Montserrat Bold italic\"),local(\"Montserrat-Bolditalic\"),url(" + __webpack_require__(19) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(135) + ") format(\"woff2\"),url(" + __webpack_require__(134) + ") format(\"woff\"),url(" + __webpack_require__(79) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:normal;font-weight:800;src:url(" + __webpack_require__(20) + ");src:local(\"Montserrat ExtraBold \"),local(\"Montserrat-ExtraBold\"),url(" + __webpack_require__(20) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(137) + ") format(\"woff2\"),url(" + __webpack_require__(136) + ") format(\"woff\"),url(" + __webpack_require__(80) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:italic;font-weight:600;src:url(" + __webpack_require__(17) + ");src:local(\"Montserrat SemiBold italic\"),local(\"Montserrat-SemiBolditalic\"),url(" + __webpack_require__(17) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(131) + ") format(\"woff2\"),url(" + __webpack_require__(130) + ") format(\"woff\"),url(" + __webpack_require__(77) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:italic;font-weight:800;src:url(" + __webpack_require__(21) + ");src:local(\"Montserrat ExtraBold italic\"),local(\"Montserrat-ExtraBolditalic\"),url(" + __webpack_require__(21) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(139) + ") format(\"woff2\"),url(" + __webpack_require__(138) + ") format(\"woff\"),url(" + __webpack_require__(81) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:normal;font-weight:900;src:url(" + __webpack_require__(22) + ");src:local(\"Montserrat Black \"),local(\"Montserrat-Black\"),url(" + __webpack_require__(22) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(141) + ") format(\"woff2\"),url(" + __webpack_require__(140) + ") format(\"woff\"),url(" + __webpack_require__(82) + "#montserrat) format(\"svg\")}@font-face{font-family:Montserrat;font-style:italic;font-weight:900;src:url(" + __webpack_require__(23) + ");src:local(\"Montserrat Black italic\"),local(\"Montserrat-Blackitalic\"),url(" + __webpack_require__(23) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(143) + ") format(\"woff2\"),url(" + __webpack_require__(142) + ") format(\"woff\"),url(" + __webpack_require__(83) + "#montserrat) format(\"svg\")}", ""]);

// exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "@font-face{font-family:Roboto;font-style:italic;font-weight:100;src:url(" + __webpack_require__(25) + ");src:local(\"Roboto Thin italic\"),local(\"Roboto-Thinitalic\"),url(" + __webpack_require__(25) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(147) + ") format(\"woff2\"),url(" + __webpack_require__(146) + ") format(\"woff\"),url(" + __webpack_require__(85) + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:300;src:url(" + __webpack_require__(26) + ");src:local(\"Roboto Light \"),local(\"Roboto-Light\"),url(" + __webpack_require__(26) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(149) + ") format(\"woff2\"),url(" + __webpack_require__(148) + ") format(\"woff\"),url(" + __webpack_require__(86) + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:italic;font-weight:300;src:url(" + __webpack_require__(27) + ");src:local(\"Roboto Light italic\"),local(\"Roboto-Lightitalic\"),url(" + __webpack_require__(27) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(151) + ") format(\"woff2\"),url(" + __webpack_require__(150) + ") format(\"woff\"),url(" + __webpack_require__(87) + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:400;src:url(" + __webpack_require__(28) + ");src:local(\"Roboto Regular \"),local(\"Roboto-Regular\"),url(" + __webpack_require__(28) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(153) + ") format(\"woff2\"),url(" + __webpack_require__(152) + ") format(\"woff\"),url(" + __webpack_require__(88) + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:italic;font-weight:400;src:url(" + __webpack_require__(29) + ");src:local(\"Roboto Regular italic\"),local(\"Roboto-Regularitalic\"),url(" + __webpack_require__(29) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(155) + ") format(\"woff2\"),url(" + __webpack_require__(154) + ") format(\"woff\"),url(" + __webpack_require__(89) + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:500;src:url(" + __webpack_require__(30) + ");src:local(\"Roboto Medium \"),local(\"Roboto-Medium\"),url(" + __webpack_require__(30) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(157) + ") format(\"woff2\"),url(" + __webpack_require__(156) + ") format(\"woff\"),url(" + __webpack_require__(90) + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:italic;font-weight:500;src:url(" + __webpack_require__(31) + ");src:local(\"Roboto Medium italic\"),local(\"Roboto-Mediumitalic\"),url(" + __webpack_require__(31) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(159) + ") format(\"woff2\"),url(" + __webpack_require__(158) + ") format(\"woff\"),url(" + __webpack_require__(91) + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:700;src:url(" + __webpack_require__(32) + ");src:local(\"Roboto Bold \"),local(\"Roboto-Bold\"),url(" + __webpack_require__(32) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(161) + ") format(\"woff2\"),url(" + __webpack_require__(160) + ") format(\"woff\"),url(" + __webpack_require__(92) + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:italic;font-weight:700;src:url(" + __webpack_require__(33) + ");src:local(\"Roboto Bold italic\"),local(\"Roboto-Bolditalic\"),url(" + __webpack_require__(33) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(163) + ") format(\"woff2\"),url(" + __webpack_require__(162) + ") format(\"woff\"),url(" + __webpack_require__(93) + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:900;src:url(" + __webpack_require__(34) + ");src:local(\"Roboto Black \"),local(\"Roboto-Black\"),url(" + __webpack_require__(34) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(165) + ") format(\"woff2\"),url(" + __webpack_require__(164) + ") format(\"woff\"),url(" + __webpack_require__(94) + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:italic;font-weight:900;src:url(" + __webpack_require__(35) + ");src:local(\"Roboto Black italic\"),local(\"Roboto-Blackitalic\"),url(" + __webpack_require__(35) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(167) + ") format(\"woff2\"),url(" + __webpack_require__(166) + ") format(\"woff\"),url(" + __webpack_require__(95) + "#roboto) format(\"svg\")}@font-face{font-family:Roboto;font-style:normal;font-weight:100;src:url(" + __webpack_require__(24) + ");src:local(\"Roboto Thin \"),local(\"Roboto-Thin\"),url(" + __webpack_require__(24) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(145) + ") format(\"woff2\"),url(" + __webpack_require__(144) + ") format(\"woff\"),url(" + __webpack_require__(84) + "#roboto) format(\"svg\")}", ""]);

// exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "*,:after,:before{box-sizing:border-box}html{overflow-y:auto}body,html{height:100%}body{color:#333;font-family:Roboto,sans-serif;margin:0}h1,h2,h3,h5{font-family:Montserrat,sans-serif;text-transform:uppercase;font-weight:600;padding:0 15px}p{line-height:1.5}p a{color:inherit;cursor:pointer}strong a{font-weight:600}#app{display:flex;height:100%;flex-direction:column}", ""]);

// exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, ".alp-button{background:#fff;border:0;border-radius:8px;color:#23b9d0;display:inline-block;font-family:Source Sans Pro,sans-serif;font-size:24px;font-weight:600;text-decoration:none;padding:15px 20px}.alp-button--blued{background-color:#23b9d0;color:#fff}.alp-button--shadowed{box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}", ""]);

// exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, ".alp-big-theme-wrapper{text-decoration:none;overflow:hidden;position:relative}.alp-big-theme{background-size:cover;background-position:50%;height:100%;min-height:100%;transition:transform .1s ease-out}.alp-big-theme:not(.alp-big-theme--no-hover):hover{transform:scale(1.05);transition:transform .1s ease-in}.alp-big-theme:not(.alp-big-theme--no-hover):hover .alp-big-theme__shadow{background-color:rgba(0,0,0,.4);transition:background-color .1s ease-in}.alp-big-theme--no-hover{background-position:50%}.alp-big-theme--no-hover>.alp-big-theme__shadow{font-size:28px;height:130px}.alp-big-theme__shadow{align-items:center;background-color:rgba(0,0,0,.5);color:#fff;cursor:pointer;display:flex;font-family:Montserrat,sans-serif;font-size:20px;font-weight:600;height:300px;justify-content:center;text-transform:uppercase;transition:background-color .1s ease-out}.alp-big-theme__shadow__back{background-color:#fff;border-radius:50%;box-shadow:0 2px 4px 0 rgba(0,0,0,.5);cursor:pointer;height:48px;left:40px;position:absolute;top:50%;transform:translateY(-50%);width:48px}@media (max-width:768px){.alp-big-theme__shadow{height:300px}.alp-big-theme__shadow__back{left:50%;top:100%;transform:translate(-50%,-50%);z-index:2}.alp-big-theme--no-hover>.alp-big-theme__shadow{font-size:24px}.alp-big-theme-wrapper{overflow:visible}}", ""]);

// exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, ".alp-tag{background:#c9462c;border-radius:3px;border:1px solid hsla(0,0%,100%,.5);color:#fff;display:inline-block;font-family:Montserrat,sans-serif;font-size:16px;font-weight:600;padding:5px 10px;transform:rotate(-5deg)}", ""]);

// exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, ".alp-home__title{color:#23b9d0;font-size:36px;font-weight:600;margin:80px 0 30px;text-align:center}.alp-home__title__red{color:#c9462c}.alp-home__intro{color:#222;font-size:18px;margin:0 auto;max-width:700px;padding:30px 10px;text-align:justify}.alp-home__choose{color:#23b9d0;margin:0 auto;max-width:700px;text-align:center;text-transform:uppercase}.alp-home__intro__red{color:#c9462c;font-weight:600}.alp-home__icon{display:block;margin:20px auto}.alp-home__themes{margin:80px auto 30px;max-width:1200px;text-align:center;padding:0 10px;overflow:auto;zoom:1}.alp-home__themes .alp-big-theme-wrapper{float:left;display:block;margin-bottom:10px;width:calc(33.3333333% - 6.666666666666667px)}.alp-home__themes .alp-big-theme-wrapper:not(:nth-child(3n)){margin-right:10px}.alp-home__footer{background:#ededed;color:#444;padding:10px}@media (max-width:768px){.alp-home__themes{flex-direction:column;height:900px}.alp-home__themes .alp-big-theme-wrapper{width:100%}.alp-home__themes .alp-big-theme-wrapper:not(:nth-child(3n)){margin-right:0}}", ""]);

// exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, ".alp-header{background:#c9462c;border-bottom:1px solid #bc4229;box-shadow:0 2px 4px rgba(0,0,0,.2);height:54px;padding:8px 20px;position:relative}.alp-header__logo{background:url(" + __webpack_require__(101) + ") 50% no-repeat;background-size:cover;display:inline-block;height:36px;text-indent:-9999px;vertical-align:middle;width:132px}.alp-header__nav{display:inline-block;margin-left:20px}.alp-header__nav a{color:#fff;font-family:Montserrat,serif;font-size:14px;line-height:36px;margin:0 6px;text-decoration:none;text-shadow:0 1px 2px rgba(0,0,0,.4)}.alp-header__title{color:#fff;display:none;left:50%;margin:0;position:absolute;top:50%;transform:translate(-50%,-50%)}.alp-header__title a{color:#fff;text-decoration:none}.alp--on-theme .alp-header__title{display:block}.alp--on-theme .a-home-links,.alp-header__nav>a:first-child{display:none}.alp--on-theme .alp-header__nav>a:first-child{display:block}@media (max-width:768px){.alp-header__nav{display:none}}", ""]);

// exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, ".alp-card{box-shadow:0 2px 4px 0 rgba(0,0,0,.5);max-width:800px;padding:20px}@media (max-width:810px){.alp-card{margin-left:10px!important;margin-right:10px!important}}", ""]);

// exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, ".alp-theme{background:#fbfbfb}.alp-theme--writing{display:flex;flex-direction:column;flex:1}.alp-theme__header{display:flex;height:130px}.alp-theme__header .alp-big-theme-wrapper{flex:1}.alp-theme__header .alp-big-theme__shadow{cursor:default}.alp-theme__writing{flex:1;padding:30px 0;text-align:center}.alp-theme__writing h3{color:#23b9d0}.alp-theme__writing p{text-align:center}.alp-theme__sublinks{margin:40px 0}.alp-theme__sublinks__buttons{display:flex;flex-wrap:wrap;margin:0 auto;max-width:800px;padding:0 10px}.alp-theme__sublinks__buttons>.alp-button-wrapper{margin-top:10px}.alp-theme__sublinks__buttons>.alp-button-wrapper>.alp-button{border-radius:6px;font-size:18px;padding:10px 15px}.alp-theme__sublinks__buttons>.alp-button-wrapper:not(:last-child){margin-right:10px}.alp-theme__intro{font-size:18px;margin:60px auto 30px;max-width:800px;padding:0 10px;text-align:justify}.alp-theme__intro a{color:#23b9d0}.alp-theme__fi>.alp-card,.alp-theme__fn>.alp-card{margin:0 auto 40px}.alp-theme__fi__title,.alp-theme__fn__title{margin:0;padding:0}.alp-theme__fn__title__blue{color:#23b9d0}.alp-theme__fn__proposals{font-size:18px}.alp-theme__fi .alp-tag{margin-left:10px}.alp-theme__fi__proposals{font-size:18px;text-align:justify}.alp-theme__fi-proposals{margin:0 auto 50px;max-width:800px}.alp-theme__fi-proposals__title{font-size:24px;color:#c9462c}.alp-theme__fi__aec{float:right;margin-bottom:1px;margin-left:15px;margin-top:-30px}.alp-theme__fi-proposals__proposal{font-size:18px;padding:0 10px;text-align:justify}.alp-theme__fi-proposals__proposal strong{color:#23b9d0;font-weight:600}.alp-theme__fi-proposals__proposal:not(:first-child){margin-top:10px}.alp-theme__more{background:#c9462c;box-shadow:inset 0 5px 10px 0 rgba(0,0,0,.2);padding:10px 30px 30px}.alp-theme__more__title{color:#fff;text-align:center}.alp-theme__more__buttons{display:flex;justify-content:center;margin:0 auto;max-width:800px}", ""]);

// exports


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-100.svg?2e95991f47cb11fa0f90155cde7145cd";

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-100italic.svg?c62abb675730a451d19f47f24f5425dc";

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-200.svg?300ee5f89e3ce7f2eca0291bb48c5ff6";

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-200italic.svg?3a2afc11ae52e436e28f82d7c169db45";

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-300.svg?b45e2b2fa43b5b10dbe4f1490e45261b";

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-300italic.svg?26aacd289eec044d31f88c44297f54ba";

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-400.svg?8ebd6e279bdebe637550c059ff43a0b8";

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-400italic.svg?08e99a9b170b60eabfb9ccfe19619f45";

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-500.svg?d5c1d1caaceda4f0a32d9d2612632df6";

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-500italic.svg?feb994281eaadd007a3cbb94adf20f60";

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-600.svg?e191570672926bc15d59883e57649ff7";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-600italic.svg?996d2512fdf5a4708499ebc5df282d92";

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-700.svg?21c945dee39e064e77a151c1052d1215";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-700italic.svg?321eced1ed63a24e07157ef8d0be72a7";

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-800.svg?6cbef7b359c0bb255d48a7baec506ed5";

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-800italic.svg?93173b4fa0330b6533fffd81129b648c";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-900.svg?8431076a8c6d3b549562f31d47db154a";

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "/dist/montserrat-latin-900italic.svg?7be6a85fe946f113dc84f0e3692cafdd";

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-100.svg?3b8bb2030a46cdcf1bf4d739702d1bb9";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-100italic.svg?4bec22c5d731c1ab60d99a1a07348250";

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-300.svg?1edaa6e50c2302bf0221d252e1caebb4";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-300italic.svg?290e6a6c01f4703f351415432980aa2f";

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-400.svg?3d3a53586bd78d1069ae4b89a3b9aa98";

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-400italic.svg?13fb9544bc459a2351bbcf844f5763d8";

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-500.svg?f1d811cdfaea49c969500d4bbe52251b";

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-500italic.svg?084d5c434250ba4b6aaa634908eb4b15";

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-700.svg?7f57c4c0f3b44acbe338d7ff6d6ee5b1";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-700italic.svg?bf39ef96a254805657605c016263db25";

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-900.svg?e43f0ef2eed55dc9e390c5032255e6f4";

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "/dist/roboto-latin-900italic.svg?258ac0302f36811f0c9e2230ce8d3f78";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "/dist/aec.png?0cefef89579a82d847ca9f0a3931c202";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "/dist/arrow.down.png?803a8019f2fc0fb968e077b26623f95b";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "/dist/arrow.left.png?57db66bca0211fc6078a99e0c66c4694";

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "/dist/economie-finance.jpg?9e3529b0ae670f2e5f984a0d13887fb1";

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "/dist/immigration-laicite.jpg?813a4342236513806f9133e9ff5efe22";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "/dist/logo.png?894fcd621818a0f0998fc31b11de3afe";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "/dist/politique-internationale.jpg?2c74ec28c6d2438420194bd0b2fbdd2a";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "/dist/progres-humain.jpg?1da39a3d2a68a96096c9d5e74353b520";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "/dist/securite-justice-defense.jpg?b2deb936829284e24df269a010829cca";

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "/dist/urgence-democratique.jpg?9581ab8e66effb2c5ab98d3d56a2ff75";

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "/dist/urgence-ecologique.jpg?f27559864ef30ff3b58e007f235c1da0";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "/dist/urgence-sociale.jpg?20e7f1d89d8d563e0df8eb342a4a9181";

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = "/dist/5e334eff013f12fbb8ed72c2a253f119.woff";

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "/dist/50d279861fb3cbfed809eae6ed8b9ac9.woff2";

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "/dist/03e19243272affe738654a157625ec26.woff";

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = "/dist/68f2c9aa62fcbcd7b094bea0497dee73.woff2";

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = "/dist/f2022ecd65a0703ec3edcb7641709a75.woff";

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = "/dist/4343d3d91a9446226e7a8bbb024111ad.woff2";

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = "/dist/89614a6008fc5c60739012463d0ee7e6.woff";

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = "/dist/116c4c4b14ef76b0555da09854512022.woff2";

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = "/dist/3a371ee0d175f5c2b15ce1d6b981dc4e.woff";

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = "/dist/d2ad295b60682a6537c358e06ea80c61.woff2";

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = "/dist/16521668f5f238098329cdd7d27c391e.woff";

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = "/dist/f6b6bf2431003f8142e800f9df157989.woff2";

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = "/dist/b20cc131034316b1c85d0498fb9ed5c5.woff";

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "/dist/240a84447b78da0920fcb07e378f2c5f.woff2";

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = "/dist/9405e78785a55cf0e4ea7669d4616ea9.woff";

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = "/dist/86172bb829de6be08b92512096b6aca6.woff2";

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = "/dist/50825d47af7ae47e055018eb689c6c99.woff";

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = "/dist/fb8d6b71dbe8d9294be43082936f649e.woff2";

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = "/dist/635de59c4be86285b1f70068c95b9816.woff";

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = "/dist/c0a555a4f8e997385a3eebbd4da0b9ee.woff2";

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = "/dist/f300da4fb4fe00e23915f62b2c643681.woff";

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = "/dist/d5615136a08cfee70deb4be1ee1651df.woff2";

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = "/dist/2bc37d86a4ba12ce526c4af904a9946e.woff";

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = "/dist/10f29d139edacde92df63374c5672568.woff2";

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = "/dist/81826529772e52f0f14a4c73c2f2c7f1.woff";

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = "/dist/7d77e1f03eefc452dab14d7f89080083.woff2";

/***/ }),
/* 134 */
/***/ (function(module, exports) {

module.exports = "/dist/c162d257f5e9f9b108a96a604cfb2132.woff";

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = "/dist/1dd2b53f1567a29e0505de9b27c4352c.woff2";

/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = "/dist/895aadbff357be35ac8dd107c7975ee7.woff";

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = "/dist/d4e7bf86bbd8e5f43ca73fa831218648.woff2";

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = "/dist/b3362875067300abedb7a8fb97903258.woff";

/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = "/dist/fc0cbe442f7b3733c91e982e825c4daa.woff2";

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = "/dist/1b99ef78e627dd9bbd0ca4b5c0789547.woff";

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = "/dist/c8bdd772c0d1347720ff7e3fb72719f3.woff2";

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = "/dist/b78bb9f8ecec6c5a924c873f1818095f.woff";

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = "/dist/cb72c1f90f66c124fb897a75bec64c78.woff2";

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = "/dist/654cb4d3907ce76ae06546007e658318.woff";

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = "/dist/8ce598834dcde808ae5a52930d2f198c.woff2";

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = "/dist/42de89835eafdcf69210bb254061b4e9.woff";

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = "/dist/acee0ea9a8fefc488c5ba3f0cea449c2.woff2";

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = "/dist/ecce92d0b0ff17197f29e7db6397bf0a.woff";

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = "/dist/16ddb1541046ada9b90cacf4adec839a.woff2";

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = "/dist/4d08daebc07fbef23449c61e4ba59fed.woff";

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = "/dist/3ddb74822e003b3b41232aa6e64d656b.woff2";

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = "/dist/16e1d930cf13fb7a956372044b6d02d0.woff";

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = "/dist/7e367be02cd17a96d513ab74846bafb3.woff2";

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = "/dist/1e65e7e4eaaa9cda89cdf3860e41a401.woff";

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = "/dist/984ae3788bccf682cc5eaaf9398a41ef.woff2";

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = "/dist/57af64fc644194101c1593abea164433.woff";

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = "/dist/bb474f16c9f76f522d656d66aa4a220e.woff2";

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = "/dist/b670694ba39f55b5ab9b6022eb09d9ef.woff";

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = "/dist/9e7beee5510fcd9cbc4dd37f2c721f14.woff2";

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = "/dist/525d5b452809b3172a2a34e26d9db546.woff";

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = "/dist/0d7e71f2b5cc1ddab837f72e1fe52f3f.woff2";

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = "/dist/ad0e74fca35d6766929fd91189a201ef.woff";

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = "/dist/7394ca9f8315fedfec68ab850157122b.woff2";

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = "/dist/de984c02ef9e756eceb2afbb2257425a.woff";

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = "/dist/f4e8dc5995b7b64c394f30df27a83612.woff2";

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = "/dist/3b9590e03f8940b592cce06bac81eaeb.woff";

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports = "/dist/4faec832c91a7732ce67680e1492238e.woff2";

/***/ }),
/* 168 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 169 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 170 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(182),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(181),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(180),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(183),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('alp-header'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alp-button-wrapper"
  }, [(_vm.link) ? _c('router-link', {
    class: _vm.classes,
    attrs: {
      "to": _vm.link
    }
  }, [_vm._t("default")], 2) : (_vm.href) ? _c('a', {
    class: _vm.classes,
    attrs: {
      "href": _vm.href
    }
  }, [_vm._t("default")], 2) : _c('button', {
    class: _vm.classes
  }, [_vm._t("default")], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.link) ? _c('router-link', {
    staticClass: "alp-big-theme-wrapper",
    attrs: {
      "to": _vm.to
    }
  }, [_c('div', {
    staticClass: "alp-big-theme",
    style: (_vm.backgroundImage)
  }, [_c('div', {
    staticClass: "alp-big-theme__shadow"
  }, [_vm._t("default")], 2)])]) : _c('div', {
    staticClass: "alp-big-theme-wrapper"
  }, [_c('div', {
    staticClass: "alp-big-theme alp-big-theme--no-hover",
    style: (_vm.backgroundImage)
  }, [_c('div', {
    staticClass: "alp-big-theme__shadow"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "alp-big-theme__shadow__back",
    on: {
      "click": function($event) {
        _vm.$router.push('/')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(98),
      "alt": "left arrow"
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alp-tag",
    style: (_vm.color)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "alp-home"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('img', {
    staticClass: "alp-home__icon",
    attrs: {
      "src": __webpack_require__(97),
      "alt": "arrow down",
      "height": "24",
      "width": "24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "alp-home__themes"
  }, _vm._l((_vm.themes), function(theme) {
    return _c('alp-big-theme', {
      key: "theme.slug",
      attrs: {
        "link": _vm.getLink(theme),
        "image": theme.slug
      }
    }, [_vm._v(_vm._s(theme.title))])
  })), _vm._v(" "), _c('div', {
    staticClass: "alp-home__footer"
  }, [_vm._v("\n    Site à l'initiative de citoyens insoumis.\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "alp-home__title"
  }, [_vm._v("\n    Analysons le projet du "), _c('span', {
    staticClass: "alp-home__title__red"
  }, [_vm._v("Front National")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alp-home__intro"
  }, [_vm._v("\n    Les rapprochements et amalgames entre le programme de la France Insoumise et celui du Front National ont été très nombreux et très virulents. Pourtant, "), _c('strong', [_vm._v("aucune analyse sérieuse et critique des propositions de Marine Le Pen")]), _vm._v(" n'a été vraiment réalisée pour tenter de les confronter à celles portées par Jean-Luc Mélenchon.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n    Le Discord Insoumis propose donc une analyse des propositions du Front National à travers plusieurs thèmes. Cette analyse est bien évidemment très critique car le projet de société de Marine Le Pen est non seulement à l'opposé de celui de la France Insoumise mais il présente de nombreuses incohérences.\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n    Ce site a pour objectif d'être "), _c('strong', [_vm._v("une source de réflexion")]), _vm._v(" pour favoriser l'esprit critique de la population autour du projet mortifère du Front National. C'est un espace en développement permanent qui sera enrichi au fil des prochaines semaines.\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "alp-home__choose"
  }, [_vm._v("\n    Sélectionnez un thème pour analyser le projet du\n    "), _c('span', {
    staticClass: "alp-home__intro__red"
  }, [_vm._v("Front National")])])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "alp-header",
    on: {
      "click": _vm.goBack
    }
  }, [_c('a', {
    staticClass: "alp-header__logo",
    attrs: {
      "href": "http://discord-insoumis.fr/",
      "target": "_blank"
    }
  }, [_vm._v("Discord Insoumis")]), _vm._v(" "), _c('nav', {
    staticClass: "alp-header__nav"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n      Analysons Le FN\n    ")]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "a-home-links"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://lafranceinsoumise.fr/",
      "title": "Site de la France Insoumise"
    }
  }, [_vm._v("lafranceinsoumise.fr")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://laec.fr/",
      "title": "Programme de Mélenchon pour la France Insoumise"
    }
  }, [_vm._v("Consultez le programme")])])
}]}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alp-card",
    style: (_vm.backgroundColor)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.themeClasses
  }, [_c('div', {
    staticClass: "alp-theme__header"
  }, [_c('alp-big-theme', {
    attrs: {
      "image": _vm.theme.slug
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), (_vm.isWriting) ? _c('div', {
    staticClass: "alp-theme__writing"
  }, [_c('h2', [_vm._v("Thème en cours de rédaction")]), _vm._v(" "), _c('p', {
    staticClass: "alp-theme__intro"
  }, [_vm._v("\n      Ce thème est actuellement en cours de rédaction.\n    ")])]) : _vm._e(), _vm._v(" "), (!_vm.isWriting) ? _c('p', {
    staticClass: "alp-theme__intro",
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theme.relatives && !_vm.isWriting) ? _c('div', {
    staticClass: "alp-theme__sublinks"
  }, [_c('div', {
    staticClass: "alp-theme__sublinks__buttons"
  }, _vm._l((_vm.theme.relatives), function(rel) {
    return _c('alp-button', {
      key: "rel.link",
      attrs: {
        "blue": rel.title === _vm.theme.title,
        "shadow": true,
        "link": rel.link
      }
    }, [_vm._v(_vm._s(rel.title))])
  }))]) : _vm._e(), _vm._v(" "), (!_vm.isWriting) ? _c('div', {
    staticClass: "alp-theme__fn"
  }, [_c('alp-card', [_c('h2', {
    staticClass: "alp-theme__fn__title"
  }, [_vm._v("\n        Quelques propositions du\n        "), _c('span', {
    staticClass: "alp-theme__fn__title__blue"
  }, [_vm._v("Front National")])]), _vm._v(" "), _c('p', {
    staticClass: "alp-theme__fn__proposals",
    domProps: {
      "innerHTML": _vm._s(_vm.theme.fn)
    }
  })])], 1) : _vm._e(), _vm._v(" "), (!_vm.isWriting) ? _c('div', {
    staticClass: "alp-theme__fi"
  }, [_c('alp-card', {
    attrs: {
      "background": "blue"
    }
  }, [_c('h2', {
    staticClass: "alp-theme__fi__title"
  }, [_vm._v("\n        L'analyse de la France Insoumise\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "alp-theme__fi__proposals",
    domProps: {
      "innerHTML": _vm._s(_vm.theme.fi)
    }
  }), _vm._v(" "), (_vm.theme.badge) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.theme.badge) ? _c('strong', [_vm._v("Conclusion : "), _c('alp-tag', {
    attrs: {
      "theme": _vm.theme.badge.color
    }
  }, [_vm._v(_vm._s(_vm.theme.badge.text))])], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.isWriting) ? _c('div', {
    staticClass: "alp-theme__fi-proposals"
  }, [_c('h2', {
    staticClass: "alp-theme__fi-proposals__title"
  }, [_vm._v("Les propositions de l’Avenir en Commun")]), _vm._v(" "), _c('img', {
    staticClass: "alp-theme__fi__aec",
    attrs: {
      "src": __webpack_require__(96),
      "alt": "Ce qu'en dit l'Avenir en Commun",
      "height": "160",
      "width": "160"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "alp-theme__fi-proposals__proposal",
    domProps: {
      "innerHTML": _vm._s(_vm.theme.aec)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "alp-theme__more"
  }, [_c('h2', {
    staticClass: "alp-theme__more__title"
  }, [_vm._v("Envie d'en savoir plus ?")]), _vm._v(" "), _c('div', {
    staticClass: "alp-theme__more__buttons"
  }, [_c('alp-button', {
    attrs: {
      "href": "https://laec.fr"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n          Consulter"), _c('br'), _vm._v("\n          L'Avenir en Commun\n        ")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.5.3
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also regiseter instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    data.props = resolveProps(route, matched.props && matched.props[name]);

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var val = extraQuery[key];
    parsedQuery[key] = Array.isArray(val) ? val.slice() : val;
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.slice().forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;
  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: location.query || {},
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) { return String(a[key]) === String(b[key]); })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed) { return }
  install.installed = true;

  _Vue = Vue;

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this.$root._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this.$root._route }
  });

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var index$1 = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var index = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (index$1(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!index$1(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!index$1(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (index$1(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

index.parse = parse_1;
index.compile = compile_1;
index.tokensToFunction = tokensToFunction_1;
index.tokensToRegExp = tokensToRegExp_1;

/*  */

var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = index.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  var pathMap = oldPathMap || Object.create(null);
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var normalizedPath = normalizePath(path, parent);
  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    if (Array.isArray(route.alias)) {
      route.alias.forEach(function (alias) {
        var aliasRoute = {
          path: alias,
          children: route.children
        };
        addRouteRecord(pathList, pathMap, nameMap, aliasRoute, parent, record.path);
      });
    } else {
      var aliasRoute = {
        path: route.alias,
        children: route.children
      };
      addRouteRecord(pathList, pathMap, nameMap, aliasRoute, parent, record.path);
    }
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path) {
  var regex = index(path);
  if (false) {
    var keys = {};
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent) {
  path = path.replace(/\/$/, '');
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);
    if (!shouldScroll) {
      return
    }
    var isObject = typeof shouldScroll === 'object';
    if (isObject && typeof shouldScroll.selector === 'string') {
      var el = document.querySelector(shouldScroll.selector);
      if (el) {
        position = getElementPosition(el);
      } else if (isValidPosition(shouldScroll)) {
        position = normalizePosition(shouldScroll);
      }
    } else if (isObject && isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }

    if (position) {
      window.scrollTo(position.x, position.y);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left,
    y: elRect.top - docRect.top
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    if (called) { return }
    called = true;
    return fn.apply(this, arguments)
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    window.addEventListener('popstate', function (e) {
      this$1.transitionTo(getLocation(this$1.base), function (route) {
        if (expectScroll) {
          handleScroll(router, route, this$1.current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    window.addEventListener('hashchange', function () {
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        replaceHash(route.fullPath);
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function pushHash (path) {
  window.location.hash = path;
}

function replaceHash (path) {
  var i = window.location.href.indexOf('#');
  window.location.replace(
    window.location.href.slice(0, i >= 0 ? i : 0) + '#' + path
  );
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: {} };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.5.3';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(58);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1a67609f", content, true);

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(59);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("6659b97e", content, true);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(60);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0a816e96", content, true);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(61);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("2239690a", content, true);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(62);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("161911cc", content, true);

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(63);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("00e79910", content, true);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(64);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("58283a86", content, true);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(65);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("02a8798b", content, true);

/***/ }),
/* 193 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./economie-finance.jpg": 99,
	"./immigration-laicite.jpg": 100,
	"./politique-internationale.jpg": 102,
	"./progres-humain.jpg": 103,
	"./securite-justice-defense.jpg": 104,
	"./urgence-democratique.jpg": 105,
	"./urgence-ecologique.jpg": 106,
	"./urgence-sociale.jpg": 107
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js